import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  PreciseDateTime: { input: string; output: string; }
  ReleaseType: { input: any; output: any; }
};

export type AccessCode = {
  __typename?: 'AccessCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
};

export type AccessCodeInput = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  label: InputMaybe<Scalars['String']['input']>;
};

/** Access group for a question */
export enum AccessGroup {
  Restricted = 'RESTRICTED',
  Subject = 'SUBJECT',
  University = 'UNIVERSITY'
}

/** Access role for a question */
export enum AccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/**
 * Gradebook result access summary describing the last access to a unique
 * external service via the result.
 */
export type AccessSummary = {
  __typename?: 'AccessSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  service: GradebookService;
};

export type AddQuestionBanksToAssessmentInput = {
  filter: QuestionBankFilterInput;
  questionBankNodes: Array<QuestionBankNodes>;
};

/** A representation of an answer to a question block */
export type AnswerBlock = {
  __typename?: 'AnswerBlock';
  /** Attachments to this answer block */
  blockAttachments: Array<BlockAttachment>;
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Bookmarked by the student. */
  bookmark: Maybe<Scalars['Boolean']['output']>;
  /** Explicit student confirmation on completed attempt */
  confirm: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestBlockSnapshot: Maybe<BlockSnapshot>;
  /** Tree layout node ID for the block */
  nodeId: Scalars['ID']['output'];
  /** Numeric ordering */
  order: Maybe<Scalars['Int']['output']>;
  /** Labelled ordering */
  orderLabel: Maybe<Scalars['String']['output']>;
  /** Tree layout parent node ID for this block */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this answer. */
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout previous node ID for this block */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Question being answered by the Answer block */
  question: Maybe<Question>;
  /** Question ID that this Answer is answering */
  questionId: Maybe<Scalars['ID']['output']>;
  /** Shuffle answer options */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  /** Skipped by the student. */
  skip: Maybe<Scalars['Boolean']['output']>;
};

/** API status information */
export type ApiStatusType = {
  __typename?: 'ApiStatusType';
  hasBrightspaceApi: Scalars['Boolean']['output'];
  hasCanvasApi: Scalars['Boolean']['output'];
};

/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type Assessment = {
  __typename?: 'Assessment';
  /** Submission due date for on-time submissions, set in the LMS. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Assessment cut-off date, set in the LMS. */
  endDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Grading reminder date, set in the LMS. */
  gradingDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Predicate checking if at least 1 save has been made in the Assessment. */
  hasSave: Scalars['Boolean']['output'];
  /** Predicate checking if at least 1 submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** LTI Custom Parameters from source LMS. */
  ltiCustomParams: Maybe<CustomParams>;
  /** All the LTI 1.1 and 1.3 services recorded for this Assessment. */
  ltiServices: Array<LtiService>;
  /** Institutions LMS Tool Provider used to launch this Assessment. */
  ltiTool: InstitutionTool;
  name: Scalars['String']['output'];
  /** Assessment wide settings. */
  settings: Maybe<AssessmentSettings>;
  /** Assessment submission start date set in the LMS. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  /** @deprecated Use the subject name from subject.name instead */
  subjectName: Scalars['String']['output'];
};


/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type AssessmentSubjectArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};

/** Settings for an Assessment */
export type AssessmentSettings = {
  __typename?: 'AssessmentSettings';
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  doubleBlindMarkingEnabled: Scalars['Boolean']['output'];
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  draftEnabled: Scalars['Boolean']['output'];
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examAccessCodeEnabled: Scalars['Boolean']['output'];
  examAutoSubmissionDisabled: Scalars['Boolean']['output'];
  examBacktrackDisabled: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examLdbEnabled: Scalars['Boolean']['output'];
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examReadingTimeDisabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  feedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  feedbackDateDisabled: Scalars['Boolean']['output'];
  groupAssessmentEnabled: Scalars['Boolean']['output'];
  groupCharterDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupCharterEnabled: Scalars['Boolean']['output'];
  groupDraftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupDraftEnabled: Scalars['Boolean']['output'];
  groupFinalised: Scalars['Boolean']['output'];
  groupHideMembersName: Scalars['Boolean']['output'];
  groupReportMaxGrade: Maybe<Scalars['Int']['output']>;
  groupReportWeight: Maybe<Scalars['Int']['output']>;
  groupSelfEnrollmentDeadline: Maybe<Scalars['PreciseDateTime']['output']>;
  groupSelfEnrollmentEnabled: Scalars['Boolean']['output'];
  groupWorkAttachmentEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  individualReportDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  individualReportEnabled: Scalars['Boolean']['output'];
  individualReportMaxGrade: Maybe<Scalars['Int']['output']>;
  individualReportWeight: Maybe<Scalars['Int']['output']>;
  individualWorkAttachmentEnabled: Scalars['Boolean']['output'];
  lateResubmissionEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use `late_submission_time_limit` instead */
  lateResubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  markingAclEnabled: Scalars['Boolean']['output'];
  markingTool: Maybe<MarkingTool>;
  markingToolPdf: Maybe<MarkingToolPdf>;
  maxGrade: Scalars['Int']['output'];
  openDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationEnabled: Scalars['Boolean']['output'];
  peerEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  peerEvaluationWeight: Maybe<Scalars['Int']['output']>;
  referencingStyle: Maybe<Scalars['String']['output']>;
  referencingStyleEnabled: Scalars['Boolean']['output'];
  releaseDate: Maybe<Scalars['PreciseDateTime']['output']>;
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  selfEvaluationEnabled: Scalars['Boolean']['output'];
  selfEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  selfEvaluationWeight: Maybe<Scalars['Int']['output']>;
  sentimentCheckEnabled: Scalars['Boolean']['output'];
  sentimentCheckIntervalInHr: Maybe<Scalars['Int']['output']>;
  smartAutomarkingEnabled: Scalars['Boolean']['output'];
  spellCheckDisabled: Scalars['Boolean']['output'];
  /** @deprecated Use `openDate` instead */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionPdfDisabled: Scalars['Boolean']['output'];
  tiiDraftSViewReports: Scalars['Int']['output'];
  tiiSViewReports: Scalars['Int']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  timeLimitEnabled: Scalars['Boolean']['output'];
  weight: Maybe<Scalars['Float']['output']>;
  weightEnabled: Scalars['Boolean']['output'];
  wordLimit: Maybe<Scalars['Int']['output']>;
  wordLimitEnabled: Scalars['Boolean']['output'];
  wordLimitGroup: Maybe<Scalars['Int']['output']>;
};

export type AssessmentSettingsInput = {
  allowGenerativeAi: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType: InputMaybe<AssessmentType>;
  countFootnotes: InputMaybe<Scalars['Boolean']['input']>;
  countReferences: InputMaybe<Scalars['Boolean']['input']>;
  doubleBlindMarkingEnabled: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  draftEnabled: InputMaybe<Scalars['Boolean']['input']>;
  dueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examAccessCodeEnabled: InputMaybe<Scalars['Boolean']['input']>;
  examAutoSubmissionDisabled: InputMaybe<Scalars['Boolean']['input']>;
  examBacktrackDisabled: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examLdbEnabled: InputMaybe<Scalars['Boolean']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examReadingTimeDisabled: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming: InputMaybe<ExamTiming>;
  examType: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  feedbackDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  feedbackDateDisabled: InputMaybe<Scalars['Boolean']['input']>;
  groupAssessmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterDueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupCharterEnabled: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftDueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupDraftEnabled: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName: InputMaybe<Scalars['Boolean']['input']>;
  groupReportWeight: InputMaybe<Scalars['Int']['input']>;
  groupSelfEnrollmentDeadline: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupSelfEnrollmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  groupWorkAttachmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  individualReportDueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  individualReportEnabled: InputMaybe<Scalars['Boolean']['input']>;
  individualReportWeight: InputMaybe<Scalars['Int']['input']>;
  individualWorkAttachmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  lateResubmissionEnabled: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit: InputMaybe<Scalars['Int']['input']>;
  markingAclEnabled: InputMaybe<Scalars['Boolean']['input']>;
  markingTool: InputMaybe<MarkingTool>;
  maxGrade: InputMaybe<Scalars['Int']['input']>;
  peerEvaluationDueDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  peerEvaluationEnabled: InputMaybe<Scalars['Boolean']['input']>;
  peerEvaluationWeight: InputMaybe<Scalars['Int']['input']>;
  referencingStyle: InputMaybe<Scalars['String']['input']>;
  referencingStyleEnabled: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationEnabled: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationWeight: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckEnabled: InputMaybe<Scalars['Boolean']['input']>;
  sentimentCheckIntervalInHr: InputMaybe<Scalars['Int']['input']>;
  spellCheckDisabled: InputMaybe<Scalars['Boolean']['input']>;
  submissionPdfDisabled: InputMaybe<Scalars['Boolean']['input']>;
  tiiDraftSViewReports: InputMaybe<Scalars['Int']['input']>;
  tiiSViewReports: InputMaybe<Scalars['Int']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  timeLimitEnabled: InputMaybe<Scalars['Boolean']['input']>;
  weight: InputMaybe<Scalars['Float']['input']>;
  weightEnabled: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled: InputMaybe<Scalars['Boolean']['input']>;
  wordLimitGroup: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus assessments can be assignments or exams. */
export enum AssessmentType {
  Assignment = 'ASSIGNMENT',
  Exam = 'EXAM'
}

/** Automarking status of the field outcome */
export enum AutomarkStatus {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING'
}

/** A background job running in an Assessment. */
export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  id: Scalars['ID']['output'];
  kind: BackgroundJobKind;
  state: BackgroundJobState;
};

/** Known kinds of background jobs in an Assessment. */
export enum BackgroundJobKind {
  RosterSync = 'ROSTER_SYNC'
}

/** States of a background job. */
export enum BackgroundJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Executing = 'EXECUTING',
  Scheduled = 'SCHEDULED'
}

/** Base type of a response. Used to determine the type of response expected. */
export enum BaseType {
  Coords = 'coords',
  DirectedPair = 'directed_pair',
  Float = 'float',
  Identifier = 'identifier',
  Range = 'range',
  Record = 'record',
  String = 'string'
}

/** A single blank in a fill-in-the-blanks response. */
export type Blank = {
  __typename?: 'Blank';
  id: Scalars['String']['output'];
  phrases: Array<Scalars['String']['output']>;
};

export type BlanksInput = {
  id: Scalars['String']['input'];
  phrases: Array<Scalars['String']['input']>;
};

/** Response as a fill-in-the-blanks type. */
export type BlanksResponse = {
  __typename?: 'BlanksResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  matchBlanks: Array<Blank>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type BlanksResponseInput = {
  caseSensitive: InputMaybe<Scalars['Boolean']['input']>;
  matchBlanks: Array<BlanksInput>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity: InputMaybe<Scalars['Float']['input']>;
};

/** Block Attachment associated with an AnswerBlock */
export type BlockAttachment = {
  __typename?: 'BlockAttachment';
  fileExtension: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mediaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A snapshot of a block inside a work */
export type BlockSnapshot = {
  __typename?: 'BlockSnapshot';
  answerBlockId: Scalars['ID']['output'];
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Special ID for client side caching. Defaults to the actual ID */
  cacheId: Scalars['ID']['output'];
  /** Serialised Snapshot contents */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** Response as a binary choice. */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  isTrue: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanResponseInput = {
  isTrue: Scalars['Boolean']['input'];
};

/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApi = {
  __typename?: 'BrightspaceApi';
  /** Brightspace Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  groups: Array<BrightspaceGroup>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiAuthorizeUrlArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiGroupsArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};

/**
 * Brightspace OrgUnit object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/orgunit.html.
 */
export type BrightspaceGroup = {
  __typename?: 'BrightspaceGroup';
  code: Maybe<Scalars['String']['output']>;
  /** Brightspace Group ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  students: Maybe<Array<BrightspaceUser>>;
  totalStudents: Scalars['Int']['output'];
};

export enum BrightspaceScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting groups */
  GetGroups = 'GET_GROUPS'
}

/**
 * Brightspace User object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/user.html#User.
 */
export type BrightspaceUser = {
  __typename?: 'BrightspaceUser';
  /** Brightspace User ID. */
  id: Scalars['ID']['output'];
};

/** Return type for cancelRelease mutation. */
export type CancelReleasePayload = {
  __typename?: 'CancelReleasePayload';
  /** Latest state of the task. */
  task: Task;
};

/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApi = {
  __typename?: 'CanvasApi';
  /** Canvas Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  sections: Array<CanvasSection>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiAuthorizeUrlArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiSectionsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};

export enum CanvasScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting assignment overrides */
  GetAssignmentOverrides = 'GET_ASSIGNMENT_OVERRIDES',
  /** scope for getting section */
  GetSections = 'GET_SECTIONS'
}

/**
 * Canvas Section object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/sections.html.
 */
export type CanvasSection = {
  __typename?: 'CanvasSection';
  courseId: Scalars['ID']['output'];
  /** Canvas Section ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sisCourseId: Maybe<Scalars['ID']['output']>;
  students: Maybe<Array<CanvasUser>>;
  totalStudents: Scalars['Int']['output'];
};

/**
 * Canvas User object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/users.html#User.
 */
export type CanvasUser = {
  __typename?: 'CanvasUser';
  /** Canvas User ID. */
  id: Scalars['ID']['output'];
  /** Canvas User full name. */
  name: Scalars['String']['output'];
  /** Canvas SIS User ID. */
  sisUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * Cardinality of the expected response in a Question as defined in the QTI spec.
 *
 * A question can have a single, multiple, or requirement for an ordered correct
 * response expressed as its cardinality.
 */
export enum Cardinality {
  Multiple = 'multiple',
  Ordered = 'ordered',
  Single = 'single'
}

/** Charter for assessment group */
export type Charter = {
  __typename?: 'Charter';
  allMembersAccepted: Scalars['Boolean']['output'];
  editors: Array<CharterEditor>;
  feedbackThreads: Array<Thread>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  latestAgreement: Maybe<CharterAgreement>;
  milestones: Array<CharterMilestone>;
};

/** Charter agreements */
export type CharterAgreement = {
  __typename?: 'CharterAgreement';
  acceptedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['String']['output'];
  unlockedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Input for student's agreemeent to the charter,
 *   the `charter_id` is passed to identify the charter and
 *   the student's `id` is taken from the context
 */
export type CharterAgreementInput = {
  charterId: Scalars['ID']['input'];
};

/** Charter editor for students */
export type CharterEditor = {
  __typename?: 'CharterEditor';
  charterFormSectionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  snapshotDoc: Maybe<Scalars['String']['output']>;
  snapshotVersion: Maybe<Scalars['Int']['output']>;
  /** Stream Identifier for Editor */
  streamUuid: Scalars['String']['output'];
};

/**
 * Input to save the editor state by passing the `editor_id`
 *   and the `snapshot_doc` and `snapshot_version` at every save of the
 *   editor
 */
export type CharterEditorInput = {
  editorId: Scalars['ID']['input'];
  snapshotDoc: Scalars['String']['input'];
  snapshotVersion: Scalars['Int']['input'];
};

/** Charter Form created by the teacher for assessment */
export type CharterForm = {
  __typename?: 'CharterForm';
  editedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  publishTimestamp: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  sections: Array<CharterFormSection>;
};

export type CharterFormInput = {
  charterFormId: Scalars['ID']['input'];
  sections: InputMaybe<Array<CharterFormSectionInput>>;
};

export type CharterFormSection = {
  __typename?: 'CharterFormSection';
  /** Soft delete */
  deleted: Scalars['Boolean']['output'];
  /** Toggle if this section will be shown to students */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  milestonePresets: Maybe<Array<MilestonePresetType>>;
  /** Description of the section as a serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Sort order of the section */
  rank: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: CharterFormSectionType;
  /** Number of words allowed. Only used if it is an input type section */
  wordLimit: Maybe<Scalars['Int']['output']>;
  /** Toggle if word limit is enabled for this section. Only used if it is an input type section */
  wordLimitEnabled: Scalars['Boolean']['output'];
};

export type CharterFormSectionInput = {
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  /** Can be null for new sections */
  id: InputMaybe<Scalars['ID']['input']>;
  milestonePresets: InputMaybe<Array<MilestonePresetInput>>;
  promptDoc: InputMaybe<Scalars['String']['input']>;
  rank: InputMaybe<Scalars['Int']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<CharterFormSectionType>;
  wordLimit: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different form sections creatable in a charter form */
export enum CharterFormSectionType {
  Instruction = 'INSTRUCTION',
  Milestone = 'MILESTONE',
  Overview = 'OVERVIEW',
  TextInput = 'TEXT_INPUT'
}

/** Charter milestones */
export type CharterMilestone = {
  __typename?: 'CharterMilestone';
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

/** Charter section types that can have threads. */
export enum CharterSectionType {
  Editor = 'EDITOR',
  Milestone = 'MILESTONE'
}

/** A single choice in a response with an ID and label text. */
export type Choice = {
  __typename?: 'Choice';
  id: Scalars['String']['output'];
  isCorrect: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type ChoiceInput = {
  id: Scalars['String']['input'];
  isCorrect: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type ChoiceInteraction = {
  __typename?: 'ChoiceInteraction';
  choices: Array<SimpleChoice>;
  /** Optional Category label */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type ChoiceInteractionInput = {
  choices: Array<SimpleChoiceInput>;
  label: InputMaybe<Scalars['String']['input']>;
  maxChoices: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus Class information for an Assessment. */
export type Class = {
  __typename?: 'Class';
  /** How the groups were setup for the assessment. */
  groupType: GroupType;
  /** List of all groups and their members */
  groups: Array<Group>;
  /** Class assessment ID */
  id: Scalars['ID']['output'];
  /** List of student enrollments in a class, including deleted enrollments. */
  students: Array<Enrollment>;
};

/** A full Class list with works and stats. */
export type ClassList = {
  __typename?: 'ClassList';
  /** List of Enrollments in a Class */
  enrollments: Array<Enrollment>;
  id: Scalars['ID']['output'];
};

/** Enum for the different Class List tab contexts. */
export enum ClassTab {
  /** Drafts tab */
  Drafts = 'DRAFTS',
  /** Finals tab */
  Finals = 'FINALS',
  /** Students or Progress tab */
  Students = 'STUDENTS'
}

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
};

/** CommentRelease represents a snapshot of a comment at the time of feedback release. */
export type CommentRelease = {
  __typename?: 'CommentRelease';
  content: Scalars['String']['output'];
  createdBy: User;
  /** The ID of the Comment`. */
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/**
 * Required and Complete: When a component's `weight` is greater than `0` and
 * the `score` value exists, then this component is complete.
 *
 * Required and Incomplete: When a component's `weight` is greater than `0` and
 * the component does not have a `score` value, then this component is incomplete.
 *
 * Disabled: When a component is null, that means that the component is not enabled
 * in the AssessmentSettings.
 *
 * Optional: When a component's `weight` is `0` and not null, the
 * component is optional.
 */
export type ComponentBreakdown = {
  __typename?: 'ComponentBreakdown';
  group: Maybe<ComponentScore>;
  individual: Maybe<ComponentScore>;
  /** Peer Component relevant fields: score, max_score, weighted_score, weighted_max_score */
  peer: Maybe<ComponentScore>;
  /** self Component elevant fields: score, max_score, weighted_score, weighted_max_score */
  self: Maybe<ComponentScore>;
  total: Maybe<ComponentScore>;
};

export type ComponentScore = {
  __typename?: 'ComponentScore';
  maxScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  weightedMaxScore: Maybe<Scalars['Float']['output']>;
  weightedModeratorModifier: Maybe<Scalars['Float']['output']>;
  weightedPenaltyScore: Maybe<Scalars['Float']['output']>;
  weightedScore: Maybe<Scalars['Float']['output']>;
};

/** Conversation event payload for subscriptions - can be either a comment event or title change */
export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  comment: Maybe<Comment>;
  eventType: ConversationEventType;
  threadId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** Conversation event types for subscriptions */
export enum ConversationEventType {
  CommentAdded = 'COMMENT_ADDED',
  CommentEdited = 'COMMENT_EDITED',
  TitleEdited = 'TITLE_EDITED'
}

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateGraderMarkerRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
};

export type CreateGraderMarkerRubricPayload = {
  __typename?: 'CreateGraderMarkerRubricPayload';
  fieldRubric: FieldRubric;
  markerRubric: MarkerRubric;
};

export type CreateMarkerRubricInput = {
  format: MarkerRubricFormat;
  kind: MarkerRubricKind;
  reversedScale: Scalars['Boolean']['input'];
};

export type CreateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

export type CreateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse: InputMaybe<BooleanResponseInput>;
  category: InputMaybe<Scalars['String']['input']>;
  difficulty: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse: InputMaybe<EditorResponseInput>;
  feedback: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  fileOriginId: InputMaybe<Scalars['ID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filepath: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse: InputMaybe<MultiResponseInput>;
  points: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse: InputMaybe<ShortResponseInput>;
  shuffle: InputMaybe<Scalars['Boolean']['input']>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateQuestionMarkerRubricInput = {
  taskBlockId: Scalars['ID']['input'];
};

export type CreateQuestionMarkerRubricPayload = {
  __typename?: 'CreateQuestionMarkerRubricPayload';
  markerRubric: MarkerRubric;
  taskBlock: TaskBlock;
};

export type CreateQuestionSelectionPayload = {
  __typename?: 'CreateQuestionSelectionPayload';
  /** Array index of incomplete rule */
  incompleteRuleIndex: Maybe<Scalars['Int']['output']>;
  /** N questions required */
  requiredQuestionCount: Maybe<Scalars['Int']['output']>;
  /** N sets required */
  requiredSetsQuantity: Maybe<Scalars['Int']['output']>;
  /** N questions found */
  selectedQuestionCount: Maybe<Scalars['Int']['output']>;
  /** Fulfilled QuestionSelection generation. */
  selection: Maybe<QuestionSelection>;
};

export type CreateSkillInput = {
  skill: Scalars['String']['input'];
};

/** Creation attributes for a TaskBlock and linked Question */
export type CreateTaskBlockInput = {
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  nodeId: InputMaybe<Scalars['ID']['input']>;
  parentNodeId: InputMaybe<Scalars['ID']['input']>;
  points: InputMaybe<Scalars['Int']['input']>;
  previousNodeId: InputMaybe<Scalars['ID']['input']>;
  questionType: QuestionType;
  shuffle: InputMaybe<Scalars['Boolean']['input']>;
};

export type Criterion = {
  __typename?: 'Criterion';
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  maxScore: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  scaleItems: Array<ScaleItem>;
  skill: Maybe<LearningOutcomeSkill>;
  /** Learning Outcome Skill with Criterion title as fallback. */
  title: Maybe<Scalars['String']['output']>;
};

export type CriterionInput = {
  color: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  maxScore: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  scaleItems: Array<ScaleItemInput>;
  skillId: InputMaybe<Scalars['ID']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
};

export type CriterionOutcome = {
  __typename?: 'CriterionOutcome';
  id: Scalars['ID']['output'];
  markerRubricCriterion: Criterion;
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
  /** For Peer Evaluations: the student that marked this outcome. */
  markerUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when the student published their evaluation. */
  publishedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** For Peer Evaluations: the student that received this outcome. */
  targetUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * CriterionOutcomeRelease represents a snapshot of a criterion outcome at release time.
 * Contains the rubric-based marking for a specific criterion.
 */
export type CriterionOutcomeRelease = {
  __typename?: 'CriterionOutcomeRelease';
  id: Scalars['ID']['output'];
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
};

/** Custom params captured for a user during LTI launches. */
export type CustomParams = {
  __typename?: 'CustomParams';
  brightspaceUserId: Maybe<Scalars['ID']['output']>;
  canvasAssignmentId: Maybe<Scalars['ID']['output']>;
  canvasSubmissionId: Maybe<Scalars['ID']['output']>;
  canvasUserId: Maybe<Scalars['ID']['output']>;
  lisPersonSourcedid: Maybe<Scalars['String']['output']>;
  moodleAttemptReopenMethod: Maybe<Scalars['String']['output']>;
};

export type DeletedMember = {
  __typename?: 'DeletedMember';
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** All possible Disciplines in Cadmus */
export enum Discipline {
  ArchitectureBuilding = 'ARCHITECTURE_BUILDING',
  Business = 'BUSINESS',
  ComputingIt = 'COMPUTING_IT',
  Design = 'DESIGN',
  Education = 'EDUCATION',
  Engineering = 'ENGINEERING',
  HumanitiesLanguages = 'HUMANITIES_LANGUAGES',
  Law = 'LAW',
  Mathematics = 'MATHEMATICS',
  MediaCommunication = 'MEDIA_COMMUNICATION',
  MedicineHealth = 'MEDICINE_HEALTH',
  PerformingFineArts = 'PERFORMING_FINE_ARTS',
  Science = 'SCIENCE',
  SocialScience = 'SOCIAL_SCIENCE'
}

/** Response as a rich text editor. */
export type EditorResponse = {
  __typename?: 'EditorResponse';
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type EditorResponseInput = {
  wordLimit: InputMaybe<Scalars['Int']['input']>;
};

/** Different kinds of client-side Editors */
export enum EditorType {
  Prosemirror = 'PROSEMIRROR',
  Slate = 'SLATE'
}

/** A class Enrollment. */
export type Enrollment = {
  __typename?: 'Enrollment';
  /**
   * Access code used by the Student in the enrollment.
   * @deprecated Use `verified_codes` instead
   */
  accessCode: Maybe<AccessCode>;
  /** Index of the enrollment for anonymous marking */
  anonymousIndex: Maybe<Scalars['Int']['output']>;
  /** LTI Custom params */
  customParams: CustomParams;
  deleted: Scalars['Boolean']['output'];
  deletedBy: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Source LMS' SIS ID for the enrolled user */
  sisUserId: Maybe<Scalars['String']['output']>;
  /** Enrollment synced at date if the enrollment is inserted/updated through roster sync not lti launch */
  syncedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Tags for the enrollment */
  tags: Array<Tag>;
  /** Enrolled user */
  user: User;
  /** List of all the verified access codes used by the student in the enrollment. */
  verifiedCodes: Maybe<Array<VerifiedCode>>;
  /** Work started under the Enrollment, if any */
  work: Maybe<Work>;
  workSettings: Maybe<WorkSettings>;
};

/** Entity thread event payload for subscriptions */
export type EntityThreadEvent = {
  __typename?: 'EntityThreadEvent';
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  eventType: EntityThreadEventType;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  threadId: Scalars['ID']['output'];
};

/** Entity thread event types for subscriptions */
export enum EntityThreadEventType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Linked = 'LINKED',
  Resolved = 'RESOLVED',
  Unlinked = 'UNLINKED',
  Unresolved = 'UNRESOLVED'
}

/** Entity types associated with threads. */
export enum EntityType {
  AnswerBlock = 'ANSWER_BLOCK',
  Charter = 'CHARTER',
  FieldOutcome = 'FIELD_OUTCOME',
  PeerOutcome = 'PEER_OUTCOME',
  SubmissionOutcome = 'SUBMISSION_OUTCOME'
}

/** Type of examination time windowing strategy. */
export enum ExamTiming {
  Live = 'LIVE',
  Window = 'WINDOW'
}

export type ExtendedInteraction = {
  __typename?: 'ExtendedInteraction';
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type ExtendedInteractionInput = {
  attachmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit: InputMaybe<Scalars['Int']['input']>;
};

/** Valid conflic actions for extensions sync types */
export enum ExtensionConflictActionType {
  Override = 'OVERRIDE',
  Skip = 'SKIP'
}

export enum FeedbackLevel {
  Answer = 'ANSWER',
  Feedback = 'FEEDBACK',
  Mark = 'MARK'
}

/** Types of Feedback Release Rule. */
export enum FeedbackReleaseBasePool {
  All = 'ALL',
  Empty = 'EMPTY'
}

/** Feedback Release Rule to release feedback to students in the future. */
export type FeedbackReleaseRule = {
  __typename?: 'FeedbackReleaseRule';
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds: Array<Scalars['ID']['output']>;
  excludedTags: Array<Scalars['String']['output']>;
  executedAt: Maybe<Scalars['DateTime']['output']>;
  executedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedStudentIds: Array<Scalars['ID']['output']>;
  includedTags: Array<Scalars['String']['output']>;
  releaseType: FeedbackReleaseType;
  ruleKind: RuleKind;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackReleaseRuleInput = {
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedTags: InputMaybe<Array<Scalars['String']['input']>>;
  id: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  includedStudentIds: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags: InputMaybe<Array<Scalars['String']['input']>>;
  releaseType: InputMaybe<FeedbackReleaseType>;
  ruleKind: RuleKind;
  scheduledAt: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FeedbackReleaseType {
  Final = 'FINAL',
  Provisional = 'PROVISIONAL'
}

/**
 * Assessment-wide Feedback Visibility. Controls level of feedback visible to
 * the students after it is released. They are unique on AssessmentID and
 * ReleaseType.
 */
export type FeedbackVisibility = {
  __typename?: 'FeedbackVisibility';
  feedbackViewLevel: FeedbackLevel;
  id: Scalars['ID']['output'];
  jointRelease: Scalars['Boolean']['output'];
  notifyStudents: Scalars['Boolean']['output'];
  releaseType: FeedbackReleaseType;
  showPeerComments: Scalars['Boolean']['output'];
  showPeerScores: Scalars['Boolean']['output'];
  withFeedbackPdf: Scalars['Boolean']['output'];
};

export type FeedbackVisibilityInput = {
  feedbackViewLevel: FeedbackLevel;
  jointRelease: InputMaybe<Scalars['Boolean']['input']>;
  notifyStudents: InputMaybe<Scalars['Boolean']['input']>;
  releaseType: InputMaybe<FeedbackReleaseType>;
  showPeerComments: InputMaybe<Scalars['Boolean']['input']>;
  showPeerScores: InputMaybe<Scalars['Boolean']['input']>;
  withFeedbackPdf: Scalars['Boolean']['input'];
};

/** Outcome on a single field in a question. */
export type FieldOutcome = {
  __typename?: 'FieldOutcome';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  /** Status of the automarking */
  automarkStatus: Maybe<AutomarkStatus>;
  comments: Maybe<Array<Comment>>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
};

/**
 * FieldOutcomeRelease represents a snapshot of a field outcome at release time.
 * Contains the marking and feedback for a specific field within a question.
 */
export type FieldOutcomeRelease = {
  __typename?: 'FieldOutcomeRelease';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  commentReleases: Array<CommentRelease>;
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
  threadReleases: Array<ThreadRelease>;
};

export type FieldResponse = {
  __typename?: 'FieldResponse';
  /** Single answer */
  answer: Maybe<Scalars['String']['output']>;
  /** Multiple answers (such as ranges) */
  answers: Maybe<Array<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  /** If the response was correct. */
  isCorrect: Scalars['Boolean']['output'];
  /** @deprecated Use `answer` instead. */
  response: Maybe<Scalars['String']['output']>;
  /** Best similarity score from 0 to 1 if the response was not correct. */
  similarity: Maybe<Scalars['Float']['output']>;
};

/** Rubric for a single field across all questions in the assessment task. */
export type FieldRubric = {
  __typename?: 'FieldRubric';
  /** Whether the field is automarked. */
  automarked: Scalars['Boolean']['output'];
  baseType: Maybe<BaseType>;
  caseSensitive: Scalars['Boolean']['output'];
  /** List of accepted position area answers */
  correctAreas: Maybe<Array<PositionArea>>;
  /** List of accepted numerical range answers */
  correctRanges: Maybe<Array<NumericRange>>;
  errorMargin: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  markerChanges: Maybe<FieldRubricChanges>;
  markerRubric: Maybe<MarkerRubric>;
  moderatorChanges: Maybe<FieldRubricChanges>;
  partialScoring: Scalars['Boolean']['output'];
  /** Aggregate of all responses provided to the field. */
  responses: Array<FieldResponse>;
  similarity: Maybe<Scalars['Float']['output']>;
  /** String matching strategy */
  strategy: Maybe<MatchStrategy>;
  /** List of accepted answers */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Overriding change tracking made by marker or moderator to a FieldRubric. */
export type FieldRubricChanges = {
  __typename?: 'FieldRubricChanges';
  id: Scalars['ID']['output'];
  valuesAdded: Array<Scalars['String']['output']>;
  valuesRemoved: Array<Scalars['String']['output']>;
};

export type FindSimilarQuestionsInput = {
  excludeQuestionIds: Array<Scalars['ID']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  tagIds: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input object which represents the global portion of the user's settings. */
export type GlobalUserSettingsInput = {
  /** User must be shown the IA onboarding */
  showIaOnboarding: InputMaybe<Scalars['Boolean']['input']>;
  showUserpilotOnboarding: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Grade information for a Result.
 *
 * A grade stored as a floating point numeric value between 0 and 1. For display
 * however, this value has to be mulitplied by the latest released maximum grade
 * point requirements. The display is also string formatted with 2-digit padding
 * and 2-decimal point accuracy.
 */
export type Grade = {
  __typename?: 'Grade';
  /** Human formatted representation of the grade */
  display: Scalars['String']['output'];
  /** Maximum score possible */
  max: Scalars['Int']['output'];
  /** Actual 0-1 grade value */
  value: Scalars['Float']['output'];
};

/** Background processing result for a Submission against a Result. */
export type GradebookReceipt = {
  __typename?: 'GradebookReceipt';
  /** Email receipt sent to student. */
  emailComplete: Scalars['Boolean']['output'];
  /** Submission PDF or Record sent to the LMS. */
  lmsComplete: Scalars['Boolean']['output'];
  /** LMS Stage is snoozed until this date. */
  lmsSnooze: Maybe<Scalars['DateTime']['output']>;
  /** PDF WorkArtifact ID for complete render of the Submission. */
  pdfArtifactId: Maybe<Scalars['ID']['output']>;
  /** Submission PDF sent to Turnitin. */
  turnitinComplete: Scalars['Boolean']['output'];
};

/** Known service integrations into the Cadmus Gradebook result */
export enum GradebookService {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/** A group of students in an assessment */
export type Group = {
  __typename?: 'Group';
  code: Maybe<Scalars['String']['output']>;
  groupSet: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  /** The maximum number of students that can be in a group */
  maxLimit: Maybe<Scalars['Int']['output']>;
  members: Array<User>;
  /** The minimum number of students required to be in a group */
  minLimit: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  questionId: Maybe<Scalars['String']['output']>;
};

export type GroupInput = {
  code: InputMaybe<Scalars['String']['input']>;
  groupSet: InputMaybe<Scalars['String']['input']>;
  maxLimit: InputMaybe<Scalars['Int']['input']>;
  members: InputMaybe<Array<Scalars['ID']['input']>>;
  minLimit: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GroupMembershipInput = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GroupRule = {
  markerId: InputMaybe<Scalars['String']['input']>;
  markerIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionIds: InputMaybe<Array<Scalars['ID']['input']>>;
  totalStudents: InputMaybe<Scalars['Int']['input']>;
};

/** Purpose of the groups setup in an Assessment */
export enum GroupType {
  Question = 'QUESTION',
  Student = 'STUDENT'
}

export type GroupUpdateInput = {
  addedMembers: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  markerId: InputMaybe<Scalars['ID']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  removedMembers: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for importing library question to task block */
export type ImportLibraryQuestionInput = {
  questionId: Scalars['ID']['input'];
  questionVersionId: InputMaybe<Scalars['ID']['input']>;
  taskBlockId: Scalars['ID']['input'];
};

/** Cadmus Institution. */
export type Institution = {
  __typename?: 'Institution';
  /**
   * Institution has the Access Code feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  accessCodeFeatureEnabled: Scalars['Boolean']['output'];
  apiStatus: ApiStatusType;
  /**
   * Institution has the Cadmus Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  cadmusGraderFeatureEnabled: Scalars['Boolean']['output'];
  /** Institution's country of origin information. Also known as home country. */
  country: Country;
  /** Custom declaration Rich text JSON from contentful */
  customDeclarationText: Maybe<Scalars['String']['output']>;
  /**
   * Institution has the Exams feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  examsFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Feature flags enabled for the institution.
   * @deprecated Use query-level `featureFlags`
   */
  features: InstitutionFeatures;
  /**
   * Institution has the Footnote Referencing feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  footnoteReferencingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Institution has the LDB feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  ldbFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Moodle Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  moodlegraderFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Multiformat Task feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  multiformatFeatureEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  /**
   * Institution has the Turnitin Feedback Studio feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  turnitinGraderFeatureEnabled: Scalars['Boolean']['output'];
};

/** Institution feature flags. */
export type InstitutionFeatures = {
  __typename?: 'InstitutionFeatures';
  accessCode: Scalars['Boolean']['output'];
  advancedMarking: Scalars['Boolean']['output'];
  cadmusGrader: Scalars['Boolean']['output'];
  exams: Scalars['Boolean']['output'];
  extensionSyncing: Scalars['Boolean']['output'];
  footnoteReferencing: Scalars['Boolean']['output'];
  genAiDeclaration: Scalars['Boolean']['output'];
  groupAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  moodleGrader: Scalars['Boolean']['output'];
  multiformat: Scalars['Boolean']['output'];
  questionLibrary: Scalars['Boolean']['output'];
  respondusLdb: Scalars['Boolean']['output'];
  smartAutomarking: Scalars['Boolean']['output'];
  timeline: Scalars['Boolean']['output'];
  turnitinGrader: Scalars['Boolean']['output'];
  workAttachment: Scalars['Boolean']['output'];
};

/** Institution LMS Tool Provider information. */
export type InstitutionTool = {
  __typename?: 'InstitutionTool';
  familyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type IssueAssigneeInput = {
  userId: Scalars['ID']['input'];
};

export enum IssueStatus {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum IssueType {
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

/** Status information on a background Job */
export type Job = {
  __typename?: 'Job';
  assessmentId: Scalars['ID']['output'];
  conflict: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Final result URL if available */
  resultUrl: Maybe<Scalars['String']['output']>;
};

export type LearningOutcomeSkill = {
  __typename?: 'LearningOutcomeSkill';
  id: Scalars['ID']['output'];
  skill: Scalars['String']['output'];
};

/** An LTI Service like AGS or NRPS. */
export type LtiService = {
  __typename?: 'LtiService';
  id: Scalars['ID']['output'];
  /** LTI Advantage (V2) services have OAuth2 token issuers */
  issuer: Maybe<Scalars['String']['output']>;
  metaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * A Mailing List representation which can be active or in-active depending on
 * the `subscribed` field.
 */
export type MailingList = {
  __typename?: 'MailingList';
  id: Scalars['String']['output'];
  members: Array<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
};

export type MarkFieldOutcomeInput = {
  fieldOutcomeId: Scalars['ID']['input'];
  scaleItemId: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
};

export type MarkFieldOutcomePayload = {
  __typename?: 'MarkFieldOutcomePayload';
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type MarkPeerOutcomeInput = {
  scaleItemId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};

export type MarkSubmissionOutcomeInput = {
  scaleItemId: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
  submissionOutcomeId: Scalars['Int']['input'];
};

export type MarkSubmissionOutcomePayload = {
  __typename?: 'MarkSubmissionOutcomePayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type MarkerRubric = {
  __typename?: 'MarkerRubric';
  assessmentId: Scalars['ID']['output'];
  /** @deprecated Use `location` field instead. */
  assessmentName: Scalars['String']['output'];
  criteria: Array<Criterion>;
  format: MarkerRubricFormat;
  /** Has un-published changes over the last published version. */
  hasChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: MarkerRubricKind;
  location: MarkerRubricLocation;
  markingExists: Scalars['Boolean']['output'];
  /** Publish timestamp if the rubric is the published version */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `location` field instead. */
  questionShortPrompt: Maybe<Scalars['String']['output']>;
  reversedScale: Scalars['Boolean']['output'];
};

export enum MarkerRubricFormat {
  Percentage = 'PERCENTAGE',
  Points = 'POINTS',
  Absolute = 'ABSOLUTE'
}

export type MarkerRubricInput = {
  criteria: Array<CriterionInput>;
  format: MarkerRubricFormat;
  kind: InputMaybe<MarkerRubricKind>;
  reversedScale: Scalars['Boolean']['input'];
};

/** Kinds of Marker Rubrics for different purposes. */
export enum MarkerRubricKind {
  Extended = 'EXTENDED',
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Location of a MarkerRubric within an Assessment. */
export type MarkerRubricLocation = {
  __typename?: 'MarkerRubricLocation';
  /** assessment name */
  assessment: Scalars['String']['output'];
  /** path within the assessment */
  path: Scalars['String']['output'];
};

export enum MarkerRubricStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum MarkingRole {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Marking tool used for the assessment. */
export enum MarkingTool {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/**
 * Restrict student result view via the PDF sent to the LMS marking tool.
 *
 *   * UnmarkedOnly - Show un-marked responses only
 *
 *   * UnmarkedAndAutomarkedSummary - Show un-marked responses and auto-mark
 *     summary
 */
export enum MarkingToolPdf {
  UnmarkedAndAutomarkedSummary = 'UNMARKED_AND_AUTOMARKED_SUMMARY',
  UnmarkedOnly = 'UNMARKED_ONLY'
}

export type MatchInteraction = {
  __typename?: 'MatchInteraction';
  /** Answer options that can be selected for matching */
  sourceSet: Array<SimpleChoice>;
  /** Prompts that are matched against */
  targetSet: Array<SimpleChoice>;
};

export type MatchInteractionInput = {
  sourceSet: Array<SimpleChoiceInput>;
  targetSet: Array<SimpleChoiceInput>;
};

/** Matching strategy used to auto-mark a string Field */
export enum MatchStrategy {
  Exact = 'EXACT',
  Levdist = 'LEVDIST',
  Smart = 'SMART'
}

/** A Message sent in a Class from an enrolled user. */
export type Message = {
  __typename?: 'Message';
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  messageType: MessageRequestType;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  sourceUserId: Scalars['ID']['output'];
};

export type MessageInput = {
  expiresInDays: InputMaybe<Scalars['Int']['input']>;
  messageType: MessageRequestType;
  targetUserId: InputMaybe<Scalars['ID']['input']>;
};

export enum MessageRequestType {
  GroupChange = 'GROUP_CHANGE'
}

export type Metadata = {
  __typename?: 'Metadata';
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId: Maybe<Scalars['Int']['output']>;
  /** Display name of the file */
  blockAttachmentName: Maybe<Scalars['String']['output']>;
  /** ID of the charter editor associated with this thread. */
  charterEditorId: Maybe<Scalars['ID']['output']>;
  /** Type of charter section this thread is associated with, can be 'Editor' or 'Milestone'. */
  charterSectionType: Maybe<CharterSectionType>;
};

/** Input for charter milestone details for updating it */
export type MilestoneInput = {
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  /** can be null for new milestones */
  id: InputMaybe<Scalars['ID']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetInput = {
  description: InputMaybe<Scalars['String']['input']>;
  /** Datetime when the milestone is due */
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  /** Title for the milestone */
  title: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetType = {
  __typename?: 'MilestonePresetType';
  description: Maybe<Scalars['String']['output']>;
  /** Datetime this milestone is due */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** Title for the milestone */
  title: Maybe<Scalars['String']['output']>;
};

/** Moderation Penalty Rule to apply penalties on feedback release. */
export type ModerationPenaltyRule = {
  __typename?: 'ModerationPenaltyRule';
  canStack: Scalars['Boolean']['output'];
  excludedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  formatUnit: Maybe<PenaltyFormatUnit>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedTags: Maybe<Array<Scalars['String']['output']>>;
  minutesLateBy: Maybe<Scalars['Int']['output']>;
  penaltyScore: Scalars['Float']['output'];
  penaltyType: ModerationPenaltyType;
  reason: Maybe<Scalars['String']['output']>;
  ruleKind: RuleKind;
  scoreUnit: PenaltyScoreUnit;
};

export type ModerationPenaltyRuleInput = {
  canStack: Scalars['Boolean']['input'];
  excludedStudentIds: InputMaybe<Array<Scalars['ID']['input']>>;
  formatUnit: PenaltyFormatUnit;
  id: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags: InputMaybe<Array<Scalars['String']['input']>>;
  minutesLateBy: InputMaybe<Scalars['Int']['input']>;
  penaltyScore: Scalars['Float']['input'];
  penaltyType: ModerationPenaltyType;
  reason: InputMaybe<Scalars['String']['input']>;
  ruleKind: RuleKind;
  scoreUnit: InputMaybe<PenaltyScoreUnit>;
};

export enum ModerationPenaltyType {
  Custom = 'CUSTOM',
  MoreThan = 'MORE_THAN'
}

/** Response as multiple choice selections. */
export type MultiResponse = {
  __typename?: 'MultiResponse';
  cardinality: Maybe<Cardinality>;
  choices: Array<Choice>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type MultiResponseInput = {
  choices: Array<ChoiceInput>;
  /** Partial scoring for multiple choice questions. */
  partialScoring: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumericRange = {
  __typename?: 'NumericRange';
  end: Scalars['Float']['output'];
  identifier: Scalars['ID']['output'];
  start: Scalars['Float']['output'];
};

export type NumericRangeInput = {
  end: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  start: Scalars['Float']['input'];
};

/** Mutation return for `captureOnboardingInput`. */
export type OnboardingPayload = {
  __typename?: 'OnboardingPayload';
  subject: Maybe<Subject>;
  userSettings: Maybe<UserSettings>;
};

export type OutcomesDeletedPayload = {
  __typename?: 'OutcomesDeletedPayload';
  outcomesDeleted: Scalars['Int']['output'];
};

/** A past instruction, which includes information about each assessment and its related, latest released instructions. */
export type PastInstructionSheet = {
  __typename?: 'PastInstructionSheet';
  assessment: Assessment;
  id: Scalars['ID']['output'];
  sheet: Sheet;
};

/** Marking outcome when a student peer evaluates another peer in a group. */
export type PeerOutcome = {
  __typename?: 'PeerOutcome';
  /** When the all group members published their complete evaluations of the target_user_id */
  completedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All Criterion selections made by peers against this Peer Outcome */
  criterionOutcomes: Array<CriterionOutcome>;
  /** When the peer outcome was used for the Students Gradebook Result */
  feedbackReleasedTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Criterion selections that the current user has made on this Peer Outcome. */
  givenCriterionOutcomes: Array<CriterionOutcome>;
  id: Scalars['ID']['output'];
  /** Precomputed peer max score (max score committed at time of publish of last student in group), only available when completed_at has a value and the assessment has peer_evaluations enabled */
  peerMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed peer score, only available when completed_at has a value and the assessment has peer_evaluations enabled */
  peerScore: Maybe<Scalars['Float']['output']>;
  /** Precomputed self max score (max score committed at time of publish), only available when completed_at has a value, and the assessment has self_evaluations enabled */
  selfMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed self score, only available when completed_at has a value, and the assessment has self_evaluations enabled */
  selfScore: Maybe<Scalars['Float']['output']>;
  /** Student being evaluated */
  targetUserId: Scalars['ID']['output'];
};

export enum PenaltyFormatUnit {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

/** Format of Moderation Penalty Value Unit. */
export enum PenaltyScoreUnit {
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

/** A single position area in a position object response. */
export type PositionArea = {
  __typename?: 'PositionArea';
  coords: Array<Scalars['Float']['output']>;
  identifier: Scalars['ID']['output'];
  shape: Shape;
};

export type PositionAreaInput = {
  coords: Array<Scalars['Float']['input']>;
  identifier: Scalars['String']['input'];
  shape: Shape;
};

export type PositionObjectInteraction = {
  __typename?: 'PositionObjectInteraction';
  /** Label for the position object */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type PositionObjectInteractionInput = {
  /** Label for the interaction */
  label: Scalars['String']['input'];
  maxChoices: InputMaybe<Scalars['Int']['input']>;
};

export type PrintArchiveInput = {
  assessmentName: Scalars['String']['input'];
  date: InputMaybe<Scalars['String']['input']>;
  labels: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Issue for Assessment Group's Project Management Board */
export type ProjectIssue = {
  __typename?: 'ProjectIssue';
  /** List of user IDs assigned to the issue. */
  assignees: Array<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  status: IssueStatus;
  title: Scalars['String']['output'];
  type: IssueType;
};

/** Input to update Project Issues for Group Assessment */
export type ProjectIssueInput = {
  assignees: InputMaybe<Array<IssueAssigneeInput>>;
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of an existing issue or null for new issues. */
  id: InputMaybe<Scalars['ID']['input']>;
  parentId: InputMaybe<Scalars['ID']['input']>;
  status: InputMaybe<IssueStatus>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<IssueType>;
};

/** Image information and associated annotations. */
export type PromptImage = {
  __typename?: 'PromptImage';
  /** Image height */
  height: Scalars['Int']['output'];
  /** Image layers for annotations. */
  layers: Array<PromptImageLayer>;
  /** Image URL */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

/** Question Prompt Image attributes */
export type PromptImageInput = {
  /** Image height */
  height: Scalars['Int']['input'];
  /** Image layers attributes */
  layers: InputMaybe<Array<PromptImageLayerInput>>;
  /** Image URL */
  url: Scalars['String']['input'];
  /** Image width */
  width: Scalars['Int']['input'];
};

/** Image layer information */
export type PromptImageLayer = {
  __typename?: 'PromptImageLayer';
  /** Layer coordinates */
  coords: Array<Scalars['Float']['output']>;
  /** Layer identifier */
  identifier: Scalars['String']['output'];
  /** Layer shape */
  shape: Shape;
};

/** Question Prompt Image Layer attributes */
export type PromptImageLayerInput = {
  /** Layer coordinates */
  coords: Array<Scalars['Float']['input']>;
  /** Layer identifier */
  identifier: Scalars['String']['input'];
  /** Layer shape */
  shape: Shape;
};

export type PublishImportedQuestionsInput = {
  assessmentId: Scalars['ID']['input'];
  questions: Array<QuestionAttributes>;
  sourceFile: SourceFileInput;
  subjectId: Scalars['ID']['input'];
  tags: InputMaybe<Array<TagInput>>;
};

/** A single Question as part of the Cadmus Assessments. */
export type Question = {
  __typename?: 'Question';
  accessGroup: Maybe<AccessGroup>;
  accessRole: Maybe<AccessRole>;
  /** Whether the question was deleted from the library. */
  archived: Scalars['Boolean']['output'];
  /** Retrieves the list of assessments where the question was used. */
  assessmentUsages: Array<QuestionAssessment>;
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  /** Preferred caching ID on the client. */
  cacheId: Scalars['ID']['output'];
  childrenQuestions: Array<Question>;
  createdAt: Scalars['PreciseDateTime']['output'];
  currentVersionId: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  libraryId: Scalars['String']['output'];
  /** Order for a child sub-question. */
  order: Maybe<Scalars['Int']['output']>;
  /** Parent question ID for sub questions. */
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this question. */
  points: Maybe<Scalars['Int']['output']>;
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Maybe<Scalars['String']['output']>;
  shuffle: Scalars['Boolean']['output'];
  sourceFile: Maybe<QuestionSourceFile>;
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
  /** Attached tags of the questions */
  tags: Array<QuestionTag>;
  /** Should be used only for task block edge. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
  /** All the versions of the question */
  versions: Array<QuestionVersion>;
};

export type QuestionAssessment = {
  __typename?: 'QuestionAssessment';
  /** When and how the question was used in an assessment. */
  assessment: Assessment;
  points: Maybe<Scalars['Int']['output']>;
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
};

export type QuestionAttributes = {
  /** Difficulty level of the question */
  difficulty: InputMaybe<QuestionDifficulty>;
  feedback: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields: InputMaybe<Array<QuestionFieldInput>>;
  /** Order of the question in the parent question */
  order: InputMaybe<Scalars['Int']['input']>;
  /** Parent question ID if this is a child of sub question */
  parentQuestionId: InputMaybe<Scalars['ID']['input']>;
  /** Points for the question */
  points: InputMaybe<Scalars['Int']['input']>;
  /** Question prompt prosemirror contents */
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** Shuffle the choices in the question */
  shuffle: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a question */
export type QuestionAttributesInput = {
  currentVersionId: InputMaybe<Scalars['ID']['input']>;
  difficulty: InputMaybe<QuestionDifficulty>;
  points: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBank = {
  __typename?: 'QuestionBank';
  assessmentId: Maybe<Scalars['ID']['output']>;
  category: Maybe<QuestionBankCategory>;
  createdBy: User;
  difficulty: Maybe<QuestionDifficulty>;
  fileOrigin: Maybe<QuestionBankFileOrigin>;
  id: Scalars['ID']['output'];
  points: Maybe<Scalars['Int']['output']>;
  question: Question;
  questionBankId: Scalars['ID']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategory = {
  __typename?: 'QuestionBankCategory';
  assessmentId: Maybe<Scalars['ID']['output']>;
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategoryInput = {
  category: Scalars['String']['input'];
  scope: QuestionBankScope;
};

export type QuestionBankFileOrigin = {
  __typename?: 'QuestionBankFileOrigin';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type QuestionBankFilterInput = {
  category: InputMaybe<Scalars['String']['input']>;
  difficulty: InputMaybe<QuestionDifficulty>;
  questionBankIds: InputMaybe<Array<Scalars['ID']['input']>>;
  questionType: InputMaybe<QuestionType>;
};

export type QuestionBankNodes = {
  nodeId: Scalars['ID']['input'];
  parentNodeId: InputMaybe<Scalars['ID']['input']>;
  previousNodeId: InputMaybe<Scalars['ID']['input']>;
  questionBankId: Scalars['ID']['input'];
};

export type QuestionBankScope = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};

/** A node (or sub-tree) in the QuestionTree */
export type QuestionBlock = {
  __typename?: 'QuestionBlock';
  /** e.g. Question 1 */
  longLabel: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the node */
  nodeId: Scalars['ID']['output'];
  /** Type of the node */
  nodeType: QuestionTreeNodeType;
  /** Order position of this node among siblings */
  order: Scalars['Int']['output'];
  /** ID of the parent node, if any */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Total points below this tree node */
  points: Maybe<Scalars['Int']['output']>;
  /** Question attached to this node */
  question: Maybe<Question>;
  questionId: Maybe<Scalars['ID']['output']>;
  questionSetId: Maybe<Scalars['ID']['output']>;
  /** e.g. Q1 */
  shortLabel: Maybe<Scalars['String']['output']>;
  /** Whether to shuffle this node's children */
  shuffle: Maybe<Scalars['Boolean']['output']>;
};

/** Saved contents of the Question. */
export type QuestionBody = {
  __typename?: 'QuestionBody';
  feedback: Maybe<Scalars['String']['output']>;
  /** Interactions and their response declaration in the question. */
  fields: Maybe<Array<QuestionField>>;
  /** Question Body ID used for caching body separately, not expected to be used. */
  id: Scalars['ID']['output'];
  /** Serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: Maybe<PromptImage>;
  /** @deprecated Use `fields` */
  response: Maybe<QuestionResponse>;
};

export enum QuestionDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

/** A single Question field. */
export type QuestionField = {
  __typename?: 'QuestionField';
  identifier: Scalars['String']['output'];
  /** How the student interacts with the field. */
  interaction: QuestionInteraction;
  /** How the response should be interpreted and marked. */
  response: Maybe<ResponseDeclaration>;
};

export type QuestionFieldInput = {
  choiceInteraction: InputMaybe<ChoiceInteractionInput>;
  extendedInteraction: InputMaybe<ExtendedInteractionInput>;
  identifier: Scalars['String']['input'];
  matchInteraction: InputMaybe<MatchInteractionInput>;
  positionObjectInteraction: InputMaybe<PositionObjectInteractionInput>;
  response: ResponseDeclarationInput;
  textEntryInteraction: InputMaybe<TextEntryInteractionInput>;
};

/** Different kinds of interactions expected for a question. */
export type QuestionInteraction = ChoiceInteraction | ExtendedInteraction | MatchInteraction | PositionObjectInteraction | TextEntryInteraction;

/**
 * Outcome recorded for a single question possibly answered by the student in
 * their work.
 */
export type QuestionOutcome = {
  __typename?: 'QuestionOutcome';
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  fieldOutcomes: Array<FieldOutcome>;
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  /** Question outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
};

/** QuestionOutcomeRelease represents a snapshot of a question outcome at release time. */
export type QuestionOutcomeRelease = {
  __typename?: 'QuestionOutcomeRelease';
  answerBlockId: Scalars['ID']['output'];
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  blockSnapshotId: Scalars['ID']['output'];
  fieldOutcomeReleases: Array<FieldOutcomeRelease>;
  /** The ID of the QuestionOutcome. */
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  questionOutcomeId: Scalars['ID']['output'];
};

/** Different kinds of responses expected for a question. */
export type QuestionResponse = BlanksResponse | BooleanResponse | EditorResponse | MultiResponse | ShortResponse;

export type QuestionResponseCounts = {
  __typename?: 'QuestionResponseCounts';
  /** Count of provided responses. */
  responseCount: Scalars['Int']['output'];
  /** Count of responses that achieved 100% of the outcomes. */
  successCount: Scalars['Int']['output'];
};

/** A Question's marking rubric. */
export type QuestionRubric = {
  __typename?: 'QuestionRubric';
  /** Metrics on the responses provided to the marked question. */
  counts: QuestionResponseCounts;
  fieldRubrics: Array<FieldRubric>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
};

export type QuestionSelection = {
  __typename?: 'QuestionSelection';
  id: Scalars['ID']['output'];
  rules: Array<QuestionSelectionRule>;
  sets: Maybe<Array<QuestionSet>>;
  setsQuantity: Scalars['Int']['output'];
};

export type QuestionSelectionFilterInput = {
  selectedSetId: Scalars['Int']['input'];
  selectionId: Scalars['ID']['input'];
};

export type QuestionSelectionInput = {
  excludeQuestionIds: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUsed: InputMaybe<Scalars['Boolean']['input']>;
  overlap: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: InputMaybe<Array<Scalars['ID']['input']>>;
  questionsPerSet: InputMaybe<Scalars['Int']['input']>;
  rules: Array<QuestionSelectionRuleInput>;
  setsQuantity: Scalars['Int']['input'];
  usedFrom: InputMaybe<Scalars['DateTime']['input']>;
  usedTo: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSelectionRule = {
  __typename?: 'QuestionSelectionRule';
  createdBy: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  id: Scalars['ID']['output'];
  includeUsed: Maybe<Scalars['Boolean']['output']>;
  points: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  questionType: QuestionType;
  usedFrom: Maybe<Scalars['DateTime']['output']>;
  usedTo: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionSelectionRuleInput = {
  createdBy: InputMaybe<Scalars['ID']['input']>;
  difficulty: InputMaybe<QuestionDifficulty>;
  includeUsed: InputMaybe<Scalars['Boolean']['input']>;
  points: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  questionType: QuestionType;
  tagIds: InputMaybe<Array<Scalars['ID']['input']>>;
  usedFrom: InputMaybe<Scalars['DateTime']['input']>;
  usedTo: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSet = {
  __typename?: 'QuestionSet';
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  questions: Array<QuestionSetQuestion>;
};

export type QuestionSetQuestion = {
  __typename?: 'QuestionSetQuestion';
  id: Scalars['ID']['output'];
  /** Tree layout node Id for the question inside question set */
  nodeId: Scalars['ID']['output'];
  /** Tree layout previous node Id for the question inside question set */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout parent node Id for the question inside question set */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  question: Question;
  /** Id of the question version used in this question set question */
  questionVersionId: Maybe<Scalars['ID']['output']>;
  shuffle: Scalars['Boolean']['output'];
};

/** A source file for imported question in the library. */
export type QuestionSourceFile = {
  __typename?: 'QuestionSourceFile';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuestionTagCategory = {
  __typename?: 'QuestionTagCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Type of tree-node in the QuestionTree */
export enum QuestionTreeNodeType {
  Overview = 'OVERVIEW',
  Question = 'QUESTION',
  Section = 'SECTION',
  Selection = 'SELECTION',
  Set = 'SET',
  Sub = 'SUB'
}

/** Valid Question types */
export enum QuestionType {
  Blanks = 'BLANKS',
  Extended = 'EXTENDED',
  Hotspot = 'HOTSPOT',
  Matching = 'MATCHING',
  Mcq = 'MCQ',
  Numerical = 'NUMERICAL',
  Overview = 'OVERVIEW',
  Section = 'SECTION',
  Short = 'SHORT',
  Sub = 'SUB',
  Truefalse = 'TRUEFALSE'
}

export type QuestionVersion = {
  __typename?: 'QuestionVersion';
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  childrenQuestions: Array<QuestionVersion>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  order: Maybe<Scalars['Int']['output']>;
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  shortPrompt: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
};

export type RegenerateQuestionSetInput = {
  allowOverlappingSets: InputMaybe<Scalars['Boolean']['input']>;
  questionSetId: Scalars['ID']['input'];
  questionSetQuestionIds: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RegenerateQuestionSetPayload = {
  __typename?: 'RegenerateQuestionSetPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** Updated Question Set. May be nil if the replacement set is incomplete. */
  questionSet: Maybe<QuestionSet>;
};

export type RegisterQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

/** Return type for cancelRelease mutation. */
export type ReleaseAssessmentPayload = {
  __typename?: 'ReleaseAssessmentPayload';
  assessment: Assessment;
  sheets: Array<Sheet>;
};

export type ReleaseFeedbackForEveryonePayload = {
  __typename?: 'ReleaseFeedbackForEveryonePayload';
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type RemoveQuestionsUniformlyInput = {
  /** ID of the Question Selection to remove questions from */
  questionSelectionId: Scalars['ID']['input'];
  /** List of selected question set question IDs to remove. These questions will be used to determine which questions to remove from the other sets. */
  questionSetQuestionIds: Array<Scalars['ID']['input']>;
};

export type ReplaceQuestionInSetInput = {
  /** ID of the Question to use as replacement */
  questionId: Scalars['ID']['input'];
  /** ID of the Question Set to update */
  questionSetId: Scalars['ID']['input'];
  /** ID of the QuestionSetQuestion to update */
  questionSetQuestionId: Scalars['ID']['input'];
  /** ID of the specific Question Version to use as replacement (optional) */
  questionVersionId: InputMaybe<Scalars['ID']['input']>;
};

/** Assessment Task requirements. */
export type Requirements = {
  __typename?: 'Requirements';
  /** Allow the use of Generative AI or not. */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is selected. */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Drafting due date with Institution timezone */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view draft similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  draftSViewReports: Scalars['Int']['output'];
  /** Final due date with Institution timezone. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Has the set of requirements been altered by a user?
   *
   * This checks whether we have saved any requirements against the assessment
   */
  hasChanged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** Restrict student result view in LMS marking tool. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  noDraft: Scalars['Boolean']['output'];
  noExamFeedbackDate: Scalars['Boolean']['output'];
  noExamReadingTime: Scalars['Boolean']['output'];
  noLimit: Scalars['Boolean']['output'];
  noReferencing: Scalars['Boolean']['output'];
  /** Do students need to work in a limited time window */
  noTimeLimit: Scalars['Boolean']['output'];
  noWeight: Scalars['Boolean']['output'];
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** If student result view is restricted. */
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  /** Final grade and feedback return date date with Institution timezone. */
  returnDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view final similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  sViewReports: Scalars['Int']['output'];
  /** Allowed working time in minutes */
  timeLimit: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type RequirementsInput = {
  allowGenerativeAi: InputMaybe<Scalars['Boolean']['input']>;
  allowLateResubmission: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType: InputMaybe<AssessmentType>;
  countFootnotes: InputMaybe<Scalars['Boolean']['input']>;
  countReferences: InputMaybe<Scalars['Boolean']['input']>;
  disableExamBacktrack: InputMaybe<Scalars['Boolean']['input']>;
  disableSpellCheck: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate: InputMaybe<Scalars['DateTime']['input']>;
  draftSViewReports: InputMaybe<Scalars['Int']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  enableExamAccessCode: InputMaybe<Scalars['Boolean']['input']>;
  enableExamAutoSubmission: InputMaybe<Scalars['Boolean']['input']>;
  enableExamLdb: InputMaybe<Scalars['Boolean']['input']>;
  enableSubmissionPdf: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examFeedbackDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming: InputMaybe<ExamTiming>;
  examType: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  gradingService: InputMaybe<Scalars['String']['input']>;
  lateSubmissionTimeLimit: InputMaybe<Scalars['Int']['input']>;
  markingToolPdf: InputMaybe<MarkingToolPdf>;
  maxGrade: InputMaybe<Scalars['Int']['input']>;
  noDraft: InputMaybe<Scalars['Boolean']['input']>;
  noExamFeedbackDate: InputMaybe<Scalars['Boolean']['input']>;
  noExamReadingTime: InputMaybe<Scalars['Boolean']['input']>;
  noLimit: InputMaybe<Scalars['Boolean']['input']>;
  noReferencing: InputMaybe<Scalars['Boolean']['input']>;
  noTimeLimit: InputMaybe<Scalars['Boolean']['input']>;
  noWeight: InputMaybe<Scalars['Boolean']['input']>;
  referencingStyle: InputMaybe<Scalars['String']['input']>;
  restrictMarkingToolPdf: InputMaybe<Scalars['Boolean']['input']>;
  returnDate: InputMaybe<Scalars['DateTime']['input']>;
  sViewReports: InputMaybe<Scalars['Int']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  weight: InputMaybe<Scalars['Float']['input']>;
  wordLimit: InputMaybe<Scalars['Int']['input']>;
};

export type ResetQuestionModerationChangesPayload = {
  __typename?: 'ResetQuestionModerationChangesPayload';
  fieldRubrics: Array<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubrics: Array<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetRubricOutcomeForFieldPayload = {
  __typename?: 'ResetRubricOutcomeForFieldPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomeForSubmissionPayload = {
  __typename?: 'ResetRubricOutcomeForSubmissionPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type ResetScoreModerationChangesPayload = {
  __typename?: 'ResetScoreModerationChangesPayload';
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** A Task resource. */
export type Resource = {
  __typename?: 'Resource';
  /** File size in bytes */
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invalidated: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Additional notes on this resource */
  notes: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Response declaration for a question field. */
export type ResponseDeclaration = {
  __typename?: 'ResponseDeclaration';
  /** Data type of the student response */
  baseType: Maybe<BaseType>;
  /** How many correct answers expected */
  cardinality: Maybe<Cardinality>;
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  correctAreas: Array<PositionArea>;
  correctRanges: Array<NumericRange>;
  correctValues: Array<Scalars['String']['output']>;
  /** Accepted margin of error */
  errorMargin: Maybe<Scalars['Float']['output']>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseDeclarationInput = {
  baseType: InputMaybe<BaseType>;
  caseSensitive: InputMaybe<Scalars['Boolean']['input']>;
  correctAreas: InputMaybe<Array<PositionAreaInput>>;
  correctRanges: InputMaybe<Array<NumericRangeInput>>;
  correctValues: Array<Scalars['String']['input']>;
  errorMargin: InputMaybe<Scalars['Float']['input']>;
  matchSimilarity: InputMaybe<Scalars['Float']['input']>;
  partialScoring: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Gradebook Result. */
export type Result = {
  __typename?: 'Result';
  /** Canvas LTI API url for a successfully recorded submission in Canvas. */
  canvasResultUrl: Maybe<Scalars['String']['output']>;
  /**
   * Find the last access summary for launching this result with the configured
   * external grading service.
   */
  feedbackAccess: Maybe<AccessSummary>;
  /** Grade information on the Result. */
  grade: Maybe<Grade>;
  /** Connection to Hera for a successfully recorded submission in Hera and Turnitin. */
  heraResultId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Is the hera connection complete?
   * @deprecated Use receipt edge instead.
   */
  isReady: Scalars['Boolean']['output'];
  /** Moodle LTI API url for a successfully recorder submission in Moodle. */
  moodleGraderUrl: Maybe<Scalars['String']['output']>;
  /**
   * Submission pipeline processing receipt for the latest submission made in
   * this Result.
   */
  receipt: Maybe<GradebookReceipt>;
  /** When Student grades were sent to the LMS */
  returnedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Similarity information on the Result. */
  similarity: Maybe<Similarity>;
  /** Latest submission tracked in the Result */
  submission: Maybe<Submission>;
  /** Type of the Submission that the Result belongs to. */
  submissionType: SubmissionType;
  /** ID of the Work that the Result belongs to. */
  workId: Scalars['String']['output'];
};

/** Criterion with fields for reuse */
export type ReuseCriterion = {
  __typename?: 'ReuseCriterion';
  /** Parent MarkerRubric's assessment */
  assessmentName: Scalars['String']['output'];
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Parent MarkerRubric's kind */
  kind: MarkerRubricKind;
  maxScore: Maybe<Scalars['Int']['output']>;
  /** Parent MarkerRubric's published_at */
  publishedAt: Scalars['DateTime']['output'];
  scaleItems: Array<ScaleItem>;
  skill: LearningOutcomeSkill;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept the charter agreement */
  acceptStudentCharter: CharterAgreement;
  /**
   * Add questions from library to the task.
   *
   * Returns newly created TaskBlocks with library questions' data copied over.
   */
  addLibraryQuestionsToTask: Array<TaskBlock>;
  /** Add questions from question bank as TaskBlocks */
  addQuestionBanksToAssessment: Array<TaskBlock>;
  /**
   * Add question selection to the task which will allow to use question sets.
   *
   * Returns created TaskBlock with question selection associated with it.
   */
  addQuestionSelectionToTask: TaskBlock;
  /** Add a tag to an enrollment */
  addTag: Tag;
  /** Append groups using group setup rules for an assessment. */
  appendGroups: Array<Group>;
  /** Append tags to the questions in given questions set, if tag's name doesn't exist in question */
  appendTagsForQuestions: Array<Question>;
  archiveQuestion: Maybe<Question>;
  assignMarkerToGroups: Maybe<Array<Group>>;
  /** Auto fill groups with students */
  autoAssignGroups: Maybe<Array<Group>>;
  /** Add a tag to multiple enrollments. */
  bulkAddTag: Array<Tag>;
  /** Remove a tag from multiple enrollments. */
  bulkRemoveTag: Scalars['Boolean']['output'];
  /** Cancel an existing Instruction Sheet release. */
  cancelRelease: CancelReleasePayload;
  /** Update user settings in a Subject context during an onboarding flow. */
  captureOnboardingInput: OnboardingPayload;
  /**
   * Finalise all submitted Criterion selection against the current student's
   * peers in the group.
   */
  completePeerOutcomes: Array<PeerOutcome>;
  /**
   * Copy Assessment accessories, which include resources, state and
   * settings from another assessment.
   */
  copyAssessment: Task;
  copyQuestion: Question;
  /** Create an attachment from an answer block. */
  createBlockAttachment: BlockAttachment;
  /** Create a draft Charter Form */
  createCharterForm: CharterForm;
  /** Create a new comment under a thread. */
  createComment: Comment;
  /** Register a file imported for question bank as an origin */
  createFileOrigin: QuestionBankFileOrigin;
  /** Create Marker Rubric via Cadmus Grader */
  createGraderMarkerRubric: CreateGraderMarkerRubricPayload;
  /** Create a new group. */
  createGroup: Group;
  /** Create multiple groups. */
  createGroups: Array<Group>;
  /** Create Marker Rubric */
  createMarkerRubric: MarkerRubric;
  createPrintArchive: Scalars['String']['output'];
  /**
   * Create a new question in the question library. It's possible to add an
   * array of children question for SUB question type. Returns the array of
   * questions created.
   */
  createQuestion: Question;
  /** Create a new question bank */
  createQuestionBank: QuestionBank;
  /** Create a new question bank category */
  createQuestionBankCategory: QuestionBankCategory;
  /** Create Marker Rubric for MFA Question via Task Builder */
  createQuestionMarkerRubric: CreateQuestionMarkerRubricPayload;
  /** Create a new Question Selection with pre-generated Question Sets */
  createQuestionSelection: CreateQuestionSelectionPayload;
  /** Create a new Link/Url Resource. */
  createResource: Resource;
  /** Create Skill */
  createSkill: LearningOutcomeSkill;
  /** Create tag with given name */
  createTag: QuestionTag;
  /** Creating a task block */
  createTaskBlock: TaskBlock;
  /**
   * Save new Task instructions for the given Assessment.
   * @deprecated Use `create_task_save_v2` instead
   */
  createTaskSave: SaveState;
  /** Save new Task instructions. */
  createTaskSaveV2: SaveState;
  /** Create a new thread. */
  createThread: Thread;
  /** Delete an existing group. */
  deleteGroup: Scalars['Boolean']['output'];
  /** Delete a member from a group. */
  deleteGroupMember: Maybe<DeletedMember>;
  /** Delete multiple groups. */
  deleteGroups: Maybe<Scalars['Int']['output']>;
  /** Invalidate an existing Link/Url Resource. */
  deleteResource: Resource;
  /** Delete a thread. */
  deleteThread: Thread;
  /** Generate a pre-signed download URL for the given save */
  downloadSavePdf: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given submissions in the
   * Assessment.
   */
  downloadSubmissions: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work artifacts ids and filenames.
   * Single artifact will download a pdf. Multiple will create a presigned url for zip.
   */
  downloadWorkArtifacts: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work file attachments.
   * Single attachment will download the file. Multiple will create a presigned url for zip.
   */
  downloadWorkAttachments: Scalars['String']['output'];
  /** Duplicating a task block and children task blocks */
  duplicateTaskBlock: Array<TaskBlock>;
  /** Edit an existing comment. */
  editComment: Comment;
  /**
   * Change Task status to editing.
   * @deprecated Use `edit_task_v2` instead
   */
  editTask: Task;
  /** Change Task status to editing. */
  editTaskV2: Task;
  /** Edit an existing thread's title. */
  editThreadTitle: Thread;
  /**
   * Select similar questions that can be used to replace the given questions
   * in the selection.
   *
   * Similar questions are selected based on question type and points. Tags can
   * be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  findSimilarQuestions: SimilarQuestionsPayload;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissions: Array<Result>;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissionsV2: Array<Result>;
  /** Generate Assessment and Student reports. */
  generateReport: Job;
  /**
   * Imports library question to the task block. If :question_version_id is not provided,
   * the task block will be populated with the :current_version of the library question.
   *
   * Returns the updated TaskBlock with library question references set.
   */
  importLibraryQuestion: TaskBlock;
  /** Queue a RosterSyncing background job for the Assessment. */
  insertSyncRosterJob: BackgroundJob;
  /** Join an existing group as a student */
  joinGroup: Group;
  /** Leave group as a student */
  leaveGroup: Group;
  /** Link a comment thread to a marking criterion. */
  linkCommentThread: Thread;
  /** Marking a Field Outcome for Marker Rubric. */
  markFieldOutcome: MarkFieldOutcomePayload;
  /** Mark a Peer student as the current student. */
  markPeerOutcome: PeerOutcome;
  /** Mark a SubmissionOutcome connected to a MarkOutcome, optionally using a Rubric. */
  markSubmissionOutcome: MarkSubmissionOutcomePayload;
  /** Publish a Charter Form */
  publishCharterForm: CharterForm;
  /** Import questions to the Question Library */
  publishImportedQuestions: Array<Question>;
  /** Publish Marker Rubric */
  publishMarkerRubric: MarkerRubric;
  /**
   * Update Question Set by replacing its questions with similar ones.
   *
   * Similar questions are selected based on the rules of the original set. If
   * no rules were defined, similar questions are selected based on the
   * question type and points. Tags can be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  regenerateQuestionSet: RegenerateQuestionSetPayload;
  /** Register the source file with the given path and name */
  registerQuestionSourceFile: QuestionSourceFile;
  /** Release the Assessment, releasing all Tasks and publishing draft MarkerRubrics. */
  releaseAssessment: ReleaseAssessmentPayload;
  releaseFeedbackForEveryone: ReleaseFeedbackForEveryonePayload;
  /** Release the given Task, returning a new latest Instruction Sheet. */
  releaseTask: Sheet;
  /** Remove an attachment from an AnswerBlock. */
  removeBlockAttachment: BlockAttachment;
  /** Remove Marker Rubric */
  removeMarkerRubric: MarkerRubric;
  /** Remove outcomes for marker rubric */
  removeMarkerRubricOutcomes: OutcomesDeletedPayload;
  /** remove a question bank category */
  removeQuestionBankCategory: Maybe<Scalars['Boolean']['output']>;
  /**
   * Remove questions uniformly across all sets in a Question Selection.
   *
   * This mutation removes the same number of questions from each set based on
   * the similarity rules derived from the provided Question Set Questions. If
   * no explicit Question Selection Rule rules are defined, the removal is
   * guided by matching question type and points.
   */
  removeQuestionsUniformly: QuestionSelection;
  /** Remove a tag from an enrollment */
  removeTag: Scalars['Boolean']['output'];
  /** Replace a question in a Question Set with another question. */
  replaceQuestionInSet: QuestionSet;
  /** Reset all the student's given peer evaluation outcomes. */
  resetCriterionOutcomes: Scalars['Int']['output'];
  /** Remove all unexecuted feedback release rules for an assessment. */
  resetFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  /** Delete all groups in an assessment. */
  resetGroups: Scalars['Boolean']['output'];
  /** Reset any un-published changes on the Marker Rubric. */
  resetMarkerRubric: MarkerRubric;
  resetModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Reset all moderation changes made against marking rubrics for all questions. */
  resetQuestionModerationChanges: ResetQuestionModerationChangesPayload;
  /** Reset rubric outcome and related field outcomes from marker rubric */
  resetRubricOutcomeForField: ResetRubricOutcomeForFieldPayload;
  /** Reset rubric outcome and related submission outcomes from marker rubric */
  resetRubricOutcomeForSubmission: ResetRubricOutcomeForSubmissionPayload;
  /** Reset all moderation changes made against the scores of the work outcomes. */
  resetScoreModerationChanges: ResetScoreModerationChangesPayload;
  /** Resolve messages by their IDs. */
  resolveMessages: Array<Message>;
  /** Cloud save for a Work. */
  save: Save;
  /** Save a new block snapshot against an answer block. */
  saveBlockSnapshot: SaveBlockSnapshotResponse;
  /**
   * Save the editor state by updating the `snapshot_doc`
   *     and `snapshot_version`
   */
  saveCharterEditor: CharterEditor;
  /** Save Institution wide settings for the current user. */
  saveGlobalUserSettings: SaveGlobalUserSettingsPayload;
  /** Append new state to the question in a task block */
  saveQuestionState: Question;
  /**
   * Send emails to students in class with a work artifact.
   *
   * This mutation is used by the teacher to batch send Automarked PDF (`complete_pdf`s)
   * to students in their class. The submission ids are provided by the client.
   */
  sendEmailsToClass: Scalars['String']['output'];
  /** Create a new pending message in the Assessment. */
  sendMessage: Message;
  /** Create or update a Access code */
  setupAccessCode: AccessCode;
  /** Create or access the latest student Group Charter. */
  setupCharter: Charter;
  /** Setup Work document for a finalised Student group. */
  setupGroupWork: WorkGroup;
  /** Initial wizard flow setup for groups in an assessment. */
  setupGroups: Array<Group>;
  /** Create a new Task for the given Assessment. */
  setupTask: Task;
  snapshotFieldOutcome: FieldOutcome;
  /** Save new snapshot for a SubmissionOutcome feedback. */
  snapshotSubmissionOutcome: SubmissionOutcome;
  /** Mark start of a work with time limit. */
  start: Work;
  /** Draft or final Submission. */
  submit: Submission;
  /** Make a server-side submission attempt. */
  submitAttempt: Result;
  /** Submit a new sentiment check */
  submitSentimentCheck: SentimentCheck;
  /** Draft or final Submission (v2) */
  submitV2: Submission;
  /** Swap the order of two Resources. */
  swapResource: Scalars['Boolean']['output'];
  /**
   * Pass all existing final grades to the source LMS of an Assessment.
   *
   * This process happens asynchronously in the background, while the mutation
   * returns immediately.
   */
  syncGrades: Maybe<Scalars['Boolean']['output']>;
  /**
   * Perform a Roster Sync with the source LMS of an Assessment.
   *
   * Returns the list of new enrollments created, if any. The roster sync will
   * fail if the source LMS does not support it or has not provided service
   * params to sync with.
   */
  syncRoster: Array<Maybe<Enrollment>>;
  /** Unlink a comment thread from its current marking criterion. */
  unlinkCommentThread: Thread;
  /** Unlink library question references from the task block. */
  unlinkLibraryQuestion: TaskBlock;
  /** Unlock the charter agreement */
  unlockStudentCharter: CharterAgreement;
  /** Unsubmission, which is really to allow Re-submissions. */
  unsubmit: Submission;
  /** Update a existing answer block. */
  updateAnswerBlock: AnswerBlock;
  /** Update an Assessment name. */
  updateAssessmentName: Assessment;
  updateAssessmentSettings: Assessment;
  /** Update an existing Charter Form and its fields */
  updateCharterForm: CharterForm;
  /**
   * Update enrollment status(deleted/withdrawn) of a list of enrollment ids on an assessment.
   *
   * This mutation is used by the Teacher to batch withdrawn/un-withdrawn students from the classlist
   * due to the fact that NRPS is not returning the right list of students on some LMS
   */
  updateEnrollmentsStatus: Array<Enrollment>;
  /** Update the cadmus experience survey score. */
  updateExperience: Survey;
  /** Update assessment's feedback release rules as a whole. */
  updateFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  updateFeedbackVisibility: FeedbackVisibility;
  /** Update the marking rubric user for a single field. */
  updateFieldRubricResponse: UpdateFieldRubricPayload;
  /** Update a file origin name */
  updateFileOrigin: QuestionBankFileOrigin;
  /** Update an existing group. */
  updateGroup: Group;
  /**
   * Bulk update user memberships across multiple existing groups.
   *
   * Returns the new complete list of an Assessment's marking groups.
   */
  updateGroupMemberships: Array<Group>;
  /** Updates the existing Insights Mailing List for the given assessment. */
  updateInsightsMailingList: MailingList;
  /** Update Marker Rubric */
  updateMarkerRubric: MarkerRubric;
  /** Upsert the milestones of a charter */
  updateMilestones: Charter;
  updateModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Update all project issues for a Student Group to reflect the latest input state. */
  updateProjectIssue: Array<ProjectIssue>;
  updateQuestion: Question;
  /** Bulk edit attributes questions without creating a new version. */
  updateQuestionAttributes: Array<Question>;
  /** Update a question bank */
  updateQuestionBank: QuestionBank;
  /** Update (set or remove) category of a list of question banks */
  updateQuestionBanksCategory: Array<QuestionBank>;
  /**
   * Update automarking conditions for a question.
   *
   * This mutation updates automark settings at the question level, which are applied
   * to all field rubrics within the given question rubric.
   *
   * Changes trigger recalculation of student outcomes.
   */
  updateQuestionRubric: UpdateQuestionRubricPayload;
  /** Update a source file name */
  updateQuestionSourceFile: QuestionSourceFile;
  /** Update a question to save a new version */
  updateQuestionVersion: Question;
  /** Partial Requirements update. */
  updateRequirements: Requirements;
  /** Update an existing Link/Url Resource. */
  updateResource: Resource;
  /** Update the moderator modifier score on a student outcome. */
  updateStudentOutcomeScore: UpdateStudentOutcomeScorePayload;
  /** Batch update student settings. */
  updateStudentSettings: Array<Maybe<WorkSettings>>;
  /** Update all tags for a question */
  updateTagsForQuestion: Question;
  /** Update TaskBlock attributes */
  updateTaskBlock: TaskBlock;
  /** Update TaskBlocks ordering/deleted flag. Returns the updated TaskBlock */
  updateTaskBlocks: Array<TaskBlock>;
  /** Update Task Format. */
  updateTaskFormat: Task;
  /** Update thread resolution status. */
  updateThreadResolution: Thread;
  /** Update the moderator modifier score on a work outcome. */
  updateWorkOutcomeScore: UpdateWorkOutcomeScorePayload;
  /** Update a Work's settings. */
  updateWorkSettings: WorkSettings;
  verifyAccessCode: Session;
  /**
   * Withdraw feedback for the Students. Withdraws all `final`
   * WorkOutcomeReleases for the Student and Student's Group
   * (if applicable). Removes grades from the Gradebook.Result
   * for the Students.
   */
  withdrawFeedback: Array<StudentOutcome>;
};


export type RootMutationTypeAcceptStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeAddLibraryQuestionsToTaskArgs = {
  questionIds: Array<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionBanksToAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: Array<AddQuestionBanksToAssessmentInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionSelectionToTaskArgs = {
  questionSelectionId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeAppendGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  userIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeAppendTagsForQuestionsArgs = {
  input: Array<TagInput>;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeArchiveQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignMarkerToGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  markerId: Scalars['ID']['input'];
};


export type RootMutationTypeAutoAssignGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeBulkAddTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeBulkRemoveTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeCancelReleaseArgs = {
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCaptureOnboardingInputArgs = {
  discipline: InputMaybe<Discipline>;
  subjectId: Scalars['ID']['input'];
  subjectRole: InputMaybe<SubjectRole>;
};


export type RootMutationTypeCompletePeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyAssessmentArgs = {
  destinationAssessmentId: Scalars['ID']['input'];
  sourceInstructionSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateBlockAttachmentArgs = {
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCommentArgs = {
  content: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateFileOriginArgs = {
  input: CreateQuestionBankFileOriginInput;
};


export type RootMutationTypeCreateGraderMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateGraderMarkerRubricInput;
};


export type RootMutationTypeCreateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupInput;
};


export type RootMutationTypeCreateGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput>;
};


export type RootMutationTypeCreateMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateMarkerRubricInput;
};


export type RootMutationTypeCreatePrintArchiveArgs = {
  input: PrintArchiveInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes>>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
  tags: InputMaybe<Array<TagInput>>;
};


export type RootMutationTypeCreateQuestionBankArgs = {
  questionBank: CreateQuestionBankInput;
};


export type RootMutationTypeCreateQuestionBankCategoryArgs = {
  input: QuestionBankCategoryInput;
};


export type RootMutationTypeCreateQuestionMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateQuestionMarkerRubricInput;
};


export type RootMutationTypeCreateQuestionSelectionArgs = {
  input: QuestionSelectionInput;
};


export type RootMutationTypeCreateResourceArgs = {
  assessmentId: Scalars['ID']['input'];
  fileSize: InputMaybe<Scalars['Int']['input']>;
  mediaId: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};


export type RootMutationTypeCreateSkillArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
};


export type RootMutationTypeCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeCreateTaskBlockArgs = {
  input: InputMaybe<CreateTaskBlockInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTaskSaveArgs = {
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTaskSaveV2Args = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateThreadArgs = {
  input: ThreadInput;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupMemberArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSavePdfArgs = {
  saveId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
  submissions: Array<SubmissionDetailInput>;
};


export type RootMutationTypeDownloadWorkArtifactsArgs = {
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput>;
};


export type RootMutationTypeDownloadWorkAttachmentsArgs = {
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDuplicateTaskBlockArgs = {
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type RootMutationTypeEditTaskArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeEditTaskV2Args = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeEditThreadTitleArgs = {
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeFindSimilarQuestionsArgs = {
  input: FindSimilarQuestionsInput;
};


export type RootMutationTypeForceSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeForceSubmissionsV2Args = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeGenerateReportArgs = {
  anonymousName: InputMaybe<Scalars['String']['input']>;
  assessmentId: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeImportLibraryQuestionArgs = {
  input: ImportLibraryQuestionInput;
};


export type RootMutationTypeInsertSyncRosterJobArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeJoinGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLeaveGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkFieldOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
};


export type RootMutationTypeMarkPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
};


export type RootMutationTypeMarkSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
};


export type RootMutationTypePublishCharterFormArgs = {
  charterFormId: Scalars['ID']['input'];
};


export type RootMutationTypePublishImportedQuestionsArgs = {
  input: PublishImportedQuestionsInput;
};


export type RootMutationTypePublishMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRegenerateQuestionSetArgs = {
  input: RegenerateQuestionSetInput;
};


export type RootMutationTypeRegisterQuestionSourceFileArgs = {
  input: RegisterQuestionSourceFileInput;
};


export type RootMutationTypeReleaseAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeReleaseFeedbackForEveryoneArgs = {
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeReleaseTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<Scalars['ReleaseType']['input']>;
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeRemoveBlockAttachmentArgs = {
  blockAttachmentId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricOutcomesArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionBankCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionsUniformlyArgs = {
  input: RemoveQuestionsUniformlyInput;
};


export type RootMutationTypeRemoveTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeReplaceQuestionInSetArgs = {
  input: ReplaceQuestionInSetInput;
};


export type RootMutationTypeResetCriterionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeResetGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetQuestionModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForFieldArgs = {
  assessmentId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeResetScoreModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResolveMessagesArgs = {
  assessmentId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeSaveArgs = {
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  editor: InputMaybe<EditorType>;
  metadata: InputMaybe<SaveMetadataInput>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveBlockSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  wordCountChange: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveCharterEditorArgs = {
  input: CharterEditorInput;
};


export type RootMutationTypeSaveGlobalUserSettingsArgs = {
  userSettingsInput: GlobalUserSettingsInput;
};


export type RootMutationTypeSaveQuestionStateArgs = {
  input: SaveQuestionStateInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeSendEmailsToClassArgs = {
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeSendMessageArgs = {
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
};


export type RootMutationTypeSetupAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AccessCodeInput;
};


export type RootMutationTypeSetupCharterArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupWorkArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
};


export type RootMutationTypeSetupTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
};


export type RootMutationTypeSnapshotFieldOutcomeArgs = {
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
};


export type RootMutationTypeSnapshotSubmissionOutcomeArgs = {
  input: SnapshotSubmissionOutcomeInput;
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeStartArgs = {
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitArgs = {
  acceptedDeclaration: Scalars['Boolean']['input'];
  editor: InputMaybe<EditorType>;
  saveId: Scalars['ID']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptArgs = {
  attemptNumber: Scalars['Int']['input'];
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitSentimentCheckArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
};


export type RootMutationTypeSubmitV2Args = {
  blockSnapshotIds: Array<Scalars['ID']['input']>;
  forceSubmitted: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSwapResourceArgs = {
  firstId: Scalars['ID']['input'];
  secondId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncGradesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncRosterArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeUnlinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkLibraryQuestionArgs = {
  input: UnlinkLibraryQuestionInput;
};


export type RootMutationTypeUnlockStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeUnsubmitArgs = {
  submissionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
};


export type RootMutationTypeUpdateAssessmentNameArgs = {
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeUpdateAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
};


export type RootMutationTypeUpdateCharterFormArgs = {
  input: CharterFormInput;
};


export type RootMutationTypeUpdateEnrollmentsStatusArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentIds: Array<Scalars['ID']['input']>;
  withdrawn: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateExperienceArgs = {
  score: Scalars['Int']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
  rules: Array<FeedbackReleaseRuleInput>;
};


export type RootMutationTypeUpdateFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeUpdateFieldRubricResponseArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
};


export type RootMutationTypeUpdateFileOriginArgs = {
  input: UpdateQuestionBankFileOriginInput;
};


export type RootMutationTypeUpdateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
};


export type RootMutationTypeUpdateGroupMembershipsArgs = {
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput>;
};


export type RootMutationTypeUpdateInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
  members: Array<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateMilestonesArgs = {
  input: UpdateMilestonesInput;
};


export type RootMutationTypeUpdateModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput>;
};


export type RootMutationTypeUpdateProjectIssueArgs = {
  input: UpdateProjectIssueInput;
};


export type RootMutationTypeUpdateQuestionArgs = {
  input: QuestionAttributesInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateQuestionAttributesArgs = {
  input: QuestionAttributesInput;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateQuestionBankArgs = {
  questionBank: UpdateQuestionBankInput;
};


export type RootMutationTypeUpdateQuestionBanksCategoryArgs = {
  input: UpdateQuestionBanksCategoryInput;
};


export type RootMutationTypeUpdateQuestionRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
};


export type RootMutationTypeUpdateQuestionSourceFileArgs = {
  input: UpdateQuestionSourceFileInput;
};


export type RootMutationTypeUpdateQuestionVersionArgs = {
  childrenQuestions: InputMaybe<Array<UpdateQuestionVersionInput>>;
  input: UpdateQuestionVersionInput;
};


export type RootMutationTypeUpdateRequirementsArgs = {
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
};


export type RootMutationTypeUpdateResourceArgs = {
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateStudentOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
  studentId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStudentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>>;
};


export type RootMutationTypeUpdateTagsForQuestionArgs = {
  input: Array<TagInput>;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlockArgs = {
  input: UpdateTaskBlockInput;
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlocksArgs = {
  taskBlockList: Array<UpdateTaskBlocksInput>;
};


export type RootMutationTypeUpdateTaskFormatArgs = {
  format: TaskFormat;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateThreadResolutionArgs = {
  resolved: Scalars['Boolean']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateWorkOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
};


export type RootMutationTypeUpdateWorkSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  draftExamEndDate: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentId: Scalars['ID']['input'];
  examDeferred: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  updateReason: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeVerifyAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type RootMutationTypeWithdrawFeedbackArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Token to use for making API calls to all Cadmus services */
  apiToken: Scalars['String']['output'];
  /** A single assessment. */
  assessment: Assessment;
  assessmentAccessCodes: Maybe<Array<AccessCode>>;
  /** All Student Group Charter documents in the Assessment. */
  assessmentCharters: Array<Charter>;
  assessmentProjectIssues: Array<ProjectIssue>;
  /** List all Sentiment Checks submitted by students in an Assessment. */
  assessmentSentimentChecks: Array<SentimentCheck>;
  /** Lookup existing background job. */
  backgroundJob: Maybe<BackgroundJob>;
  /** Access the Brightspace REST API as the current user via OAuth2 interface. */
  brightspaceApi: BrightspaceApi;
  /** Access the Canvas REST API as the current user via OAuth2 interface. */
  canvasApi: CanvasApi;
  /** Student group charter document */
  charter: Charter;
  /** Assessment's Group Charter form (draft or published) */
  charterForm: Maybe<CharterForm>;
  /** Complete Class information for an Assessment's cohort. */
  class: Class;
  /**
   * A full Class list for the given Assessment.
   * @deprecated Use `class` query field instead
   */
  classList: ClassList;
  /** All Peer Outcomes in a Class, for teacher eyes only. */
  classPeerOutcomes: Array<PeerOutcome>;
  /** All Work Groups in a Group Assessment. */
  classWorkGroups: Array<WorkGroup>;
  /** Reusing Scale Items by Skill */
  criteriaBySkill: Array<ReuseCriterion>;
  /** Fetch threads by entity ID and type. */
  entityThreads: Array<Thread>;
  /** MarkerRubric lookup by ID and document status. */
  extendedRubric: Maybe<MarkerRubric>;
  /** Feature flags enabled in the user's context. */
  featureFlags: InstitutionFeatures;
  /** Feedback Release Rule: schedule feedback release based on filters. */
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  /**
   * feedback visibility for assessment
   * @deprecated Use `feedback_visibility_for_type` instead
   */
  feedbackVisibility: FeedbackVisibility;
  /** feedback visibility for assessment */
  feedbackVisibilityForType: FeedbackVisibility;
  /** Future scheduled Instruction sheet, if any */
  futureSheet: Maybe<Sheet>;
  groupList: Array<Group>;
  /** Peer Outcomes for members of a Student Group. */
  groupPeerOutcomes: Array<PeerOutcome>;
  /** List Sentiment Checks submitted by students in a group. */
  groupSentimentChecks: Array<SentimentCheck>;
  /** Work Outcome for a Student Group in an assessment. */
  groupWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Groups for assessment.
   * @deprecated Use `class` query field instead
   */
  groups: Array<Group>;
  /**
   * Assessment's latest Insights mailing list consisting of teacher emails who
   * want to receive Insight updates via email.
   */
  insightsMailingList: MailingList;
  /** Current user Institution. */
  institution: Institution;
  /** InstructionSheet within an Assessment defaulting to the latest. */
  instructionSheet: Maybe<Sheet>;
  /**
   * Latest Gradebook result for a particular submission type.
   *
   * This field always tries to resolve to the most up to date information, and
   * can also query Hera (and in turn Turnitin) to get it.
   */
  latestResult: Result;
  /** List of lecturers for an assessment */
  lecturers: Array<User>;
  /** Lists all library questions viewable by the current user. */
  libraryQuestions: Array<Question>;
  /** MarkerRubric lookup in an Assessment for a given kind and document status. */
  markerRubric: Maybe<MarkerRubric>;
  /** Current logged in User profile */
  me: User;
  /** List messages receivable by current user. */
  messageInbox: Array<Message>;
  /** Moderation Penalty Rule: penalties to apply on feedback release. */
  moderationPenaltyRules: Maybe<Array<ModerationPenaltyRule>>;
  /** Past instruction sheets that the user has been involved in. */
  pastInstructionSheets: Array<PastInstructionSheet>;
  /** Past Marker Rubrics */
  pastMarkerRubrics: Array<MarkerRubric>;
  /** Peer Rubric for Students */
  peerRubric: Maybe<MarkerRubric>;
  /** URL for a expected PrintInstruction archive, if it is ready. */
  printArchiveUrl: Maybe<Scalars['String']['output']>;
  /** List of issues in a student Group's project board. */
  projectIssues: Array<ProjectIssue>;
  /** Single library published question */
  question: Maybe<Question>;
  questionBankCategories: Array<QuestionBankCategory>;
  questionBanks: Array<QuestionBank>;
  /** Single question rubric. */
  questionRubric: QuestionRubric;
  questionSelection: Maybe<QuestionSelection>;
  /** All Tag categories in the Question Library for the current Tenant */
  questionTagCategories: Array<QuestionTagCategory>;
  /** List of all selected question blocks in the Task. */
  questionTree: Array<QuestionBlock>;
  /** Select a known past Question version */
  questionVersion: Maybe<QuestionVersion>;
  /** Assessment's marking rubrics. */
  rubric: Maybe<Rubric>;
  /** @deprecated Please use :api_token instead, which is more scoped */
  serviceToken: Scalars['String']['output'];
  /** User's session information. */
  session: Session;
  /**
   * Current Session ID tied to the user's authenticated session.
   * @deprecated Please use the `session` field instead.
   */
  sessionId: Scalars['String']['output'];
  /** Learning Outcome Skills for the Tenant. */
  skills: Array<LearningOutcomeSkill>;
  /** Learning Outcome Skills used in the Assessment. */
  skillsByAssessment: Array<LearningOutcomeSkill>;
  /** Student Outcome in an Assessment */
  studentOutcome: StudentOutcome;
  /** Student Outcomes in an Assessment */
  studentOutcomes: Array<StudentOutcome>;
  /** The current student's Peer Outcome in the Assessment. */
  studentPeerOutcome: Maybe<PeerOutcome>;
  /** Current student users' Work Group in the Assessment. */
  studentWorkGroup: Maybe<WorkGroup>;
  /** Work Outcome for a Student in an assessment. */
  studentWorkOutcome: Maybe<WorkOutcome>;
  /** A single assessment task of a specific kind. */
  task: Maybe<Task>;
  /** Fetch a thread by ID. */
  thread: Thread;
  /** Fetch multiple threads by IDs. */
  threads: Array<Thread>;
  /** Token for Current User token authentication with Phoenix channels. */
  token: Scalars['String']['output'];
  /** Lookup complete user settings for an asseessment */
  userSettings: Maybe<UserSettings>;
  /** A single Work. */
  work: Work;
  /** Outcome recorded for a student's work. */
  workOutcome: Maybe<WorkOutcome>;
  /** Work Outcomes in an Assessment. */
  workOutcomes: Array<WorkOutcome>;
};


export type RootQueryTypeApiTokenArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentAccessCodesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentChartersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProjectIssuesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeBackgroundJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type RootQueryTypeBrightspaceApiArgs = {
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};


export type RootQueryTypeCanvasApiArgs = {
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};


export type RootQueryTypeCharterArgs = {
  charterId: Scalars['ID']['input'];
};


export type RootQueryTypeCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClassArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassWorkGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeCriteriaBySkillArgs = {
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type RootQueryTypeEntityThreadsArgs = {
  entityId: InputMaybe<Scalars['ID']['input']>;
  entityIds: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityType;
};


export type RootQueryTypeExtendedRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  status: MarkerRubricStatus;
};


export type RootQueryTypeFeatureFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityForTypeArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: FeedbackReleaseType;
};


export type RootQueryTypeFutureSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
};


export type RootQueryTypeGroupListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInstructionSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  sheetId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeLatestResultArgs = {
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeLecturersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
};


export type RootQueryTypeMessageInboxArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePastMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePeerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePrintArchiveUrlArgs = {
  archiveId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeProjectIssuesArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionBankCategoriesArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionBanksArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionRubricArgs = {
  questionRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionSelectionArgs = {
  questionSelectionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionTreeArgs = {
  selectionInput: Array<QuestionSelectionFilterInput>;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionVersionArgs = {
  questionId: InputMaybe<Scalars['ID']['input']>;
  version: InputMaybe<Scalars['Int']['input']>;
  versionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSkillsByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootQueryTypeThreadsArgs = {
  threadIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeUserSettingsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeWorkArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomeArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Subscribe to updates for AssessmentSettings */
  assessmentSettings: AssessmentSettings;
  /** Notification on number of enrollments updated */
  enrollmentsUpdated: Scalars['Int']['output'];
  /** Subscribe to thread updates for a specific entity (e.g., answer block). Receives lightweight thread lifecycle events. */
  entityThreadsUpdated: EntityThreadEvent;
  /** Subscription for field outcome batch updates. */
  fieldOutcomesUpdated: Maybe<Array<Maybe<FieldOutcome>>>;
  /** Subscription for field_rubric updates. */
  fieldRubricsUpdated: Array<FieldRubric>;
  /** Future sheet release schedule timestamp */
  futureReleaseSchedule: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Subscription for when a group is updated by self enrollment. */
  groupUpdated: Group;
  /** At least one submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  /**
   * A Gradebook Result update in an Assessment.
   * @deprecated Use `results_updated` instead
   */
  resultUpdated: Result;
  /** Multiple Gradebook Results updated in an Assessment. */
  resultsUpdated: Array<Result>;
  /** New Instruction Sheet release. */
  sheetReleased: Sheet;
  /** Subscription for student outcomes updates for an assessment */
  studentOutcomesUpdated: Array<StudentOutcome>;
  /** Subscribe to conversation updates for a specific thread. Receives comment additions, edits, and title changes. */
  threadConversationUpdated: ConversationEvent;
  /** [DEPRECATED] Subscribe to thread updates. Use entity_threads_updated for thread lifecycle events or thread_conversation_updated for comment events. */
  threadUpdated: Thread;
  /**
   * Subscription for work outcome batch updates.
   * @deprecated use `student_outcomes_updated`
   */
  workOutcomesUpdated: Array<WorkOutcome>;
  /** Pdf Artifact created in an assessment. */
  workPdfCreated: WorkArtifact;
  /** Update for a Gradebook result for a particular Work only. */
  workResultUpdated: Result;
  /** Update for a Work Settings. */
  workSettingsUpdated: WorkSettings;
  /** Update for work started */
  workStarted: Work;
  /** A Work has a new submission. */
  workSubmitted: Submission;
  /** A Work has been updated. Usually it's the settings that update for a work. */
  workUpdated: Work;
  /** A list of works' settings has been updated */
  worksSettingsUpdated: Array<Maybe<WorkSettings>>;
  /**
   * Multiple Works were submitted in the assessment.
   * @deprecated Use `results_updated` instead for updates on multiple submissions.
   */
  worksSubmitted: Array<Submission>;
};


export type RootSubscriptionTypeAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEnrollmentsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEntityThreadsUpdatedArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type RootSubscriptionTypeFieldOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFieldRubricsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFutureReleaseScheduleArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeGroupUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeHasSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSheetReleasedArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootSubscriptionTypeStudentOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadConversationUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkPdfCreatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkResultUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSettingsUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkStartedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSubmittedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSubmittedArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** An Assessment's marking rubrics. */
export type Rubric = {
  __typename?: 'Rubric';
  id: Scalars['ID']['output'];
  questions: Array<QuestionRubric>;
};

/** Marking outcome from using a MarkerRubric to score the parent Outcome. */
export type RubricOutcome = {
  __typename?: 'RubricOutcome';
  criterionOutcomes: Array<CriterionOutcome>;
  score: Maybe<Scalars['Float']['output']>;
};

export enum RuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Joint = 'JOINT'
}

/** A Save for a work. */
export type Save = {
  __typename?: 'Save';
  /** Fetched contents of the embedded S3 Store reference. */
  content: Scalars['String']['output'];
  dispatchedAt: Scalars['PreciseDateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Database ID of the persisted save.
   *
   * This always reflects the actual table primary key of the Save, even when the
   * the `:id` value is some constant string. Sometimes the `:id` field has to
   * resolve to a constant string to make the client side cache always hit.
   */
  serverId: Scalars['ID']['output'];
  /** S3 object version ID. */
  version: Scalars['String']['output'];
};

/** Response for saving a block snapshot */
export type SaveBlockSnapshotResponse = {
  __typename?: 'SaveBlockSnapshotResponse';
  blockSnapshot: BlockSnapshot;
};

/** Mutation return for `saveGlobalUserSettings`. */
export type SaveGlobalUserSettingsPayload = {
  __typename?: 'SaveGlobalUserSettingsPayload';
  userSettings: Maybe<UserSettings>;
};

export type SaveMetadataInput = {
  assessmentId: Scalars['String']['input'];
  prevSaveId: InputMaybe<Scalars['String']['input']>;
  prevVersionId: InputMaybe<Scalars['String']['input']>;
  /** @deprecated will be automatically added from session */
  sessionId: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};

/** Question state append attributes */
export type SaveQuestionStateInput = {
  feedback: Scalars['String']['input'];
  /** Question fields with response declaration and interaction type */
  fields: InputMaybe<Array<QuestionFieldInput>>;
  /** Question prompt prosemirror contents */
  promptDoc: InputMaybe<Scalars['String']['input']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
};

/** Latest Task content save. */
export type SaveState = {
  __typename?: 'SaveState';
  /** Latest Task save ID. */
  id: Scalars['ID']['output'];
  /** JSON serialised raw content in this save. */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The persisted TaskState server ID */
  serverId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type ScaleItem = {
  __typename?: 'ScaleItem';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  rangeFrom: Maybe<Scalars['Float']['output']>;
  rangeTo: Maybe<Scalars['Float']['output']>;
  scaleLabel: Maybe<Scalars['String']['output']>;
};

export type ScaleItemInput = {
  description: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  rangeFrom: InputMaybe<Scalars['Int']['input']>;
  rangeTo: InputMaybe<Scalars['Int']['input']>;
  scaleLabel: InputMaybe<Scalars['String']['input']>;
};

/** Score Breakdown */
export type ScoreBreakdown = {
  __typename?: 'ScoreBreakdown';
  automark: Maybe<Scalars['Float']['output']>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  marker: Maybe<Scalars['Float']['output']>;
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

/** A sentiment check */
export type SentimentCheck = {
  __typename?: 'SentimentCheck';
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  level: Maybe<SentimentCheckLevel>;
  order: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  user: User;
};

export type SentimentCheckInput = {
  comment: InputMaybe<Scalars['String']['input']>;
  level: InputMaybe<SentimentCheckLevel>;
  skipped: Scalars['Boolean']['input'];
};

/** Enum of sentiment check levels */
export enum SentimentCheckLevel {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

/** Session information */
export type Session = {
  __typename?: 'Session';
  /** Session ID */
  id: Scalars['ID']['output'];
  /** Verification status for a session tied to an enrollment. */
  verified: Scalars['Boolean']['output'];
};


/** Session information */
export type SessionVerifiedArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type SetupGroupInput = {
  divideEqually: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags: InputMaybe<Array<Scalars['String']['input']>>;
  groupAssessmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  groupRules: InputMaybe<Array<GroupRule>>;
  groupSelfEnrollment: InputMaybe<Scalars['Boolean']['input']>;
  groupSelfEnrollmentDeadline: InputMaybe<Scalars['DateTime']['input']>;
  groupType: GroupType;
  maxLimit: InputMaybe<Scalars['Int']['input']>;
  minLimit: InputMaybe<Scalars['Int']['input']>;
};

export enum Shape {
  Ellipse = 'ellipse',
  Point = 'point',
  Polygon = 'polygon',
  Rectangle = 'rectangle'
}

/** Latest Instruction sheet for an Assessment. */
export type Sheet = {
  __typename?: 'Sheet';
  /** If generative AI is allowed */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is enabled */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  /** Assessment Type */
  assessmentType: AssessmentType;
  /**
   * List of released TaskBlocks in the Sheet
   * @deprecated Use the `question_blocks` field instead
   */
  blocks: Array<TaskBlock>;
  /** If footnotes should be counted as part of the word limit. */
  countFootnotes: Scalars['Boolean']['output'];
  /** If references should be counted as part of the word limit. */
  countReferences: Scalars['Boolean']['output'];
  /**
   * Type of submissions currently being accepted.
   *
   * This can never be `nil` as the `:sheet` should always have a Final due date.
   *
   * Note that the comparison with the draft due date allows a grace period of 1
   * hour.
   * @deprecated Use client side logic to determine submission type based on due dates.
   */
  currentSubmissionType: SubmissionType;
  /** Whether backtrack navigation is disabled in exam */
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  /** Whether students cannot use the Cadmus Spell Check feature. */
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Draft submission due date if drafting is enabled */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Latest setting value for draft_s_view_reports. */
  draftSViewReports: Scalars['Int']['output'];
  /** Final Submission due date. */
  dueDate: Scalars['PreciseDateTime']['output'];
  /** Whether to enable access code for exam */
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  /** Whether to enable exam LDB flow for student */
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Released task format */
  format: TaskFormat;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Task ID for which this sheet is released.
   *
   * NOTE: this is the Task ID and not the actual sheet ID which changes from
   * sheet to sheet. Use `serverId` for the actual sheet ID. This was done for
   * automatic cache replacement in apollo client for new sheets.
   */
  id: Scalars['String']['output'];
  kind: TaskKind;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** If not restricted then the student result view only unmarked or unmarked and automarked. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  /** When the next sheet, if any, will be released. */
  nextReleaseTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  noExamFeedbackDate: Scalars['Boolean']['output'];
  /** Flattened Question Tree */
  questionBlocks: Array<QuestionBlock>;
  /** Serialised Editor contents of the Task body with other embedded metadata */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The style of referencing to be used for the assessment. */
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** When the sheet was released. */
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
  /** List of released resources. */
  resources: Array<Resource>;
  /** Feedback return date. */
  returnDate: Scalars['PreciseDateTime']['output'];
  /** Latest setting value for s_view_reports. */
  sViewReports: Scalars['Int']['output'];
  /** Actual TaskHistory primary ID. */
  serverId: Scalars['ID']['output'];
  /** Source Task ID for the Sheet */
  taskId: Scalars['ID']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  /** Task save version number from which the Sheet was created. */
  version: Scalars['Int']['output'];
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

/** Response as a plain text short phrase. */
export type ShortResponse = {
  __typename?: 'ShortResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  /** Expected answer matches */
  matchPhrases: Maybe<Array<Scalars['String']['output']>>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type ShortResponseInput = {
  caseSensitive: InputMaybe<Scalars['Boolean']['input']>;
  matchPhrases: InputMaybe<Array<Scalars['String']['input']>>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity: InputMaybe<Scalars['Float']['input']>;
};

export type SimilarQuestionsPayload = {
  __typename?: 'SimilarQuestionsPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** List of similar questions found */
  questions: Maybe<Array<Question>>;
};

/**
 * Similarity information for a Result.
 *
 * Currently a Turnitin similarity score is available in the gradebook. This
 * score is a floating point percentage value.
 */
export type Similarity = {
  __typename?: 'Similarity';
  /** Human formatted representation */
  display: Scalars['String']['output'];
  /** Label color for the similarity score */
  label: Scalars['String']['output'];
  /** Actual similarity score value between 0-100 */
  value: Scalars['Float']['output'];
};

export type SimpleChoice = {
  __typename?: 'SimpleChoice';
  content: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type SimpleChoiceInput = {
  content: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type SnapshotFieldOutcomeInput = {
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotSubmissionOutcomeInput = {
  /** 'body' or 'references' */
  blockName: Scalars['String']['input'];
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SourceFileInput = {
  /** Imported file name set by the user */
  filename: InputMaybe<Scalars['String']['input']>;
  /** File path of imported file */
  filepath: InputMaybe<Scalars['String']['input']>;
  /** ID of the file source */
  id: InputMaybe<Scalars['ID']['input']>;
};

/** All possible Task release states. */
export enum Status {
  Editing = 'EDITING',
  Released = 'RELEASED'
}

/** Marking outcome targetting a single student in the assessment. */
export type StudentOutcome = {
  __typename?: 'StudentOutcome';
  base: ComponentBreakdown;
  /** Moderator modifier applied on the final score. */
  final: ComponentBreakdown;
  /**
   * Final calculated score including all penalties and moderator modifiers.
   *
   * Each component is scaled to the AssessmentSetting weights at the time of
   * submission (for Individual and Group WorkOutcomes). Self and Peer Scores
   * depend on the PeerOutcome and AssessmentSettings.
   * @deprecated Use `studentOutcome.base.total.weightedScore` or
   * `studentOutcome.base.final.weightedScore`
   *
   */
  finalScore: Maybe<Scalars['Float']['output']>;
  /**
   * Penalty applied to group WorkOutcome.
   *
   * This penalty can be prospective or a final score if the feedback was
   * released.
   * @deprecated Use `studentOutcome.base.group.penaltyScore` for prospective,
   * Use `studentOutcome.final.group.penaltyScore` for final.
   *
   */
  groupPenalty: Maybe<Scalars['Float']['output']>;
  groupWorkOutcome: Maybe<WorkOutcome>;
  id: Scalars['ID']['output'];
  /**
   * Penalty applied to individual WorkOutcome.
   *
   * This penalty can be prospective or a final score if the feedback was
   * released.
   * @deprecated Use `studentOutcome.base.individual.penaltyScore` for prospective,
   * Use `studentOutcome.final.individual.penaltyScore` for final.
   *
   */
  individualPenalty: Maybe<Scalars['Float']['output']>;
  individualWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Maximum score the student was graded on.
   * @deprecated Use `studentOutcome.base.total.weightedMaxScore`
   */
  maxScore: Scalars['Int']['output'];
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  peerOutcome: Maybe<PeerOutcome>;
  provisional: ComponentBreakdown;
  studentId: Scalars['ID']['output'];
};

/** Input object for updating a student's settings within an assessment context. */
export type StudentSettingsInput = {
  draftExamEndDate: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  examDeferred: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  studentId: Scalars['ID']['input'];
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  updateReason: InputMaybe<Scalars['String']['input']>;
};

/** A Cadmus Subject. */
export type Subject = {
  __typename?: 'Subject';
  discipline: Maybe<Discipline>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SubjectRole {
  ExternalExaminer = 'EXTERNAL_EXAMINER',
  FacultyLeader = 'FACULTY_LEADER',
  LearningDesigner = 'LEARNING_DESIGNER',
  LearningTechnologist = 'LEARNING_TECHNOLOGIST',
  Lecturer = 'LECTURER',
  Marker = 'MARKER',
  Other = 'OTHER',
  SubjectCoordinator = 'SUBJECT_COORDINATOR',
  Tutor = 'TUTOR',
  UniversityLeader = 'UNIVERSITY_LEADER'
}

/** A Final or Draft Submission. */
export type Submission = {
  __typename?: 'Submission';
  /** Attempt number if provided during submission. */
  attemptNumber: Maybe<Scalars['Int']['output']>;
  /** A representation of an answer to a question block */
  blockSnapshots: Array<BlockSnapshot>;
  /**
   * If the submission was forcefully submitted on behalf of the student.
   *
   * Use the `submittedBy` field to know who submitted the submission.
   */
  forceSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Last marking PDF artifact sent to the marking tool. */
  markingPdf: Maybe<WorkArtifact>;
  /** PDF artifact associated for the submission. */
  pdf: Maybe<WorkArtifact>;
  /**
   * Gradebook result on the submission.
   * @deprecated Use Work.result directly instead. Result should be the parent of Submission.
   */
  result: Result;
  /** Save attached to the submission. */
  save: Maybe<Save>;
  submittedAt: Scalars['PreciseDateTime']['output'];
  /**
   * The User who made the submission.
   *
   * If the value is null, the user should be assumed to be the student who owns
   * the Work.
   */
  submittedBy: Maybe<User>;
  /** Type of Submission. */
  type: SubmissionType;
  unsubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadSubmissions mutation to add a submission's PDF to the
 * archive.
 */
export type SubmissionDetailInput = {
  /** Submission ID */
  id: Scalars['ID']['input'];
  /** Filename inside the archive */
  name: Scalars['String']['input'];
};

/** Outcome recorded for a student's submission. */
export type SubmissionOutcome = {
  __typename?: 'SubmissionOutcome';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Maybe<Scalars['ID']['output']>;
  bodyDocVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  submissionId: Scalars['ID']['output'];
};

/**
 * SubmissionOutcomeRelease represents a snapshot of a submission outcome at release time.
 * Contains the overall submission marking and documentation.
 */
export type SubmissionOutcomeRelease = {
  __typename?: 'SubmissionOutcomeRelease';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Scalars['ID']['output'];
  bodyDocVersion: Scalars['Int']['output'];
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  submissionId: Scalars['ID']['output'];
  threadReleases: Array<ThreadRelease>;
};

/** Types of submissions the client can make. */
export enum SubmissionType {
  Draft = 'DRAFT',
  Final = 'FINAL'
}

/** A recorded Survey response. */
export type Survey = {
  __typename?: 'Survey';
  /** Is the survey open for accepting new answers? */
  active: Scalars['Boolean']['output'];
  answer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Maybe<Scalars['Int']['output']>;
};

/** A Tag attached to an Enrollment */
export type Tag = {
  __typename?: 'Tag';
  /** @deprecated Use an explicit `tab` instead of column */
  column: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tab: ClassTab;
  text: Scalars['String']['output'];
};

export type TagInput = {
  /** Link tag to a category */
  categoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * An Assessment's Task.
 *
 * A single `Task` document is edited by a teacher and released as `Sheet` to
 * their Assessment. An Assessment can have multiple Tasks, one of each
 * `TaskKind`. The `INDIVIDUAL` kinded Task is the default and always-present
 * Task.
 *
 * A Task has a latest `SaveState` which is the latest content saved by the
 * teacher.
 *
 * A Task has attached `Resources`.
 *
 * DEPRECATED A Task has settings in the form of `Requirements`. Use `settings`
 * edge on `Assessment` instead.
 */
export type Task = {
  __typename?: 'Task';
  /** List of all multi-format Task blocks. */
  blocks: Array<TaskBlock>;
  format: Maybe<TaskFormat>;
  /** Task has a linked Marker Rubric. */
  hasMarkerRubric: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: TaskKind;
  /** Latest Task requirement values. */
  requirements: Requirements;
  /** Latest Task resources. */
  resources: Array<Resource>;
  /** Latest Task save state. */
  saveState: SaveState;
  /** Task is in a released state or not. */
  status: Status;
};

/**
 * A block inside a Task or TaskHistory.
 *
 * Task blocks convey a question or bunch of questions within a Task. A list of
 * blocks within a Task have a Tree structure with nesting. This Tree structure
 * is constructed using the 3 fields:
 *
 *   1. `nodeId` required
 *   2. `parentNodeId` optional
 *   3. `previousNodeId` optional
 *
 * Task blocks can also be flattened and given a fixed ordering using the `order`
 * field. The flattened tree numbering is preserved in `orderLabel` field.
 */
export type TaskBlock = {
  __typename?: 'TaskBlock';
  deleted: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Library Question ID linked to this block */
  libraryQuestionId: Maybe<Scalars['ID']['output']>;
  /** Library Question Version ID linked to this block */
  libraryQuestionVersionId: Maybe<Scalars['ID']['output']>;
  markerRubric: Maybe<MarkerRubric>;
  /** Tree layout node ID for the block. */
  nodeId: Scalars['ID']['output'];
  order: Maybe<Scalars['Int']['output']>;
  orderLabel: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentNodeId */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Tree layout parent node ID for this block. */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use previousNodeId */
  previousId: Maybe<Scalars['ID']['output']>;
  /** Tree layout previous node ID for this block. */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Number of questions referenced by the TaskBlock */
  quantity: Maybe<Scalars['Int']['output']>;
  /** Question attached to a Task block. */
  question: Maybe<Question>;
  /** QuestionSelection with sets attached this block */
  questionSelection: Maybe<QuestionSelection>;
  shuffle: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Enum of format of task */
export enum TaskFormat {
  Classic = 'CLASSIC',
  Multiformat = 'MULTIFORMAT'
}

/** Kinds of Tasks created in an Assessment. */
export enum TaskKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

export type TextEntryInteraction = {
  __typename?: 'TextEntryInteraction';
  /** Allow file attachments */
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Base type of the student's answer */
  baseType: Maybe<BaseType>;
  /** Expected length of the text entry */
  expectedLength: Maybe<Scalars['Int']['output']>;
};

export type TextEntryInteractionInput = {
  attachmentEnabled: InputMaybe<Scalars['Boolean']['input']>;
  expectedLength: InputMaybe<Scalars['Int']['input']>;
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  createdBy: User;
  criterion: Maybe<Criterion>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  metadata: Maybe<Metadata>;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  title: Maybe<Scalars['String']['output']>;
};

export type ThreadInput = {
  /** Initial comment content as HTML string */
  comment: InputMaybe<Scalars['String']['input']>;
  criterionId: InputMaybe<Scalars['Int']['input']>;
  /** ID of the associated entity. */
  entityId: Scalars['ID']['input'];
  /** Type of the associated entity. */
  entityType: EntityType;
  /** ID of the group the thread belongs to. */
  groupId: InputMaybe<Scalars['ID']['input']>;
  metadata: InputMaybe<ThreadMetadataInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

export type ThreadMetadataInput = {
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the file */
  blockAttachmentName: InputMaybe<Scalars['String']['input']>;
  charterEditorId: InputMaybe<Scalars['ID']['input']>;
  charterSectionType: InputMaybe<CharterSectionType>;
};

/**
 * ThreadRelease represents a snapshot of a thread at the time of feedback release.
 * Contains the thread information and its comments at release time.
 */
export type ThreadRelease = {
  __typename?: 'ThreadRelease';
  commentReleases: Array<CommentRelease>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  /** The ID of the Thread. */
  id: Scalars['ID']['output'];
  metadata: Maybe<Metadata>;
  threadInsertedAt: Scalars['PreciseDateTime']['output'];
  title: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Thread states. */
export enum ThreadStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Editing = 'EDITING'
}

/** Input for unlinking library question references */
export type UnlinkLibraryQuestionInput = {
  taskBlockId: Scalars['ID']['input'];
  unlinkVersionOnly: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAnswerBlockInput = {
  bookmark: InputMaybe<Scalars['Boolean']['input']>;
  confirm: InputMaybe<Scalars['Boolean']['input']>;
  skip: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFieldRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  valuesAdded: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuesRemoved: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateFieldRubricPayload = {
  __typename?: 'UpdateFieldRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/**
 * Input to update the milestones of a charter by passing
 *   the `charter_id` and the list of `milestones`
 */
export type UpdateMilestonesInput = {
  charterId: Scalars['ID']['input'];
  milestones: InputMaybe<Array<MilestoneInput>>;
};

export type UpdateProjectIssueInput = {
  groupId: Scalars['ID']['input'];
  issues: InputMaybe<Array<ProjectIssueInput>>;
};

export type UpdateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse: InputMaybe<BooleanResponseInput>;
  category: InputMaybe<Scalars['String']['input']>;
  difficulty: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse: InputMaybe<EditorResponseInput>;
  feedback: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse: InputMaybe<MultiResponseInput>;
  points: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  questionBankId: Scalars['ID']['input'];
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse: InputMaybe<ShortResponseInput>;
  shuffle: InputMaybe<Scalars['Boolean']['input']>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuestionBanksCategoryInput = {
  category: InputMaybe<Scalars['String']['input']>;
  questionBankIds: Array<Scalars['ID']['input']>;
  scope: QuestionBankScope;
};

export type UpdateQuestionRubricInput = {
  caseSensitive: InputMaybe<Scalars['Boolean']['input']>;
  errorMargin: InputMaybe<Scalars['Float']['input']>;
  partialScoring: InputMaybe<Scalars['Boolean']['input']>;
  questionRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  similarity: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuestionRubricPayload = {
  __typename?: 'UpdateQuestionRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type UpdateQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionVersionInput = {
  /** The attributes to update the question with */
  attributes: QuestionAttributes;
  /** The ID of the question to be updated */
  id: Scalars['ID']['input'];
  /** The version of the question to be updated */
  version: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStudentOutcomeScoreInput = {
  moderatorModifier: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentOutcomeScorePayload = {
  __typename?: 'UpdateStudentOutcomeScorePayload';
  studentOutcome: StudentOutcome;
};

/** Updatable attributes for a TaskBlock */
export type UpdateTaskBlockInput = {
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  nodeId: InputMaybe<Scalars['ID']['input']>;
  parentNodeId: InputMaybe<Scalars['ID']['input']>;
  points: InputMaybe<Scalars['Int']['input']>;
  previousNodeId: InputMaybe<Scalars['ID']['input']>;
  quantity: InputMaybe<Scalars['Int']['input']>;
  shuffle: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a TaskBlock for UpdateTaskBlocks */
export type UpdateTaskBlocksInput = {
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  nodeId: InputMaybe<Scalars['ID']['input']>;
  parentNodeId: InputMaybe<Scalars['ID']['input']>;
  previousNodeId: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkOutcomeScoreInput = {
  moderatorModifier: Scalars['Float']['input'];
  workOutcomeId: Scalars['ID']['input'];
};

export type UpdateWorkOutcomeScorePayload = {
  __typename?: 'UpdateWorkOutcomeScorePayload';
  fieldOutcome: Maybe<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcome: Maybe<QuestionOutcome>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: Maybe<WorkOutcome>;
};

/** Cadmus User profile */
export type User = {
  __typename?: 'User';
  /** Optional user colourset index for group context. */
  colourset: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** User family name to be used for sorting. */
  familyName: Scalars['String']['output'];
  /** User given name to be used as a short display name. */
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Full name, parsed from the LMS request which created the user. */
  name: Scalars['String']['output'];
  /** Has the user seen the latest onboarding manual screens? */
  onboardingSeen: Scalars['Boolean']['output'];
};

/** Personal settings of a user. */
export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['ID']['output'];
  /** Integrity Assuranceonboarding flag */
  showIaOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No more UserPilot */
  showUserpilotOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** User provided role in the subject */
  subjectRole: Maybe<SubjectRole>;
};

export type VerifiedCode = {
  __typename?: 'VerifiedCode';
  code: Scalars['String']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

/** A Student's Work with submissions and saves. */
export type Work = {
  __typename?: 'Work';
  /** Answer blocks linked to a Work */
  answerBlocks: Array<AnswerBlock>;
  /** Current attempt count: not 1 to 1 for Submissions */
  attemptCount: Scalars['Int']['output'];
  /**
   * Latest draft submission.
   * @deprecated Follow Work.result(type=DRAFT).submission instead.
   */
  draft: Maybe<Submission>;
  /**
   * Individual final due date for this work if one has been set. Will override
   * the assessment final due date.
   */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student's Cadmus experience survey response related to this work */
  experience: Survey;
  /** Feature flags enabled on a Work */
  features: WorkFeatures;
  /**
   * Latest final submission
   * @deprecated Follow Work.result(type=FINAL).submission instead.
   */
  final: Maybe<Submission>;
  /** Group that owns the work in group assessments. */
  group: Maybe<Group>;
  id: Scalars['ID']['output'];
  /**
   * Last save timestamp if there is a last save.
   *
   * NOTE: This field is optimised for batch loading
   */
  lastSaveTime: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Latest save for the Work, if any.
   *
   * NOTE: This field is not optimised for batch loading on multiple works.
   */
  latestSave: Maybe<Save>;
  /** Latest sentiment check for a work */
  latestSentimentCheck: Maybe<SentimentCheck>;
  /** Latest Gradebook result for the Work. */
  result: Maybe<Result>;
  /** Settings specific to the Work that override the Assessment's released sheet. */
  settings: Maybe<WorkSettings>;
  /** Instruction Sheet released to the Student. */
  sheet: Maybe<Sheet>;
  /** Start date for a timed Work that the student has to manually trigger. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student with access to the work. */
  student: User;
  /** Last update timestamp. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};


/** A Student's Work with submissions and saves. */
export type WorkResultArgs = {
  submissionType: SubmissionType;
};

/** Work Artifacts Associated with this Work. */
export type WorkArtifact = {
  __typename?: 'WorkArtifact';
  /** Marking service or AGS receipt date */
  agsSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Email receipt date */
  studentSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionId: Scalars['ID']['output'];
  taskHistoryId: Scalars['ID']['output'];
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadWorkArtifacts mutation to add an artifact's PDF to the
 * archive.
 */
export type WorkArtifactDetailInput = {
  /** Filename inside the archive */
  filename: Scalars['String']['input'];
  /** Work Artifact ID */
  id: Scalars['ID']['input'];
  /** Force regenerate the WorkArtifact */
  regenerate: InputMaybe<Scalars['Boolean']['input']>;
};

/** Feature flags enabled on a Work */
export type WorkFeatures = {
  __typename?: 'WorkFeatures';
  /** Enable usage of Work Authority API */
  enableWorkAuthority: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** A Working Group of students in a group assessment. */
export type WorkGroup = {
  __typename?: 'WorkGroup';
  /** Group's charter, if created */
  charter: Maybe<Charter>;
  /** Finalised status of the current group. */
  finalised: Scalars['Boolean']['output'];
  /** Student's current group in the Assessment. */
  group: Group;
  id: Scalars['ID']['output'];
  /** Student's individual Work, if created. */
  individualWork: Maybe<Work>;
  /**
   * ID for Individual work report if enabled for the group assessment.
   * @deprecated Use `individual_work` edge.
   */
  individualWorkId: Maybe<Scalars['ID']['output']>;
  /** Latest group change request of the current user. */
  latestGroupChangeRequest: Maybe<Message>;
  /** Group's Work document, if created. */
  work: Maybe<Work>;
};


/** A Working Group of students in a group assessment. */
export type WorkGroupLatestGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** Outcome recorded for a student's work. */
export type WorkOutcome = {
  __typename?: 'WorkOutcome';
  /** Answer blocks seen by the connected Work. */
  answerBlocks: Array<AnswerBlock>;
  assessmentId: Scalars['ID']['output'];
  /** If there are FieldOutcomes still being automarked. */
  automarkPending: Maybe<Scalars['Boolean']['output']>;
  enableProvisionalRelease: Scalars['Boolean']['output'];
  /** Indicates whether final feedback has been released for the work outcome. */
  feedbackReleased: Scalars['Boolean']['output'];
  feedbackReleasedTimestamp: Maybe<Scalars['DateTime']['output']>;
  finalRelease: Maybe<WorkOutcomeRelease>;
  /** The final score of the most recent final feedback. */
  finalScore: Maybe<Scalars['Float']['output']>;
  /** The final score penalty of the most recent final feedback. */
  finalScorePenalty: Maybe<Scalars['Float']['output']>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  latestSubmissionOutcome: Maybe<SubmissionOutcome>;
  maxScore: Scalars['Int']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  provisionalRelease: Maybe<WorkOutcomeRelease>;
  questionOutcomes: Array<QuestionOutcome>;
  /** Work outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
  studentId: Maybe<Scalars['ID']['output']>;
  /** Submission scored in this work outcome. */
  submission: Submission;
  workId: Scalars['ID']['output'];
  /** Latest released feedback */
  workOutcomeRelease: Maybe<WorkOutcomeRelease>;
};

/**
 * WorkOutcomeRelease represents a snapshot of a WorkOutcome at the time of feedback release.
 * Each release event (provisional or final) creates a new WorkOutcomeRelease record.
 *
 * This edge can also be resolve by any `WorkOutcomeRelease.t()`.
 */
export type WorkOutcomeRelease = {
  __typename?: 'WorkOutcomeRelease';
  feedbackVisibility: FeedbackVisibility;
  finalScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Scalars['Float']['output'];
  questionOutcomeReleases: Array<QuestionOutcomeRelease>;
  releaseType: FeedbackReleaseType;
  releasedAt: Scalars['DateTime']['output'];
  submissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
};

/** Settings for a work */
export type WorkSettings = {
  __typename?: 'WorkSettings';
  assessmentId: Scalars['ID']['output'];
  draftExamEndDate: Maybe<Scalars['String']['output']>;
  draftExamStartDate: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examDeferred: Maybe<Scalars['Boolean']['output']>;
  examEndDate: Maybe<Scalars['DateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['DateTime']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  studentId: Scalars['ID']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  updateReason: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

export type FeatureFlagsFragment = { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, workAttachment: boolean };

export type InstitutionFragment = { __typename?: 'Institution', id: string, customDeclarationText: string | null };

export type SessionFragment = { __typename?: 'Session', id: string, verified: boolean };

export type UserFragment = { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null };

export type ApiTokenQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
}>;


export type ApiTokenQuery = { __typename?: 'RootQueryType', apiToken: string };

export type AssessmentFragment = { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean } | null };

export type AssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', id: string, verified: boolean }, institution: { __typename?: 'Institution', id: string, customDeclarationText: string | null }, me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean } | null } };

export type AssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean };

export type AssessmentSettingsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSettingsQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean } | null } };

export type OnFutureReleaseScheduleSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type OnFutureReleaseScheduleSubscription = { __typename?: 'RootSubscriptionType', futureReleaseSchedule: string | null };

export type InstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskKind: InputMaybe<TaskKind>;
}>;


export type InstructionSheetQuery = { __typename?: 'RootQueryType', instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null };

export type MarkerRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
}>;


export type MarkerRubricQuery = { __typename?: 'RootQueryType', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type ResourceFragment = { __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null };

export type SheetFragment = { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> };

export type SheetQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type SheetQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', id: string, startDate: string | null, group: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> } | null, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null } | null, student: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null } };

export type OnSheetReleasedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
}>;


export type OnSheetReleasedSubscription = { __typename?: 'RootSubscriptionType', sheetReleased: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } };

export type TaskBlockFragment = { __typename?: 'TaskBlock', id: string, order: number | null, orderLabel: string | null, points: number | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null };

export type CommentReleaseFragment = { __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } };

export type CriterionOutcomeReleaseFragment = { __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string };

export type DownloadWorkAttachmentsMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DownloadWorkAttachmentsMutation = { __typename?: 'RootMutationType', downloadWorkAttachments: string };

export type FeedbackCriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type FeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FeedbackQuery = { __typename?: 'RootQueryType', token: string, session: { __typename?: 'Session', id: string }, me: { __typename?: 'User', id: string }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean } | null }, instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat } | null };

export type FeedbackSummaryQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FeedbackSummaryQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, dueDate: string | null, openDate: string | null, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, draftDueDate: string | null, draftEnabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, anonymousMarking: boolean | null, maxGrade: number, selfEvaluationMaxGrade: number | null, individualReportMaxGrade: number | null, groupReportMaxGrade: number | null, peerEvaluationMaxGrade: number | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, smartAutomarkingEnabled: boolean } | null }, finalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, finalScore: number | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null } | null, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', weightedScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, weight: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, weight: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, weight: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, weight: number | null } | null }, base: { __typename?: 'ComponentBreakdown', individual: { __typename?: 'ComponentScore', weight: number | null } | null, peer: { __typename?: 'ComponentScore', weight: number | null } | null, self: { __typename?: 'ComponentScore', weight: number | null } | null }, peerOutcome: { __typename?: 'PeerOutcome', id: string, completedAt: string | null, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null } | null } };

export type FeedbackVisibilityFragment = { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType };

export type FieldOutcomeFragment = { __typename?: 'FieldOutcome', id: string, docVersion: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } };

export type FieldOutcomeReleaseFragment = { __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type GroupFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupFeedbackQuery = { __typename?: 'RootQueryType', individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, groupMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, peerMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkGroup: { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string, name: string }> } } | null, studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, completedAt: string | null, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } | null } };

export type IndividualFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type IndividualFeedbackQuery = { __typename?: 'RootQueryType', individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null };

export type MarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type MfaFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MfaFeedbackQuery = { __typename?: 'RootQueryType', rubric: { __typename?: 'Rubric', questions: Array<{ __typename?: 'QuestionRubric', questionId: string, fieldRubrics: Array<{ __typename?: 'FieldRubric', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, publishedAt: string | null, assessmentName: string, questionShortPrompt: string | null, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> }> } | null, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null };

export type QuestionOutcomeFragment = { __typename?: 'QuestionOutcome', questionId: string, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, docVersion: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null };

export type QuestionOutcomeReleaseFragment = { __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null };

export type ReceivedPeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, completedAt: string | null, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> };

export type SimilarityQueryVariables = Exact<{
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
}>;


export type SimilarityQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, workId: string, heraResultId: number | null, returnedAt: string | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type StudentOutcomeFragment = { __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, completedAt: string | null, peerMaxScore: number | null, selfMaxScore: number | null, peerScore: number | null, selfScore: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } | null };

export type SubmissionOutcomeFragment = { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } };

export type SubmissionOutcomeReleaseFragment = { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type ThreadReleaseFragment = { __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type WorkOutcomeFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, maxScore: number, feedbackReleased: boolean, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }>, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type WorkOutcomeReleaseFragment = { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, feedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, showPeerComments: boolean, showPeerScores: boolean, withFeedbackPdf: boolean, releaseType: FeedbackReleaseType }, questionOutcomeReleases: Array<{ __typename?: 'QuestionOutcomeRelease', id: string, questionId: string, fieldOutcomeReleases: Array<{ __typename?: 'FieldOutcomeRelease', id: string, score: number, docContent: string | null, docVersion: number | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> }>, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null }>, submissionOutcomeRelease: { __typename?: 'SubmissionOutcomeRelease', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, criterionOutcomeReleases: Array<{ __typename?: 'CriterionOutcomeRelease', id: string, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string }>, threadReleases: Array<{ __typename?: 'ThreadRelease', id: string, title: string | null, criterionId: string | null, threadInsertedAt: string, userId: string, metadata: { __typename?: 'Metadata', blockAttachmentName: string | null } | null, commentReleases: Array<{ __typename?: 'CommentRelease', id: string, content: string, userId: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } | null };

export type AcceptStudentCharterMutationVariables = Exact<{
  input: CharterAgreementInput;
}>;


export type AcceptStudentCharterMutation = { __typename?: 'RootMutationType', acceptStudentCharter: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } };

export type CharterAgreementFragment = { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null };

export type CharterEditorFragment = { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string };

export type CharterFormFragment = { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, type: CharterFormSectionType, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> };

export type CharterFragment = { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> };

export type CharterMilestoneFragment = { __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean };

export type CharterQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  charterId: Scalars['ID']['input'];
}>;


export type CharterQuery = { __typename?: 'RootQueryType', token: string, charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> }, charterForm: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, type: CharterFormSectionType, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> } | null };

export type CharterStatusQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CharterStatusQuery = { __typename?: 'RootQueryType', studentWorkGroup: { __typename?: 'WorkGroup', charter: { __typename?: 'Charter', allMembersAccepted: boolean } | null } | null };

export type SaveCharterEditorMutationVariables = Exact<{
  input: CharterEditorInput;
}>;


export type SaveCharterEditorMutation = { __typename?: 'RootMutationType', saveCharterEditor: { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string } };

export type SetupCharterMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type SetupCharterMutation = { __typename?: 'RootMutationType', setupCharter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> } };

export type UnlockStudentCharterMutationVariables = Exact<{
  input: CharterAgreementInput;
}>;


export type UnlockStudentCharterMutation = { __typename?: 'RootMutationType', unlockStudentCharter: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } };

export type UpdateMilestonesMutationVariables = Exact<{
  input: UpdateMilestonesInput;
}>;


export type UpdateMilestonesMutation = { __typename?: 'RootMutationType', updateMilestones: { __typename?: 'Charter', id: string, milestones: Array<{ __typename?: 'CharterMilestone', deleted: boolean, description: string | null, dueDate: string, id: string | null, title: string }> } };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> };

export type GroupUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', groupUpdated: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> } };

export type ListGroupsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ListGroupsQuery = { __typename?: 'RootQueryType', token: string, groupList: Array<{ __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> }>, me: { __typename?: 'User', id: string, name: string }, assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean } | null } };

export type JoinGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type JoinGroupMutation = { __typename?: 'RootMutationType', joinGroup: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> } };

export type LeaveGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type LeaveGroupMutation = { __typename?: 'RootMutationType', leaveGroup: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> } };

export type MessageFragment = { __typename?: 'Message', id: string, messageType: MessageRequestType, expiresAt: string | null, resolvedAt: string | null };

export type PeerOverviewQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PeerOverviewQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, name: string }, assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', selfEvaluationEnabled: boolean, groupCharterEnabled: boolean } | null }, peerRubric: { __typename?: 'MarkerRubric', id: string, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkGroup: { __typename?: 'WorkGroup', id: string, work: { __typename?: 'Work', id: string } | null, charter: { __typename?: 'Charter', latestAgreement: { __typename?: 'CharterAgreement', id: string, acceptedAt: string } | null } | null, group: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string, name: string }> } } | null, groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, completedAt: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }> };

export type ProjectIssueFragment = { __typename?: 'ProjectIssue', id: string, groupId: string, title: string, type: IssueType, status: IssueStatus, deleted: boolean, description: string | null, dueDate: string | null, parentId: string | null, assignees: Array<string> };

export type ProjectIssuesQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type ProjectIssuesQuery = { __typename?: 'RootQueryType', projectIssues: Array<{ __typename?: 'ProjectIssue', id: string, title: string, type: IssueType, status: IssueStatus, groupId: string, deleted: boolean, description: string | null, dueDate: string | null, parentId: string | null, assignees: Array<string> }> };

export type UpdateProjectIssueMutationVariables = Exact<{
  input: UpdateProjectIssueInput;
}>;


export type UpdateProjectIssueMutation = { __typename?: 'RootMutationType', updateProjectIssue: Array<{ __typename?: 'ProjectIssue', id: string, title: string, type: IssueType, status: IssueStatus, deleted: boolean, description: string | null, dueDate: string | null, assignees: Array<string>, parentId: string | null }> };

export type SendMessageMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
}>;


export type SendMessageMutation = { __typename?: 'RootMutationType', sendMessage: { __typename?: 'Message', id: string, messageType: MessageRequestType, expiresAt: string | null, resolvedAt: string | null } };

export type SetupGroupWorkMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type SetupGroupWorkMutation = { __typename?: 'RootMutationType', setupGroupWork: { __typename?: 'WorkGroup', id: string, work: { __typename?: 'Work', id: string } | null } };

export type WorkGroupQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type WorkGroupQuery = { __typename?: 'RootQueryType', studentWorkGroup: { __typename?: 'WorkGroup', id: string, finalised: boolean, latestGroupChangeRequest: { __typename?: 'Message', id: string, messageType: MessageRequestType, expiresAt: string | null, resolvedAt: string | null } | null, charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, latestAgreement: { __typename?: 'CharterAgreement', acceptedAt: string, unlockedAt: string | null } | null, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> } | null, group: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> }, work: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string } | null } | null, individualWork: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string } | null } | null } | null };

export type CompletePeerOutcomesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CompletePeerOutcomesMutation = { __typename?: 'RootMutationType', completePeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, completedAt: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }> };

export type CriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type CriterionOutcomeFragment = { __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null };

export type FeedbackThreadFragment = { __typename?: 'Thread', id: string, entityId: string | null, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type GroupPeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, completedAt: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> };

export type LearningOutcomeSkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type MarkPeerOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
}>;


export type MarkPeerOutcomeMutation = { __typename?: 'RootMutationType', markPeerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, completedAt: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> } };

export type PeerAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PeerAssessmentQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }, studentWorkGroup: { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, maxLimit: number | null, members: Array<{ __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null }> } } | null, peerRubric: { __typename?: 'MarkerRubric', id: string, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, feedbackReleasedTimestamp: string | null, completedAt: string | null, givenCriterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, targetUserId: string | null, markerRubricCriterionId: string, markerRubricScaleItemId: string, markerUserId: string | null, markerScore: number, publishedAt: string | null }> }>, instructionSheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null };

export type ResetGivenEvaluationsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetGivenEvaluationsMutation = { __typename?: 'RootMutationType', resetCriterionOutcomes: number };

export type ScaleItemFragment = { __typename?: 'ScaleItem', id: string | null, description: string | null, order: number, scaleLabel: string | null, rangeFrom: number | null, rangeTo: number | null };

export type SentimentCheckFragment = { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null };

export type SubmitSentimentCheckMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
}>;


export type SubmitSentimentCheckMutation = { __typename?: 'RootMutationType', submitSentimentCheck: { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null } };

export type AnswerBlockFragment = { __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> };

export type BlockAttachmentFragment = { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null };

export type BlockSnapshotFragment = { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string };

export type CommentFragment = { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } };

export type CommentUserFragment = { __typename?: 'User', id: string, name: string, colourset: number | null };

export type ConversationEventFragment = { __typename?: 'ConversationEvent', eventType: ConversationEventType, threadId: string, title: string | null, comment: { __typename?: 'Comment', insertedAt: string, id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } | null };

export type CreateBlockAttachmentMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: Scalars['String']['input'];
}>;


export type CreateBlockAttachmentMutation = { __typename?: 'RootMutationType', createBlockAttachment: { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null } };

export type CreateCommentMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateCommentMutation = { __typename?: 'RootMutationType', createComment: { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type CreateThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  input: ThreadInput;
}>;


export type CreateThreadMutation = { __typename?: 'RootMutationType', createThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null, name: string, givenName: string, familyName: string, colourset: number | null } };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'Thread', id: string, createdBy: { __typename?: 'User', id: string, name: string } } };

export type EditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type EditCommentMutation = { __typename?: 'RootMutationType', editComment: { __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type EntityThreadEventFragment = { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null };

export type EntityThreadsQueryVariables = Exact<{
  entityType: EntityType;
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EntityThreadsQuery = { __typename?: 'RootQueryType', entityThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null }> };

export type OnEntityThreadsUpdatedSubscriptionVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
}>;


export type OnEntityThreadsUpdatedSubscription = { __typename?: 'RootSubscriptionType', entityThreadsUpdated: { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null } };

export type UpdateExperienceMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
}>;


export type UpdateExperienceMutation = { __typename?: 'RootMutationType', updateExperience: { __typename?: 'Survey', id: string, score: number | null, active: boolean } };

export type ExperienceQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type ExperienceQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, subjectId: string }, work: { __typename?: 'Work', id: string, experience: { __typename?: 'Survey', id: string, score: number | null, active: boolean } } };

export type LatestBlockSnapshotFragment = { __typename?: 'AnswerBlock', id: string, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null };

export type LatestResultQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  type: SubmissionType;
}>;


export type LatestResultQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type OnResultUpdatedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnResultUpdatedSubscription = { __typename?: 'RootSubscriptionType', workResultUpdated: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type QuestionBodyFragment = { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null };

export type QuestionFieldFragment = { __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } };

export type QuestionFragment = { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null };

export type RemoveBlockAttachmentMutationVariables = Exact<{
  blockAttachmentId: Scalars['ID']['input'];
}>;


export type RemoveBlockAttachmentMutation = { __typename?: 'RootMutationType', removeBlockAttachment: { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null } };

export type ResolveThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type ResolveThreadMutation = { __typename?: 'RootMutationType', updateThreadResolution: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type ResultFragment = { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null };

export type ResultLineFragment = { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null };

export type SaveBlockSnapshotMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  wordCountChange: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveBlockSnapshotMutation = { __typename?: 'RootMutationType', saveBlockSnapshot: { __typename?: 'SaveBlockSnapshotResponse', blockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, version: number, blockName: string | null } } };

export type SaveFragment = { __typename?: 'Save', id: string, serverId: string, version: string, content: string };

export type SaveMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  metadata: InputMaybe<SaveMetadataInput>;
  editor: InputMaybe<EditorType>;
}>;


export type SaveMutation = { __typename?: 'RootMutationType', save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string, dispatchedAt: string } };

export type SimpleChoiceFragment = { __typename?: 'SimpleChoice', identifier: string, content: string };

export type StartMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type StartMutation = { __typename?: 'RootMutationType', start: { __typename?: 'Work', id: string, startDate: string | null } };

export type SubmissionFragment = { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> };

export type SubmissionMetadataFragment = { __typename?: 'Submission', id: string, type: SubmissionType, submittedAt: string, unsubmittedAt: string | null };

export type SubmissionQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
  submissionType: SubmissionType;
}>;


export type SubmissionQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', id: string, result: { __typename?: 'Result', id: string, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null } | null } };

export type SubmitAttemptMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  type: SubmissionType;
  attemptNumber: Scalars['Int']['input'];
}>;


export type SubmitAttemptMutation = { __typename?: 'RootMutationType', submitAttempt: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type SubmitMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  saveId: Scalars['ID']['input'];
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
  acceptedDeclaration: Scalars['Boolean']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  editor: InputMaybe<EditorType>;
}>;


export type SubmitMutation = { __typename?: 'RootMutationType', submit: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export type OnThreadConversationUpdatedSubscriptionVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type OnThreadConversationUpdatedSubscription = { __typename?: 'RootSubscriptionType', threadConversationUpdated: { __typename?: 'ConversationEvent', eventType: ConversationEventType, threadId: string, title: string | null, comment: { __typename?: 'Comment', insertedAt: string, id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } | null } };

export type ThreadFragment = { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null };

export type ThreadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ThreadQuery = { __typename?: 'RootQueryType', thread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type OnThreadUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnThreadUpdatedSubscription = { __typename?: 'RootSubscriptionType', threadUpdated: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type UnresolveThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type UnresolveThreadMutation = { __typename?: 'RootMutationType', updateThreadResolution: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, resolvedAt: string | null, status: ThreadStatus, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null }, resolvedBy: { __typename?: 'User', id: string, name: string, colourset: number | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, insertedAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }>, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null } };

export type UnsubmitMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  submissionId: Scalars['ID']['input'];
}>;


export type UnsubmitMutation = { __typename?: 'RootMutationType', unsubmit: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export type UpdateAnswerBlockMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
}>;


export type UpdateAnswerBlockMutation = { __typename?: 'RootMutationType', updateAnswerBlock: { __typename?: 'AnswerBlock', id: string, skip: boolean | null, bookmark: boolean | null, confirm: boolean | null } };

export type VerifyAccessCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type VerifyAccessCodeMutation = { __typename?: 'RootMutationType', verifyAccessCode: { __typename?: 'Session', id: string, verified: boolean } };

export type WorkAnswerBlocksFragment = { __typename?: 'Work', answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> };

export type WorkAttemptCountFragment = { __typename?: 'Work', id: string, attemptCount: number };

export type WorkDueDateQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type WorkDueDateQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', id: string, dueDate: string | null } };

export type WorkQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type WorkQuery = { __typename?: 'RootQueryType', token: string, work: { __typename?: 'Work', id: string, startDate: string | null, attemptCount: number, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null, group: { __typename?: 'Group', id: string, name: string } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, settings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, blockName: string | null, points: number | null, skip: boolean | null, bookmark: boolean | null, order: number | null, orderLabel: string | null, nodeId: string, shuffle: boolean | null, parentNodeId: string | null, confirm: boolean | null, question: { __typename?: 'Question', id: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', baseType: BaseType | null, expectedLength: number | null, attachmentEnabled: boolean | null } }> | null } | null } | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string } | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }>, latestSave: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, latestSentimentCheck: { __typename?: 'SentimentCheck', id: string, comment: string | null, skipped: boolean, level: SentimentCheckLevel | null, sessionId: string, insertedAt: string | null } | null, finalResult: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } | null, draftResult: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } | null } };

export type WorkSettingsFragment = { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null };

export type OnWorkSettingsUpdatedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkSettingsUpdatedSubscription = { __typename?: 'RootSubscriptionType', workSettingsUpdated: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examWritingTime: number | null, examDeferred: boolean | null } };

export type OnWorkStartedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkStartedSubscription = { __typename?: 'RootSubscriptionType', workStarted: { __typename?: 'Work', id: string, startDate: string | null, sheet: { __typename?: 'Sheet', id: string, format: TaskFormat, kind: TaskKind, rawContent: string | null, releaseTimestamp: string, nextReleaseTimestamp: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, notes: string | null, fileSize: number | null }> } | null } };

export type WorkSubmitAttemptFragment = { __typename?: 'Work', id: string, attemptCount: number, finalResult: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } | null, draftResult: { __typename?: 'Result', id: string, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, submission: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } | null, grade: { __typename?: 'Grade', display: string, max: number, value: number } | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } | null };

export type OnWorkSubmittedSubscriptionVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type OnWorkSubmittedSubscription = { __typename?: 'RootSubscriptionType', workSubmitted: { __typename?: 'Submission', id: string, submittedAt: string, unsubmittedAt: string | null, type: SubmissionType, attemptNumber: number | null, save: { __typename?: 'Save', id: string, serverId: string, version: string, content: string } | null, blockSnapshots: Array<{ __typename?: 'BlockSnapshot', id: string, cacheId: string, answerBlockId: string, version: number, blockName: string | null, content: string }> } };

export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on InstitutionFeatures {
  id
  accessCode
  exams
  respondusLdb
  moodleGrader
  multiformat
  turnitinGrader
  cadmusGrader
  groupAssessment
  genAiDeclaration
  questionLibrary
  extensionSyncing
  workAttachment
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on Institution {
  id
  customDeclarationText
}
    `;
export const SessionFragmentDoc = gql`
    fragment Session on Session {
  id
  verified(assessmentId: $assessmentId)
}
    `;
export const AssessmentSettingsFragmentDoc = gql`
    fragment AssessmentSettings on AssessmentSettings {
  id
  assessmentType
  releaseDate
  dueDate
  openDate
  individualWorkAttachmentEnabled
  groupWorkAttachmentEnabled
  draftDueDate
  draftEnabled
  lateSubmissionTimeLimit
  lateResubmissionEnabled
  markingTool
  feedbackDate
  feedbackDateDisabled
  anonymousMarking
  maxGrade
  selfEvaluationMaxGrade
  individualReportMaxGrade
  groupReportMaxGrade
  peerEvaluationMaxGrade
  tiiSViewReports
  tiiDraftSViewReports
  timeLimit
  timeLimitEnabled
  examType
  examTiming
  examStartDate
  examEndDate
  examReadingTime
  examReadingTimeDisabled
  examWritingTime
  examAutoSubmissionDisabled
  examBacktrackDisabled
  examLdbEnabled
  examAccessCodeEnabled
  weight
  weightEnabled
  wordLimit
  wordLimitEnabled
  wordLimitGroup
  referencingStyle
  referencingStyleEnabled
  countReferences
  countFootnotes
  allowGenerativeAi
  spellCheckDisabled
  groupAssessmentEnabled
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  groupFinalised
  sentimentCheckEnabled
  sentimentCheckIntervalInHr
  individualReportEnabled
  individualReportWeight
  individualReportDueDate
  peerEvaluationEnabled
  peerEvaluationWeight
  peerEvaluationDueDate
  selfEvaluationEnabled
  selfEvaluationWeight
  groupCharterEnabled
  groupCharterDueDate
  groupReportWeight
  smartAutomarkingEnabled
}
    `;
export const AssessmentFragmentDoc = gql`
    fragment Assessment on Assessment {
  id
  name
  subjectName
  settings {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  id
  name
  url
  notes
  fileSize
}
    `;
export const SheetFragmentDoc = gql`
    fragment Sheet on Sheet {
  id
  format
  kind
  rawContent
  releaseTimestamp
  nextReleaseTimestamp
  resources {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export const SimpleChoiceFragmentDoc = gql`
    fragment SimpleChoice on SimpleChoice {
  identifier
  content
}
    `;
export const QuestionFieldFragmentDoc = gql`
    fragment QuestionField on QuestionField {
  identifier
  interaction {
    ... on ChoiceInteraction {
      choices {
        ...SimpleChoice
      }
      label
      maxChoices
    }
    ... on ExtendedInteraction {
      wordLimit
      attachmentEnabled
    }
    ... on TextEntryInteraction {
      baseType
      expectedLength
      attachmentEnabled
    }
    ... on MatchInteraction {
      targetSet {
        ...SimpleChoice
      }
      sourceSet {
        ...SimpleChoice
      }
    }
    ... on PositionObjectInteraction {
      label
      maxChoices
    }
  }
}
    ${SimpleChoiceFragmentDoc}`;
export const QuestionBodyFragmentDoc = gql`
    fragment QuestionBody on QuestionBody {
  id
  feedback
  promptDoc
  promptImage {
    ... on PromptImage {
      url
      width
      height
      layers {
        ... on PromptImageLayer {
          identifier
          shape
          coords
        }
      }
    }
  }
  fields {
    ...QuestionField
  }
}
    ${QuestionFieldFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  questionType
  shortPrompt
  body {
    ...QuestionBody
  }
}
    ${QuestionBodyFragmentDoc}`;
export const TaskBlockFragmentDoc = gql`
    fragment TaskBlock on TaskBlock {
  id
  order
  orderLabel
  points
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const LearningOutcomeSkillFragmentDoc = gql`
    fragment LearningOutcomeSkill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const ScaleItemFragmentDoc = gql`
    fragment ScaleItem on ScaleItem {
  id
  description
  order
  scaleLabel
  rangeFrom
  rangeTo
}
    `;
export const FeedbackCriterionFragmentDoc = gql`
    fragment FeedbackCriterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const MarkerRubricFragmentDoc = gql`
    fragment MarkerRubric on MarkerRubric {
  id
  kind
  format
  publishedAt
  assessmentName
  questionShortPrompt
  criteria {
    ...FeedbackCriterion
  }
}
    ${FeedbackCriterionFragmentDoc}`;
export const CriterionOutcomeFragmentDoc = gql`
    fragment CriterionOutcome on CriterionOutcome {
  id
  targetUserId
  markerRubricCriterionId
  markerRubricScaleItemId
  markerUserId
  markerScore
  publishedAt
}
    `;
export const FieldOutcomeFragmentDoc = gql`
    fragment FieldOutcome on FieldOutcome {
  id
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
  docVersion
}
    ${CriterionOutcomeFragmentDoc}`;
export const BlockSnapshotFragmentDoc = gql`
    fragment BlockSnapshot on BlockSnapshot {
  id
  cacheId
  answerBlockId
  version
  blockName
  content
}
    `;
export const QuestionOutcomeFragmentDoc = gql`
    fragment QuestionOutcome on QuestionOutcome {
  questionId
  fieldOutcomes {
    ...FieldOutcome
  }
  blockSnapshot {
    ...BlockSnapshot
  }
}
    ${FieldOutcomeFragmentDoc}
${BlockSnapshotFragmentDoc}`;
export const FeedbackVisibilityFragmentDoc = gql`
    fragment FeedbackVisibility on FeedbackVisibility {
  id
  feedbackViewLevel
  showPeerComments
  showPeerScores
  withFeedbackPdf
  releaseType
}
    `;
export const CriterionOutcomeReleaseFragmentDoc = gql`
    fragment CriterionOutcomeRelease on CriterionOutcomeRelease {
  id
  markerScore
  markerRubricCriterionId
  markerRubricScaleItemId
}
    `;
export const CommentUserFragmentDoc = gql`
    fragment CommentUser on User {
  id
  name
  colourset
}
    `;
export const CommentReleaseFragmentDoc = gql`
    fragment CommentRelease on CommentRelease {
  id
  content
  userId
  createdBy {
    ...CommentUser
  }
}
    ${CommentUserFragmentDoc}`;
export const ThreadReleaseFragmentDoc = gql`
    fragment ThreadRelease on ThreadRelease {
  id
  title
  criterionId
  threadInsertedAt
  userId
  metadata {
    blockAttachmentName
  }
  commentReleases {
    ...CommentRelease
  }
}
    ${CommentReleaseFragmentDoc}`;
export const FieldOutcomeReleaseFragmentDoc = gql`
    fragment FieldOutcomeRelease on FieldOutcomeRelease {
  id
  score
  criterionOutcomeReleases {
    ...CriterionOutcomeRelease
  }
  threadReleases {
    ...ThreadRelease
  }
  docContent
  docVersion
}
    ${CriterionOutcomeReleaseFragmentDoc}
${ThreadReleaseFragmentDoc}`;
export const QuestionOutcomeReleaseFragmentDoc = gql`
    fragment QuestionOutcomeRelease on QuestionOutcomeRelease {
  id
  questionId
  fieldOutcomeReleases {
    ...FieldOutcomeRelease
  }
  blockSnapshot {
    ...BlockSnapshot
  }
}
    ${FieldOutcomeReleaseFragmentDoc}
${BlockSnapshotFragmentDoc}`;
export const SubmissionOutcomeReleaseFragmentDoc = gql`
    fragment SubmissionOutcomeRelease on SubmissionOutcomeRelease {
  id
  submissionId
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  criterionOutcomeReleases {
    ...CriterionOutcomeRelease
  }
  threadReleases {
    ...ThreadRelease
  }
}
    ${CriterionOutcomeReleaseFragmentDoc}
${ThreadReleaseFragmentDoc}`;
export const WorkOutcomeReleaseFragmentDoc = gql`
    fragment WorkOutcomeRelease on WorkOutcomeRelease {
  id
  releaseType
  releasedAt
  finalScore
  penaltyScore
  feedbackVisibility {
    ...FeedbackVisibility
  }
  questionOutcomeReleases {
    ...QuestionOutcomeRelease
  }
  submissionOutcomeRelease {
    ...SubmissionOutcomeRelease
  }
}
    ${FeedbackVisibilityFragmentDoc}
${QuestionOutcomeReleaseFragmentDoc}
${SubmissionOutcomeReleaseFragmentDoc}`;
export const BlockAttachmentFragmentDoc = gql`
    fragment BlockAttachment on BlockAttachment {
  id
  name
  mediaUrl
  fileSize
  fileExtension
}
    `;
export const WorkOutcomeFragmentDoc = gql`
    fragment WorkOutcome on WorkOutcome {
  id
  workId
  groupId
  maxScore
  feedbackReleased
  workOutcomeRelease {
    ...WorkOutcomeRelease
  }
  answerBlocks {
    id
    nodeId
    blockName
    blockAttachments {
      ...BlockAttachment
    }
    question {
      ...Question
    }
  }
}
    ${WorkOutcomeReleaseFragmentDoc}
${BlockAttachmentFragmentDoc}
${QuestionFragmentDoc}`;
export const ReceivedPeerOutcomeFragmentDoc = gql`
    fragment ReceivedPeerOutcome on PeerOutcome {
  id
  targetUserId
  completedAt
  peerMaxScore
  selfMaxScore
  peerScore
  selfScore
  criterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const StudentOutcomeFragmentDoc = gql`
    fragment StudentOutcome on StudentOutcome {
  id
  studentId
  groupWorkOutcome {
    ...WorkOutcome
  }
  individualWorkOutcome {
    ...WorkOutcome
  }
  peerOutcome {
    ...ReceivedPeerOutcome
  }
}
    ${WorkOutcomeFragmentDoc}
${ReceivedPeerOutcomeFragmentDoc}`;
export const SubmissionOutcomeFragmentDoc = gql`
    fragment SubmissionOutcome on SubmissionOutcome {
  id
  submissionId
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const CharterEditorFragmentDoc = gql`
    fragment CharterEditor on CharterEditor {
  id
  charterFormSectionId
  snapshotDoc
  snapshotVersion
  streamUuid
}
    `;
export const CharterFormFragmentDoc = gql`
    fragment CharterForm on CharterForm {
  id
  published
  publishTimestamp
  sections {
    id
    type
    deleted
    enabled
    milestonePresets {
      description
      dueDate
      title
    }
    promptDoc
    rank
    title
    wordLimit
    wordLimitEnabled
  }
}
    `;
export const CharterAgreementFragmentDoc = gql`
    fragment CharterAgreement on CharterAgreement {
  acceptedAt
  unlockedAt
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  content
  insertedAt
  updatedAt
  createdBy {
    ...CommentUser
  }
}
    ${CommentUserFragmentDoc}`;
export const ThreadFragmentDoc = gql`
    fragment Thread on Thread {
  id
  title
  entityType
  entityId
  criterionId
  createdBy {
    ...CommentUser
  }
  insertedAt
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  status
  comments {
    ...Comment
  }
  metadata {
    charterSectionType
    charterEditorId
    blockAttachmentId
    blockAttachmentName
  }
}
    ${CommentUserFragmentDoc}
${CommentFragmentDoc}`;
export const CharterFragmentDoc = gql`
    fragment Charter on Charter {
  id
  groupId
  milestones {
    id
    title
    description
    dueDate
    deleted
  }
  editors {
    id
    charterFormSectionId
    snapshotDoc
    snapshotVersion
    streamUuid
  }
  latestAgreement {
    ...CharterAgreement
  }
  feedbackThreads {
    ...Thread
  }
}
    ${CharterAgreementFragmentDoc}
${ThreadFragmentDoc}`;
export const CharterMilestoneFragmentDoc = gql`
    fragment CharterMilestone on CharterMilestone {
  id
  title
  description
  dueDate
  deleted
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  name
  givenName
  familyName
  colourset
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on Group {
  id
  name
  maxLimit
  members {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  messageType
  expiresAt
  resolvedAt
}
    `;
export const ProjectIssueFragmentDoc = gql`
    fragment ProjectIssue on ProjectIssue {
  id
  groupId
  title
  type
  status
  deleted
  description
  dueDate
  parentId
  assignees
}
    `;
export const CriterionFragmentDoc = gql`
    fragment Criterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const FeedbackThreadFragmentDoc = gql`
    fragment FeedbackThread on Thread {
  id
  entityId
  createdBy {
    ...CommentUser
  }
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  status
  comments {
    ...Comment
  }
}
    ${CommentUserFragmentDoc}
${CommentFragmentDoc}`;
export const GroupPeerOutcomeFragmentDoc = gql`
    fragment GroupPeerOutcome on PeerOutcome {
  id
  targetUserId
  feedbackReleasedTimestamp
  completedAt
  givenCriterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const SentimentCheckFragmentDoc = gql`
    fragment SentimentCheck on SentimentCheck {
  id
  comment
  skipped
  level
  sessionId
  insertedAt
}
    `;
export const ConversationEventFragmentDoc = gql`
    fragment ConversationEvent on ConversationEvent {
  eventType
  threadId
  comment {
    ...Comment
    insertedAt
  }
  title
}
    ${CommentFragmentDoc}`;
export const EntityThreadEventFragmentDoc = gql`
    fragment EntityThreadEvent on EntityThreadEvent {
  eventType
  threadId
  status
  entityId
  entityType
  resolvedAt
  resolvedBy {
    ...CommentUser
  }
  criterionId
}
    ${CommentUserFragmentDoc}`;
export const LatestBlockSnapshotFragmentDoc = gql`
    fragment LatestBlockSnapshot on AnswerBlock {
  id
  latestBlockSnapshot {
    ...BlockSnapshot
  }
}
    ${BlockSnapshotFragmentDoc}`;
export const ResultLineFragmentDoc = gql`
    fragment ResultLine on Result {
  id
  heraResultId
  canvasResultUrl
  moodleGraderUrl
  grade {
    display
    max
    value
  }
  similarity {
    display
    label
    value
  }
}
    `;
export const SubmissionMetadataFragmentDoc = gql`
    fragment SubmissionMetadata on Submission {
  id
  type
  submittedAt
  unsubmittedAt
}
    `;
export const AnswerBlockFragmentDoc = gql`
    fragment AnswerBlock on AnswerBlock {
  id
  blockName
  points
  skip
  bookmark
  order
  orderLabel
  nodeId
  shuffle
  parentNodeId
  confirm
  question {
    ...Question
  }
  latestBlockSnapshot {
    ...BlockSnapshot
  }
  blockAttachments {
    ...BlockAttachment
  }
}
    ${QuestionFragmentDoc}
${BlockSnapshotFragmentDoc}
${BlockAttachmentFragmentDoc}`;
export const WorkAnswerBlocksFragmentDoc = gql`
    fragment WorkAnswerBlocks on Work {
  answerBlocks {
    ...AnswerBlock
  }
}
    ${AnswerBlockFragmentDoc}`;
export const WorkAttemptCountFragmentDoc = gql`
    fragment WorkAttemptCount on Work {
  id
  attemptCount
}
    `;
export const WorkSettingsFragmentDoc = gql`
    fragment WorkSettings on WorkSettings {
  id
  dueDate
  timeLimit
  examStartDate
  examEndDate
  examReadingTime
  examWritingTime
  examDeferred
}
    `;
export const SaveFragmentDoc = gql`
    fragment Save on Save {
  id
  serverId
  version
  content
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment Submission on Submission {
  id
  submittedAt
  unsubmittedAt
  type
  attemptNumber
  save {
    ...Save
  }
  blockSnapshots {
    ...BlockSnapshot
  }
}
    ${SaveFragmentDoc}
${BlockSnapshotFragmentDoc}`;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  id
  heraResultId
  canvasResultUrl
  moodleGraderUrl
  submission {
    ...Submission
  }
  grade {
    display
    max
    value
  }
  similarity {
    display
    label
    value
  }
}
    ${SubmissionFragmentDoc}`;
export const WorkSubmitAttemptFragmentDoc = gql`
    fragment WorkSubmitAttempt on Work {
  id
  attemptCount
  finalResult: result(submissionType: FINAL) {
    ...Result
  }
  draftResult: result(submissionType: DRAFT) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const ApiTokenDocument = gql`
    query ApiToken($assessmentId: ID!, $workId: ID!) {
  apiToken(assessmentId: $assessmentId, workId: $workId)
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables> & ({ variables: ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export function useApiTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export const AssessmentDocument = gql`
    query Assessment($assessmentId: ID!) {
  session {
    ...Session
  }
  institution {
    ...Institution
  }
  me {
    ...User
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
}
    ${SessionFragmentDoc}
${InstitutionFragmentDoc}
${UserFragmentDoc}
${AssessmentFragmentDoc}`;

/**
 * __useAssessmentQuery__
 *
 * To run a query within a React component, call `useAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentQuery, AssessmentQueryVariables> & ({ variables: AssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
      }
export function useAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export function useAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export type AssessmentQueryHookResult = ReturnType<typeof useAssessmentQuery>;
export type AssessmentLazyQueryHookResult = ReturnType<typeof useAssessmentLazyQuery>;
export type AssessmentSuspenseQueryHookResult = ReturnType<typeof useAssessmentSuspenseQuery>;
export type AssessmentQueryResult = Apollo.QueryResult<AssessmentQuery, AssessmentQueryVariables>;
export const AssessmentSettingsDocument = gql`
    query AssessmentSettings($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...AssessmentSettings
    }
  }
}
    ${AssessmentSettingsFragmentDoc}`;

/**
 * __useAssessmentSettingsQuery__
 *
 * To run a query within a React component, call `useAssessmentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSettingsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSettingsQuery(baseOptions: Apollo.QueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables> & ({ variables: AssessmentSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
      }
export function useAssessmentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
        }
export function useAssessmentSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>(AssessmentSettingsDocument, options);
        }
export type AssessmentSettingsQueryHookResult = ReturnType<typeof useAssessmentSettingsQuery>;
export type AssessmentSettingsLazyQueryHookResult = ReturnType<typeof useAssessmentSettingsLazyQuery>;
export type AssessmentSettingsSuspenseQueryHookResult = ReturnType<typeof useAssessmentSettingsSuspenseQuery>;
export type AssessmentSettingsQueryResult = Apollo.QueryResult<AssessmentSettingsQuery, AssessmentSettingsQueryVariables>;
export const OnFutureReleaseScheduleDocument = gql`
    subscription onFutureReleaseSchedule($assessmentId: ID!) {
  futureReleaseSchedule(assessmentId: $assessmentId)
}
    `;

/**
 * __useOnFutureReleaseScheduleSubscription__
 *
 * To run a query within a React component, call `useOnFutureReleaseScheduleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFutureReleaseScheduleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFutureReleaseScheduleSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useOnFutureReleaseScheduleSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnFutureReleaseScheduleSubscription, OnFutureReleaseScheduleSubscriptionVariables> & ({ variables: OnFutureReleaseScheduleSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnFutureReleaseScheduleSubscription, OnFutureReleaseScheduleSubscriptionVariables>(OnFutureReleaseScheduleDocument, options);
      }
export type OnFutureReleaseScheduleSubscriptionHookResult = ReturnType<typeof useOnFutureReleaseScheduleSubscription>;
export type OnFutureReleaseScheduleSubscriptionResult = Apollo.SubscriptionResult<OnFutureReleaseScheduleSubscription>;
export const InstructionSheetDocument = gql`
    query InstructionSheet($assessmentId: ID!, $taskKind: TaskKind) {
  instructionSheet(assessmentId: $assessmentId, kind: $taskKind) {
    ...Sheet
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useInstructionSheetQuery__
 *
 * To run a query within a React component, call `useInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskKind: // value for 'taskKind'
 *   },
 * });
 */
export function useInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables> & ({ variables: InstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
      }
export function useInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export function useInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export type InstructionSheetQueryHookResult = ReturnType<typeof useInstructionSheetQuery>;
export type InstructionSheetLazyQueryHookResult = ReturnType<typeof useInstructionSheetLazyQuery>;
export type InstructionSheetSuspenseQueryHookResult = ReturnType<typeof useInstructionSheetSuspenseQuery>;
export type InstructionSheetQueryResult = Apollo.QueryResult<InstructionSheetQuery, InstructionSheetQueryVariables>;
export const MarkerRubricDocument = gql`
    query MarkerRubric($assessmentId: ID!, $kind: MarkerRubricKind!) {
  markerRubric(assessmentId: $assessmentId, kind: $kind, status: PUBLISHED) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricQuery__
 *
 * To run a query within a React component, call `useMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables> & ({ variables: MarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
      }
export function useMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export function useMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export type MarkerRubricQueryHookResult = ReturnType<typeof useMarkerRubricQuery>;
export type MarkerRubricLazyQueryHookResult = ReturnType<typeof useMarkerRubricLazyQuery>;
export type MarkerRubricSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricSuspenseQuery>;
export type MarkerRubricQueryResult = Apollo.QueryResult<MarkerRubricQuery, MarkerRubricQueryVariables>;
export const SheetDocument = gql`
    query Sheet($workId: ID!) {
  work(workId: $workId) {
    id
    group {
      ...Group
    }
    startDate
    settings {
      ...WorkSettings
    }
    student {
      ...User
    }
    sheet {
      ...Sheet
    }
  }
}
    ${GroupFragmentDoc}
${WorkSettingsFragmentDoc}
${UserFragmentDoc}
${SheetFragmentDoc}`;

/**
 * __useSheetQuery__
 *
 * To run a query within a React component, call `useSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSheetQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSheetQuery(baseOptions: Apollo.QueryHookOptions<SheetQuery, SheetQueryVariables> & ({ variables: SheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
      }
export function useSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SheetQuery, SheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
        }
export function useSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SheetQuery, SheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SheetQuery, SheetQueryVariables>(SheetDocument, options);
        }
export type SheetQueryHookResult = ReturnType<typeof useSheetQuery>;
export type SheetLazyQueryHookResult = ReturnType<typeof useSheetLazyQuery>;
export type SheetSuspenseQueryHookResult = ReturnType<typeof useSheetSuspenseQuery>;
export type SheetQueryResult = Apollo.QueryResult<SheetQuery, SheetQueryVariables>;
export const OnSheetReleasedDocument = gql`
    subscription onSheetReleased($assessmentId: ID!, $workId: ID!) {
  sheetReleased(assessmentId: $assessmentId, workId: $workId) {
    ...Sheet
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useOnSheetReleasedSubscription__
 *
 * To run a query within a React component, call `useOnSheetReleasedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSheetReleasedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSheetReleasedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnSheetReleasedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnSheetReleasedSubscription, OnSheetReleasedSubscriptionVariables> & ({ variables: OnSheetReleasedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSheetReleasedSubscription, OnSheetReleasedSubscriptionVariables>(OnSheetReleasedDocument, options);
      }
export type OnSheetReleasedSubscriptionHookResult = ReturnType<typeof useOnSheetReleasedSubscription>;
export type OnSheetReleasedSubscriptionResult = Apollo.SubscriptionResult<OnSheetReleasedSubscription>;
export const DownloadWorkAttachmentsDocument = gql`
    mutation DownloadWorkAttachments($answerBlockId: ID!, $blockAttachmentIds: [ID!]!) {
  downloadWorkAttachments(
    answerBlockId: $answerBlockId
    blockAttachmentIds: $blockAttachmentIds
  )
}
    `;
export type DownloadWorkAttachmentsMutationFn = Apollo.MutationFunction<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;

/**
 * __useDownloadWorkAttachmentsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkAttachmentsMutation, { data, loading, error }] = useDownloadWorkAttachmentsMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      blockAttachmentIds: // value for 'blockAttachmentIds'
 *   },
 * });
 */
export function useDownloadWorkAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>(DownloadWorkAttachmentsDocument, options);
      }
export type DownloadWorkAttachmentsMutationHookResult = ReturnType<typeof useDownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationResult = Apollo.MutationResult<DownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;
export const FeedbackDocument = gql`
    query Feedback($assessmentId: ID!) {
  token
  session {
    id
  }
  me {
    id
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    id
    format
  }
}
    ${AssessmentFragmentDoc}`;

/**
 * __useFeedbackQuery__
 *
 * To run a query within a React component, call `useFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFeedbackQuery(baseOptions: Apollo.QueryHookOptions<FeedbackQuery, FeedbackQueryVariables> & ({ variables: FeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
      }
export function useFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
        }
export function useFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
        }
export type FeedbackQueryHookResult = ReturnType<typeof useFeedbackQuery>;
export type FeedbackLazyQueryHookResult = ReturnType<typeof useFeedbackLazyQuery>;
export type FeedbackSuspenseQueryHookResult = ReturnType<typeof useFeedbackSuspenseQuery>;
export type FeedbackQueryResult = Apollo.QueryResult<FeedbackQuery, FeedbackQueryVariables>;
export const FeedbackSummaryDocument = gql`
    query FeedbackSummary($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  finalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: FINAL
  ) {
    ...FeedbackVisibility
  }
  studentOutcome(assessmentId: $assessmentId) {
    id
    studentId
    groupWorkOutcome {
      id
      workId
      workOutcomeRelease {
        ...WorkOutcomeRelease
      }
    }
    individualWorkOutcome {
      id
      workId
      finalScore
      workOutcomeRelease {
        ...WorkOutcomeRelease
      }
    }
    final {
      total {
        weightedScore
      }
      peer {
        score
        maxScore
        weight
      }
      self {
        score
        maxScore
        weight
      }
      individual {
        score
        maxScore
        weight
      }
      group {
        score
        maxScore
        weight
      }
    }
    base {
      individual {
        weight
      }
      peer {
        weight
      }
      self {
        weight
      }
    }
    peerOutcome {
      id
      completedAt
      peerMaxScore
      selfMaxScore
      peerScore
      selfScore
    }
  }
}
    ${AssessmentFragmentDoc}
${FeedbackVisibilityFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}`;

/**
 * __useFeedbackSummaryQuery__
 *
 * To run a query within a React component, call `useFeedbackSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackSummaryQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFeedbackSummaryQuery(baseOptions: Apollo.QueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables> & ({ variables: FeedbackSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
      }
export function useFeedbackSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
        }
export function useFeedbackSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>(FeedbackSummaryDocument, options);
        }
export type FeedbackSummaryQueryHookResult = ReturnType<typeof useFeedbackSummaryQuery>;
export type FeedbackSummaryLazyQueryHookResult = ReturnType<typeof useFeedbackSummaryLazyQuery>;
export type FeedbackSummarySuspenseQueryHookResult = ReturnType<typeof useFeedbackSummarySuspenseQuery>;
export type FeedbackSummaryQueryResult = Apollo.QueryResult<FeedbackSummaryQuery, FeedbackSummaryQueryVariables>;
export const GroupFeedbackDocument = gql`
    query GroupFeedback($assessmentId: ID!) {
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  groupMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  peerMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    group {
      id
      members {
        id
        name
      }
    }
  }
  studentOutcome(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
}
    ${MarkerRubricFragmentDoc}
${StudentOutcomeFragmentDoc}`;

/**
 * __useGroupFeedbackQuery__
 *
 * To run a query within a React component, call `useGroupFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables> & ({ variables: GroupFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
      }
export function useGroupFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
        }
export function useGroupFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedbackQuery, GroupFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFeedbackQuery, GroupFeedbackQueryVariables>(GroupFeedbackDocument, options);
        }
export type GroupFeedbackQueryHookResult = ReturnType<typeof useGroupFeedbackQuery>;
export type GroupFeedbackLazyQueryHookResult = ReturnType<typeof useGroupFeedbackLazyQuery>;
export type GroupFeedbackSuspenseQueryHookResult = ReturnType<typeof useGroupFeedbackSuspenseQuery>;
export type GroupFeedbackQueryResult = Apollo.QueryResult<GroupFeedbackQuery, GroupFeedbackQueryVariables>;
export const IndividualFeedbackDocument = gql`
    query IndividualFeedback($assessmentId: ID!) {
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  studentWorkOutcome(assessmentId: $assessmentId) {
    ...WorkOutcome
  }
}
    ${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}`;

/**
 * __useIndividualFeedbackQuery__
 *
 * To run a query within a React component, call `useIndividualFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useIndividualFeedbackQuery(baseOptions: Apollo.QueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables> & ({ variables: IndividualFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
      }
export function useIndividualFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
        }
export function useIndividualFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>(IndividualFeedbackDocument, options);
        }
export type IndividualFeedbackQueryHookResult = ReturnType<typeof useIndividualFeedbackQuery>;
export type IndividualFeedbackLazyQueryHookResult = ReturnType<typeof useIndividualFeedbackLazyQuery>;
export type IndividualFeedbackSuspenseQueryHookResult = ReturnType<typeof useIndividualFeedbackSuspenseQuery>;
export type IndividualFeedbackQueryResult = Apollo.QueryResult<IndividualFeedbackQuery, IndividualFeedbackQueryVariables>;
export const MfaFeedbackDocument = gql`
    query MfaFeedback($assessmentId: ID!) {
  rubric(assessmentId: $assessmentId) {
    questions {
      questionId
      fieldRubrics {
        markerRubric {
          ...MarkerRubric
        }
      }
    }
  }
  studentWorkOutcome(assessmentId: $assessmentId) {
    ...WorkOutcome
  }
}
    ${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}`;

/**
 * __useMfaFeedbackQuery__
 *
 * To run a query within a React component, call `useMfaFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfaFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfaFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMfaFeedbackQuery(baseOptions: Apollo.QueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables> & ({ variables: MfaFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
      }
export function useMfaFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
        }
export function useMfaFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfaFeedbackQuery, MfaFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfaFeedbackQuery, MfaFeedbackQueryVariables>(MfaFeedbackDocument, options);
        }
export type MfaFeedbackQueryHookResult = ReturnType<typeof useMfaFeedbackQuery>;
export type MfaFeedbackLazyQueryHookResult = ReturnType<typeof useMfaFeedbackLazyQuery>;
export type MfaFeedbackSuspenseQueryHookResult = ReturnType<typeof useMfaFeedbackSuspenseQuery>;
export type MfaFeedbackQueryResult = Apollo.QueryResult<MfaFeedbackQuery, MfaFeedbackQueryVariables>;
export const SimilarityDocument = gql`
    query Similarity($submissionType: SubmissionType!, $workId: ID!) {
  latestResult(submissionType: $submissionType, workId: $workId) {
    id
    workId
    heraResultId
    returnedAt
    similarity {
      display
      label
      value
    }
  }
}
    `;

/**
 * __useSimilarityQuery__
 *
 * To run a query within a React component, call `useSimilarityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarityQuery({
 *   variables: {
 *      submissionType: // value for 'submissionType'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSimilarityQuery(baseOptions: Apollo.QueryHookOptions<SimilarityQuery, SimilarityQueryVariables> & ({ variables: SimilarityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
      }
export function useSimilarityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export function useSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export type SimilarityQueryHookResult = ReturnType<typeof useSimilarityQuery>;
export type SimilarityLazyQueryHookResult = ReturnType<typeof useSimilarityLazyQuery>;
export type SimilaritySuspenseQueryHookResult = ReturnType<typeof useSimilaritySuspenseQuery>;
export type SimilarityQueryResult = Apollo.QueryResult<SimilarityQuery, SimilarityQueryVariables>;
export const AcceptStudentCharterDocument = gql`
    mutation AcceptStudentCharter($input: CharterAgreementInput!) {
  acceptStudentCharter(input: $input) {
    ...CharterAgreement
  }
}
    ${CharterAgreementFragmentDoc}`;
export type AcceptStudentCharterMutationFn = Apollo.MutationFunction<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>;

/**
 * __useAcceptStudentCharterMutation__
 *
 * To run a mutation, you first call `useAcceptStudentCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptStudentCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptStudentCharterMutation, { data, loading, error }] = useAcceptStudentCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptStudentCharterMutation(baseOptions?: Apollo.MutationHookOptions<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>(AcceptStudentCharterDocument, options);
      }
export type AcceptStudentCharterMutationHookResult = ReturnType<typeof useAcceptStudentCharterMutation>;
export type AcceptStudentCharterMutationResult = Apollo.MutationResult<AcceptStudentCharterMutation>;
export type AcceptStudentCharterMutationOptions = Apollo.BaseMutationOptions<AcceptStudentCharterMutation, AcceptStudentCharterMutationVariables>;
export const CharterDocument = gql`
    query Charter($assessmentId: ID!, $charterId: ID!) {
  token
  charter(charterId: $charterId) {
    ...Charter
  }
  charterForm(assessmentId: $assessmentId, published: true) {
    ...CharterForm
  }
}
    ${CharterFragmentDoc}
${CharterFormFragmentDoc}`;

/**
 * __useCharterQuery__
 *
 * To run a query within a React component, call `useCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      charterId: // value for 'charterId'
 *   },
 * });
 */
export function useCharterQuery(baseOptions: Apollo.QueryHookOptions<CharterQuery, CharterQueryVariables> & ({ variables: CharterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
      }
export function useCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export function useCharterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export type CharterQueryHookResult = ReturnType<typeof useCharterQuery>;
export type CharterLazyQueryHookResult = ReturnType<typeof useCharterLazyQuery>;
export type CharterSuspenseQueryHookResult = ReturnType<typeof useCharterSuspenseQuery>;
export type CharterQueryResult = Apollo.QueryResult<CharterQuery, CharterQueryVariables>;
export const CharterStatusDocument = gql`
    query CharterStatus($assessmentId: ID!) {
  studentWorkGroup(assessmentId: $assessmentId) {
    charter {
      allMembersAccepted
    }
  }
}
    `;

/**
 * __useCharterStatusQuery__
 *
 * To run a query within a React component, call `useCharterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterStatusQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCharterStatusQuery(baseOptions: Apollo.QueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables> & ({ variables: CharterStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
      }
export function useCharterStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
        }
export function useCharterStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterStatusQuery, CharterStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterStatusQuery, CharterStatusQueryVariables>(CharterStatusDocument, options);
        }
export type CharterStatusQueryHookResult = ReturnType<typeof useCharterStatusQuery>;
export type CharterStatusLazyQueryHookResult = ReturnType<typeof useCharterStatusLazyQuery>;
export type CharterStatusSuspenseQueryHookResult = ReturnType<typeof useCharterStatusSuspenseQuery>;
export type CharterStatusQueryResult = Apollo.QueryResult<CharterStatusQuery, CharterStatusQueryVariables>;
export const SaveCharterEditorDocument = gql`
    mutation saveCharterEditor($input: CharterEditorInput!) {
  saveCharterEditor(input: $input) {
    id
    charterFormSectionId
    snapshotDoc
    snapshotVersion
    streamUuid
  }
}
    `;
export type SaveCharterEditorMutationFn = Apollo.MutationFunction<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>;

/**
 * __useSaveCharterEditorMutation__
 *
 * To run a mutation, you first call `useSaveCharterEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCharterEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCharterEditorMutation, { data, loading, error }] = useSaveCharterEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCharterEditorMutation(baseOptions?: Apollo.MutationHookOptions<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>(SaveCharterEditorDocument, options);
      }
export type SaveCharterEditorMutationHookResult = ReturnType<typeof useSaveCharterEditorMutation>;
export type SaveCharterEditorMutationResult = Apollo.MutationResult<SaveCharterEditorMutation>;
export type SaveCharterEditorMutationOptions = Apollo.BaseMutationOptions<SaveCharterEditorMutation, SaveCharterEditorMutationVariables>;
export const SetupCharterDocument = gql`
    mutation SetupCharter($groupId: ID!) {
  setupCharter(groupId: $groupId) {
    ...Charter
  }
}
    ${CharterFragmentDoc}`;
export type SetupCharterMutationFn = Apollo.MutationFunction<SetupCharterMutation, SetupCharterMutationVariables>;

/**
 * __useSetupCharterMutation__
 *
 * To run a mutation, you first call `useSetupCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupCharterMutation, { data, loading, error }] = useSetupCharterMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetupCharterMutation(baseOptions?: Apollo.MutationHookOptions<SetupCharterMutation, SetupCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupCharterMutation, SetupCharterMutationVariables>(SetupCharterDocument, options);
      }
export type SetupCharterMutationHookResult = ReturnType<typeof useSetupCharterMutation>;
export type SetupCharterMutationResult = Apollo.MutationResult<SetupCharterMutation>;
export type SetupCharterMutationOptions = Apollo.BaseMutationOptions<SetupCharterMutation, SetupCharterMutationVariables>;
export const UnlockStudentCharterDocument = gql`
    mutation UnlockStudentCharter($input: CharterAgreementInput!) {
  unlockStudentCharter(input: $input) {
    ...CharterAgreement
  }
}
    ${CharterAgreementFragmentDoc}`;
export type UnlockStudentCharterMutationFn = Apollo.MutationFunction<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>;

/**
 * __useUnlockStudentCharterMutation__
 *
 * To run a mutation, you first call `useUnlockStudentCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockStudentCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockStudentCharterMutation, { data, loading, error }] = useUnlockStudentCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockStudentCharterMutation(baseOptions?: Apollo.MutationHookOptions<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>(UnlockStudentCharterDocument, options);
      }
export type UnlockStudentCharterMutationHookResult = ReturnType<typeof useUnlockStudentCharterMutation>;
export type UnlockStudentCharterMutationResult = Apollo.MutationResult<UnlockStudentCharterMutation>;
export type UnlockStudentCharterMutationOptions = Apollo.BaseMutationOptions<UnlockStudentCharterMutation, UnlockStudentCharterMutationVariables>;
export const UpdateMilestonesDocument = gql`
    mutation UpdateMilestones($input: UpdateMilestonesInput!) {
  updateMilestones(input: $input) {
    id
    milestones {
      deleted
      description
      dueDate
      id
      title
    }
  }
}
    `;
export type UpdateMilestonesMutationFn = Apollo.MutationFunction<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>;

/**
 * __useUpdateMilestonesMutation__
 *
 * To run a mutation, you first call `useUpdateMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestonesMutation, { data, loading, error }] = useUpdateMilestonesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMilestonesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>(UpdateMilestonesDocument, options);
      }
export type UpdateMilestonesMutationHookResult = ReturnType<typeof useUpdateMilestonesMutation>;
export type UpdateMilestonesMutationResult = Apollo.MutationResult<UpdateMilestonesMutation>;
export type UpdateMilestonesMutationOptions = Apollo.BaseMutationOptions<UpdateMilestonesMutation, UpdateMilestonesMutationVariables>;
export const GroupUpdatedDocument = gql`
    subscription groupUpdated($assessmentId: ID!) {
  groupUpdated(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables> & ({ variables: GroupUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>(GroupUpdatedDocument, options);
      }
export type GroupUpdatedSubscriptionHookResult = ReturnType<typeof useGroupUpdatedSubscription>;
export type GroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<GroupUpdatedSubscription>;
export const ListGroupsDocument = gql`
    query ListGroups($assessmentId: ID!) {
  groupList(assessmentId: $assessmentId) {
    ...Group
  }
  token
  me {
    id
    name
  }
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      id
      groupSelfEnrollmentDeadline
      groupFinalised
    }
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables> & ({ variables: ListGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsSuspenseQueryHookResult = ReturnType<typeof useListGroupsSuspenseQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export const JoinGroupDocument = gql`
    mutation JoinGroup($assessmentId: ID!, $groupId: ID!) {
  joinGroup(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type JoinGroupMutationFn = Apollo.MutationFunction<JoinGroupMutation, JoinGroupMutationVariables>;

/**
 * __useJoinGroupMutation__
 *
 * To run a mutation, you first call `useJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupMutation, { data, loading, error }] = useJoinGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupMutation, JoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupMutation, JoinGroupMutationVariables>(JoinGroupDocument, options);
      }
export type JoinGroupMutationHookResult = ReturnType<typeof useJoinGroupMutation>;
export type JoinGroupMutationResult = Apollo.MutationResult<JoinGroupMutation>;
export type JoinGroupMutationOptions = Apollo.BaseMutationOptions<JoinGroupMutation, JoinGroupMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation leaveGroup($assessmentId: ID!, $groupId: ID!) {
  leaveGroup(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const PeerOverviewDocument = gql`
    query PeerOverview($assessmentId: ID!) {
  me {
    id
    name
  }
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      selfEvaluationEnabled
      groupCharterEnabled
    }
  }
  peerRubric(assessmentId: $assessmentId) {
    id
    criteria {
      ...Criterion
    }
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    work {
      id
    }
    charter {
      latestAgreement {
        id
        acceptedAt
      }
    }
    group {
      id
      members {
        id
        name
      }
    }
  }
  groupPeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
}
    ${CriterionFragmentDoc}
${GroupPeerOutcomeFragmentDoc}`;

/**
 * __usePeerOverviewQuery__
 *
 * To run a query within a React component, call `usePeerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeerOverviewQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePeerOverviewQuery(baseOptions: Apollo.QueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables> & ({ variables: PeerOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
      }
export function usePeerOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
        }
export function usePeerOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeerOverviewQuery, PeerOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeerOverviewQuery, PeerOverviewQueryVariables>(PeerOverviewDocument, options);
        }
export type PeerOverviewQueryHookResult = ReturnType<typeof usePeerOverviewQuery>;
export type PeerOverviewLazyQueryHookResult = ReturnType<typeof usePeerOverviewLazyQuery>;
export type PeerOverviewSuspenseQueryHookResult = ReturnType<typeof usePeerOverviewSuspenseQuery>;
export type PeerOverviewQueryResult = Apollo.QueryResult<PeerOverviewQuery, PeerOverviewQueryVariables>;
export const ProjectIssuesDocument = gql`
    query ProjectIssues($groupId: ID!) {
  projectIssues(groupId: $groupId) {
    id
    title
    type
    status
    groupId
    deleted
    description
    dueDate
    parentId
    assignees
  }
}
    `;

/**
 * __useProjectIssuesQuery__
 *
 * To run a query within a React component, call `useProjectIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectIssuesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useProjectIssuesQuery(baseOptions: Apollo.QueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables> & ({ variables: ProjectIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
      }
export function useProjectIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
        }
export function useProjectIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectIssuesQuery, ProjectIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectIssuesQuery, ProjectIssuesQueryVariables>(ProjectIssuesDocument, options);
        }
export type ProjectIssuesQueryHookResult = ReturnType<typeof useProjectIssuesQuery>;
export type ProjectIssuesLazyQueryHookResult = ReturnType<typeof useProjectIssuesLazyQuery>;
export type ProjectIssuesSuspenseQueryHookResult = ReturnType<typeof useProjectIssuesSuspenseQuery>;
export type ProjectIssuesQueryResult = Apollo.QueryResult<ProjectIssuesQuery, ProjectIssuesQueryVariables>;
export const UpdateProjectIssueDocument = gql`
    mutation UpdateProjectIssue($input: UpdateProjectIssueInput!) {
  updateProjectIssue(input: $input) {
    id
    title
    type
    status
    deleted
    description
    dueDate
    assignees
    parentId
  }
}
    `;
export type UpdateProjectIssueMutationFn = Apollo.MutationFunction<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>;

/**
 * __useUpdateProjectIssueMutation__
 *
 * To run a mutation, you first call `useUpdateProjectIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectIssueMutation, { data, loading, error }] = useUpdateProjectIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectIssueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>(UpdateProjectIssueDocument, options);
      }
export type UpdateProjectIssueMutationHookResult = ReturnType<typeof useUpdateProjectIssueMutation>;
export type UpdateProjectIssueMutationResult = Apollo.MutationResult<UpdateProjectIssueMutation>;
export type UpdateProjectIssueMutationOptions = Apollo.BaseMutationOptions<UpdateProjectIssueMutation, UpdateProjectIssueMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($assessmentId: ID!, $message: MessageInput!) {
  sendMessage(assessmentId: $assessmentId, message: $message) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SetupGroupWorkDocument = gql`
    mutation SetupGroupWork($groupId: ID!) {
  setupGroupWork(groupId: $groupId) {
    id
    work {
      id
    }
  }
}
    `;
export type SetupGroupWorkMutationFn = Apollo.MutationFunction<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>;

/**
 * __useSetupGroupWorkMutation__
 *
 * To run a mutation, you first call `useSetupGroupWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupGroupWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupGroupWorkMutation, { data, loading, error }] = useSetupGroupWorkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetupGroupWorkMutation(baseOptions?: Apollo.MutationHookOptions<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>(SetupGroupWorkDocument, options);
      }
export type SetupGroupWorkMutationHookResult = ReturnType<typeof useSetupGroupWorkMutation>;
export type SetupGroupWorkMutationResult = Apollo.MutationResult<SetupGroupWorkMutation>;
export type SetupGroupWorkMutationOptions = Apollo.BaseMutationOptions<SetupGroupWorkMutation, SetupGroupWorkMutationVariables>;
export const WorkGroupDocument = gql`
    query WorkGroup($assessmentId: ID!) {
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    finalised
    latestGroupChangeRequest(assessmentId: $assessmentId) {
      ...Message
    }
    charter {
      ...Charter
    }
    group {
      ...Group
    }
    work {
      id
      result(submissionType: FINAL) {
        id
      }
    }
    individualWork {
      id
      result(submissionType: FINAL) {
        id
      }
    }
  }
}
    ${MessageFragmentDoc}
${CharterFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useWorkGroupQuery__
 *
 * To run a query within a React component, call `useWorkGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkGroupQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useWorkGroupQuery(baseOptions: Apollo.QueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables> & ({ variables: WorkGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
      }
export function useWorkGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
        }
export function useWorkGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkGroupQuery, WorkGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkGroupQuery, WorkGroupQueryVariables>(WorkGroupDocument, options);
        }
export type WorkGroupQueryHookResult = ReturnType<typeof useWorkGroupQuery>;
export type WorkGroupLazyQueryHookResult = ReturnType<typeof useWorkGroupLazyQuery>;
export type WorkGroupSuspenseQueryHookResult = ReturnType<typeof useWorkGroupSuspenseQuery>;
export type WorkGroupQueryResult = Apollo.QueryResult<WorkGroupQuery, WorkGroupQueryVariables>;
export const CompletePeerOutcomesDocument = gql`
    mutation CompletePeerOutcomes($assessmentId: ID!) {
  completePeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
}
    ${GroupPeerOutcomeFragmentDoc}`;
export type CompletePeerOutcomesMutationFn = Apollo.MutationFunction<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>;

/**
 * __useCompletePeerOutcomesMutation__
 *
 * To run a mutation, you first call `useCompletePeerOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePeerOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePeerOutcomesMutation, { data, loading, error }] = useCompletePeerOutcomesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCompletePeerOutcomesMutation(baseOptions?: Apollo.MutationHookOptions<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>(CompletePeerOutcomesDocument, options);
      }
export type CompletePeerOutcomesMutationHookResult = ReturnType<typeof useCompletePeerOutcomesMutation>;
export type CompletePeerOutcomesMutationResult = Apollo.MutationResult<CompletePeerOutcomesMutation>;
export type CompletePeerOutcomesMutationOptions = Apollo.BaseMutationOptions<CompletePeerOutcomesMutation, CompletePeerOutcomesMutationVariables>;
export const MarkPeerOutcomeDocument = gql`
    mutation MarkPeerOutcome($assessmentId: ID!, $input: MarkPeerOutcomeInput!) {
  markPeerOutcome(assessmentId: $assessmentId, input: $input) {
    ...GroupPeerOutcome
  }
}
    ${GroupPeerOutcomeFragmentDoc}`;
export type MarkPeerOutcomeMutationFn = Apollo.MutationFunction<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>;

/**
 * __useMarkPeerOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkPeerOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPeerOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPeerOutcomeMutation, { data, loading, error }] = useMarkPeerOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkPeerOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>(MarkPeerOutcomeDocument, options);
      }
export type MarkPeerOutcomeMutationHookResult = ReturnType<typeof useMarkPeerOutcomeMutation>;
export type MarkPeerOutcomeMutationResult = Apollo.MutationResult<MarkPeerOutcomeMutation>;
export type MarkPeerOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkPeerOutcomeMutation, MarkPeerOutcomeMutationVariables>;
export const PeerAssessmentDocument = gql`
    query PeerAssessment($assessmentId: ID!) {
  me {
    ...User
  }
  studentWorkGroup(assessmentId: $assessmentId) {
    id
    group {
      ...Group
    }
  }
  peerRubric(assessmentId: $assessmentId) {
    id
    criteria {
      ...Criterion
    }
  }
  groupPeerOutcomes(assessmentId: $assessmentId) {
    ...GroupPeerOutcome
  }
  instructionSheet(assessmentId: $assessmentId, kind: PEER) {
    ...Sheet
  }
}
    ${UserFragmentDoc}
${GroupFragmentDoc}
${CriterionFragmentDoc}
${GroupPeerOutcomeFragmentDoc}
${SheetFragmentDoc}`;

/**
 * __usePeerAssessmentQuery__
 *
 * To run a query within a React component, call `usePeerAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeerAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeerAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePeerAssessmentQuery(baseOptions: Apollo.QueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables> & ({ variables: PeerAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
      }
export function usePeerAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
        }
export function usePeerAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeerAssessmentQuery, PeerAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeerAssessmentQuery, PeerAssessmentQueryVariables>(PeerAssessmentDocument, options);
        }
export type PeerAssessmentQueryHookResult = ReturnType<typeof usePeerAssessmentQuery>;
export type PeerAssessmentLazyQueryHookResult = ReturnType<typeof usePeerAssessmentLazyQuery>;
export type PeerAssessmentSuspenseQueryHookResult = ReturnType<typeof usePeerAssessmentSuspenseQuery>;
export type PeerAssessmentQueryResult = Apollo.QueryResult<PeerAssessmentQuery, PeerAssessmentQueryVariables>;
export const ResetGivenEvaluationsDocument = gql`
    mutation ResetGivenEvaluations($assessmentId: ID!) {
  resetCriterionOutcomes(assessmentId: $assessmentId)
}
    `;
export type ResetGivenEvaluationsMutationFn = Apollo.MutationFunction<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>;

/**
 * __useResetGivenEvaluationsMutation__
 *
 * To run a mutation, you first call `useResetGivenEvaluationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGivenEvaluationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGivenEvaluationsMutation, { data, loading, error }] = useResetGivenEvaluationsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetGivenEvaluationsMutation(baseOptions?: Apollo.MutationHookOptions<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>(ResetGivenEvaluationsDocument, options);
      }
export type ResetGivenEvaluationsMutationHookResult = ReturnType<typeof useResetGivenEvaluationsMutation>;
export type ResetGivenEvaluationsMutationResult = Apollo.MutationResult<ResetGivenEvaluationsMutation>;
export type ResetGivenEvaluationsMutationOptions = Apollo.BaseMutationOptions<ResetGivenEvaluationsMutation, ResetGivenEvaluationsMutationVariables>;
export const SubmitSentimentCheckDocument = gql`
    mutation SubmitSentimentCheck($assessmentId: ID!, $input: SentimentCheckInput!) {
  submitSentimentCheck(assessmentId: $assessmentId, input: $input) {
    ...SentimentCheck
  }
}
    ${SentimentCheckFragmentDoc}`;
export type SubmitSentimentCheckMutationFn = Apollo.MutationFunction<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>;

/**
 * __useSubmitSentimentCheckMutation__
 *
 * To run a mutation, you first call `useSubmitSentimentCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSentimentCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSentimentCheckMutation, { data, loading, error }] = useSubmitSentimentCheckMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSentimentCheckMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>(SubmitSentimentCheckDocument, options);
      }
export type SubmitSentimentCheckMutationHookResult = ReturnType<typeof useSubmitSentimentCheckMutation>;
export type SubmitSentimentCheckMutationResult = Apollo.MutationResult<SubmitSentimentCheckMutation>;
export type SubmitSentimentCheckMutationOptions = Apollo.BaseMutationOptions<SubmitSentimentCheckMutation, SubmitSentimentCheckMutationVariables>;
export const CreateBlockAttachmentDocument = gql`
    mutation CreateBlockAttachment($answerBlockId: ID!, $mediaId: ID!, $mediaUrl: String!) {
  createBlockAttachment(
    answerBlockId: $answerBlockId
    mediaId: $mediaId
    mediaUrl: $mediaUrl
  ) {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export type CreateBlockAttachmentMutationFn = Apollo.MutationFunction<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>;

/**
 * __useCreateBlockAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateBlockAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockAttachmentMutation, { data, loading, error }] = useCreateBlockAttachmentMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      mediaId: // value for 'mediaId'
 *      mediaUrl: // value for 'mediaUrl'
 *   },
 * });
 */
export function useCreateBlockAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>(CreateBlockAttachmentDocument, options);
      }
export type CreateBlockAttachmentMutationHookResult = ReturnType<typeof useCreateBlockAttachmentMutation>;
export type CreateBlockAttachmentMutationResult = Apollo.MutationResult<CreateBlockAttachmentMutation>;
export type CreateBlockAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateBlockAttachmentMutation, CreateBlockAttachmentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($threadId: ID!, $content: String!) {
  createComment(threadId: $threadId, content: $content) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($threadId: ID!, $input: ThreadInput!) {
  createThread(threadId: $threadId, input: $input) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    id
    email
    name
    givenName
    familyName
    colourset
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    id
    createdBy {
      id
      name
    }
  }
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const EditCommentDocument = gql`
    mutation EditComment($commentId: ID!, $content: String!) {
  editComment(commentId: $commentId, content: $content) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type EditCommentMutationFn = Apollo.MutationFunction<EditCommentMutation, EditCommentMutationVariables>;

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditCommentMutation, EditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommentMutation, EditCommentMutationVariables>(EditCommentDocument, options);
      }
export type EditCommentMutationHookResult = ReturnType<typeof useEditCommentMutation>;
export type EditCommentMutationResult = Apollo.MutationResult<EditCommentMutation>;
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<EditCommentMutation, EditCommentMutationVariables>;
export const EntityThreadsDocument = gql`
    query EntityThreads($entityType: EntityType!, $entityIds: [ID!]!) {
  entityThreads(entityType: $entityType, entityIds: $entityIds) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useEntityThreadsQuery__
 *
 * To run a query within a React component, call `useEntityThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityThreadsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityThreadsQuery(baseOptions: Apollo.QueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables> & ({ variables: EntityThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
      }
export function useEntityThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export function useEntityThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export type EntityThreadsQueryHookResult = ReturnType<typeof useEntityThreadsQuery>;
export type EntityThreadsLazyQueryHookResult = ReturnType<typeof useEntityThreadsLazyQuery>;
export type EntityThreadsSuspenseQueryHookResult = ReturnType<typeof useEntityThreadsSuspenseQuery>;
export type EntityThreadsQueryResult = Apollo.QueryResult<EntityThreadsQuery, EntityThreadsQueryVariables>;
export const OnEntityThreadsUpdatedDocument = gql`
    subscription onEntityThreadsUpdated($entityId: ID!, $entityType: EntityType!) {
  entityThreadsUpdated(entityId: $entityId, entityType: $entityType) {
    ...EntityThreadEvent
  }
}
    ${EntityThreadEventFragmentDoc}`;

/**
 * __useOnEntityThreadsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityThreadsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityThreadsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityThreadsUpdatedSubscription({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useOnEntityThreadsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables> & ({ variables: OnEntityThreadsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables>(OnEntityThreadsUpdatedDocument, options);
      }
export type OnEntityThreadsUpdatedSubscriptionHookResult = ReturnType<typeof useOnEntityThreadsUpdatedSubscription>;
export type OnEntityThreadsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnEntityThreadsUpdatedSubscription>;
export const UpdateExperienceDocument = gql`
    mutation UpdateExperience($workId: ID!, $score: Int!) {
  updateExperience(workId: $workId, score: $score) {
    id
    score
    active
  }
}
    `;
export type UpdateExperienceMutationFn = Apollo.MutationFunction<UpdateExperienceMutation, UpdateExperienceMutationVariables>;

/**
 * __useUpdateExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperienceMutation, { data, loading, error }] = useUpdateExperienceMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useUpdateExperienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperienceMutation, UpdateExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperienceMutation, UpdateExperienceMutationVariables>(UpdateExperienceDocument, options);
      }
export type UpdateExperienceMutationHookResult = ReturnType<typeof useUpdateExperienceMutation>;
export type UpdateExperienceMutationResult = Apollo.MutationResult<UpdateExperienceMutation>;
export type UpdateExperienceMutationOptions = Apollo.BaseMutationOptions<UpdateExperienceMutation, UpdateExperienceMutationVariables>;
export const ExperienceDocument = gql`
    query Experience($workId: ID!, $assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    subjectId
  }
  work(workId: $workId) {
    id
    experience {
      id
      score
      active
    }
  }
}
    `;

/**
 * __useExperienceQuery__
 *
 * To run a query within a React component, call `useExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useExperienceQuery(baseOptions: Apollo.QueryHookOptions<ExperienceQuery, ExperienceQueryVariables> & ({ variables: ExperienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
      }
export function useExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperienceQuery, ExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
        }
export function useExperienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperienceQuery, ExperienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperienceQuery, ExperienceQueryVariables>(ExperienceDocument, options);
        }
export type ExperienceQueryHookResult = ReturnType<typeof useExperienceQuery>;
export type ExperienceLazyQueryHookResult = ReturnType<typeof useExperienceLazyQuery>;
export type ExperienceSuspenseQueryHookResult = ReturnType<typeof useExperienceSuspenseQuery>;
export type ExperienceQueryResult = Apollo.QueryResult<ExperienceQuery, ExperienceQueryVariables>;
export const LatestResultDocument = gql`
    query LatestResult($workId: ID!, $type: SubmissionType!) {
  latestResult(workId: $workId, submissionType: $type) {
    ...ResultLine
  }
}
    ${ResultLineFragmentDoc}`;

/**
 * __useLatestResultQuery__
 *
 * To run a query within a React component, call `useLatestResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestResultQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLatestResultQuery(baseOptions: Apollo.QueryHookOptions<LatestResultQuery, LatestResultQueryVariables> & ({ variables: LatestResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
      }
export function useLatestResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestResultQuery, LatestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
        }
export function useLatestResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestResultQuery, LatestResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestResultQuery, LatestResultQueryVariables>(LatestResultDocument, options);
        }
export type LatestResultQueryHookResult = ReturnType<typeof useLatestResultQuery>;
export type LatestResultLazyQueryHookResult = ReturnType<typeof useLatestResultLazyQuery>;
export type LatestResultSuspenseQueryHookResult = ReturnType<typeof useLatestResultSuspenseQuery>;
export type LatestResultQueryResult = Apollo.QueryResult<LatestResultQuery, LatestResultQueryVariables>;
export const OnResultUpdatedDocument = gql`
    subscription onResultUpdated($workId: ID!) {
  workResultUpdated(workId: $workId) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;

/**
 * __useOnResultUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnResultUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnResultUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnResultUpdatedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnResultUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnResultUpdatedSubscription, OnResultUpdatedSubscriptionVariables> & ({ variables: OnResultUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnResultUpdatedSubscription, OnResultUpdatedSubscriptionVariables>(OnResultUpdatedDocument, options);
      }
export type OnResultUpdatedSubscriptionHookResult = ReturnType<typeof useOnResultUpdatedSubscription>;
export type OnResultUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnResultUpdatedSubscription>;
export const RemoveBlockAttachmentDocument = gql`
    mutation RemoveBlockAttachment($blockAttachmentId: ID!) {
  removeBlockAttachment(blockAttachmentId: $blockAttachmentId) {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export type RemoveBlockAttachmentMutationFn = Apollo.MutationFunction<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>;

/**
 * __useRemoveBlockAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveBlockAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockAttachmentMutation, { data, loading, error }] = useRemoveBlockAttachmentMutation({
 *   variables: {
 *      blockAttachmentId: // value for 'blockAttachmentId'
 *   },
 * });
 */
export function useRemoveBlockAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>(RemoveBlockAttachmentDocument, options);
      }
export type RemoveBlockAttachmentMutationHookResult = ReturnType<typeof useRemoveBlockAttachmentMutation>;
export type RemoveBlockAttachmentMutationResult = Apollo.MutationResult<RemoveBlockAttachmentMutation>;
export type RemoveBlockAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveBlockAttachmentMutation, RemoveBlockAttachmentMutationVariables>;
export const ResolveThreadDocument = gql`
    mutation ResolveThread($threadId: ID!) {
  updateThreadResolution(threadId: $threadId, resolved: true) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type ResolveThreadMutationFn = Apollo.MutationFunction<ResolveThreadMutation, ResolveThreadMutationVariables>;

/**
 * __useResolveThreadMutation__
 *
 * To run a mutation, you first call `useResolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveThreadMutation, { data, loading, error }] = useResolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useResolveThreadMutation(baseOptions?: Apollo.MutationHookOptions<ResolveThreadMutation, ResolveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveThreadMutation, ResolveThreadMutationVariables>(ResolveThreadDocument, options);
      }
export type ResolveThreadMutationHookResult = ReturnType<typeof useResolveThreadMutation>;
export type ResolveThreadMutationResult = Apollo.MutationResult<ResolveThreadMutation>;
export type ResolveThreadMutationOptions = Apollo.BaseMutationOptions<ResolveThreadMutation, ResolveThreadMutationVariables>;
export const SaveBlockSnapshotDocument = gql`
    mutation SaveBlockSnapshot($workId: ID!, $answerBlockId: ID!, $snapshotContent: String!, $version: Int!, $previousBlockSnapshotId: ID, $wordCountChange: String) {
  saveBlockSnapshot(
    workId: $workId
    answerBlockId: $answerBlockId
    snapshotContent: $snapshotContent
    version: $version
    previousBlockSnapshotId: $previousBlockSnapshotId
    wordCountChange: $wordCountChange
  ) {
    blockSnapshot {
      id
      cacheId
      version
      blockName
    }
  }
}
    `;
export type SaveBlockSnapshotMutationFn = Apollo.MutationFunction<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>;

/**
 * __useSaveBlockSnapshotMutation__
 *
 * To run a mutation, you first call `useSaveBlockSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBlockSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBlockSnapshotMutation, { data, loading, error }] = useSaveBlockSnapshotMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      answerBlockId: // value for 'answerBlockId'
 *      snapshotContent: // value for 'snapshotContent'
 *      version: // value for 'version'
 *      previousBlockSnapshotId: // value for 'previousBlockSnapshotId'
 *      wordCountChange: // value for 'wordCountChange'
 *   },
 * });
 */
export function useSaveBlockSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>(SaveBlockSnapshotDocument, options);
      }
export type SaveBlockSnapshotMutationHookResult = ReturnType<typeof useSaveBlockSnapshotMutation>;
export type SaveBlockSnapshotMutationResult = Apollo.MutationResult<SaveBlockSnapshotMutation>;
export type SaveBlockSnapshotMutationOptions = Apollo.BaseMutationOptions<SaveBlockSnapshotMutation, SaveBlockSnapshotMutationVariables>;
export const SaveDocument = gql`
    mutation Save($workId: ID!, $content: String!, $dispatchedAt: DateTime!, $metadata: SaveMetadataInput, $editor: EditorType) {
  save(
    editor: $editor
    workId: $workId
    content: $content
    dispatchedAt: $dispatchedAt
    metadata: $metadata
  ) {
    id
    serverId
    version
    content
    dispatchedAt
  }
}
    `;
export type SaveMutationFn = Apollo.MutationFunction<SaveMutation, SaveMutationVariables>;

/**
 * __useSaveMutation__
 *
 * To run a mutation, you first call `useSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMutation, { data, loading, error }] = useSaveMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      content: // value for 'content'
 *      dispatchedAt: // value for 'dispatchedAt'
 *      metadata: // value for 'metadata'
 *      editor: // value for 'editor'
 *   },
 * });
 */
export function useSaveMutation(baseOptions?: Apollo.MutationHookOptions<SaveMutation, SaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMutation, SaveMutationVariables>(SaveDocument, options);
      }
export type SaveMutationHookResult = ReturnType<typeof useSaveMutation>;
export type SaveMutationResult = Apollo.MutationResult<SaveMutation>;
export type SaveMutationOptions = Apollo.BaseMutationOptions<SaveMutation, SaveMutationVariables>;
export const StartDocument = gql`
    mutation Start($workId: ID!) {
  start(workId: $workId) {
    id
    startDate
  }
}
    `;
export type StartMutationFn = Apollo.MutationFunction<StartMutation, StartMutationVariables>;

/**
 * __useStartMutation__
 *
 * To run a mutation, you first call `useStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMutation, { data, loading, error }] = useStartMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useStartMutation(baseOptions?: Apollo.MutationHookOptions<StartMutation, StartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMutation, StartMutationVariables>(StartDocument, options);
      }
export type StartMutationHookResult = ReturnType<typeof useStartMutation>;
export type StartMutationResult = Apollo.MutationResult<StartMutation>;
export type StartMutationOptions = Apollo.BaseMutationOptions<StartMutation, StartMutationVariables>;
export const SubmissionDocument = gql`
    query Submission($workId: ID!, $submissionType: SubmissionType!) {
  work(workId: $workId) {
    id
    result(submissionType: $submissionType) {
      id
      submission {
        ...Submission
      }
    }
  }
}
    ${SubmissionFragmentDoc}`;

/**
 * __useSubmissionQuery__
 *
 * To run a query within a React component, call `useSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *      submissionType: // value for 'submissionType'
 *   },
 * });
 */
export function useSubmissionQuery(baseOptions: Apollo.QueryHookOptions<SubmissionQuery, SubmissionQueryVariables> & ({ variables: SubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
      }
export function useSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export function useSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export type SubmissionQueryHookResult = ReturnType<typeof useSubmissionQuery>;
export type SubmissionLazyQueryHookResult = ReturnType<typeof useSubmissionLazyQuery>;
export type SubmissionSuspenseQueryHookResult = ReturnType<typeof useSubmissionSuspenseQuery>;
export type SubmissionQueryResult = Apollo.QueryResult<SubmissionQuery, SubmissionQueryVariables>;
export const SubmitAttemptDocument = gql`
    mutation submitAttempt($workId: ID!, $type: SubmissionType!, $attemptNumber: Int!) {
  submitAttempt(workId: $workId, type: $type, attemptNumber: $attemptNumber) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type SubmitAttemptMutationFn = Apollo.MutationFunction<SubmitAttemptMutation, SubmitAttemptMutationVariables>;

/**
 * __useSubmitAttemptMutation__
 *
 * To run a mutation, you first call `useSubmitAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAttemptMutation, { data, loading, error }] = useSubmitAttemptMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      type: // value for 'type'
 *      attemptNumber: // value for 'attemptNumber'
 *   },
 * });
 */
export function useSubmitAttemptMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAttemptMutation, SubmitAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAttemptMutation, SubmitAttemptMutationVariables>(SubmitAttemptDocument, options);
      }
export type SubmitAttemptMutationHookResult = ReturnType<typeof useSubmitAttemptMutation>;
export type SubmitAttemptMutationResult = Apollo.MutationResult<SubmitAttemptMutation>;
export type SubmitAttemptMutationOptions = Apollo.BaseMutationOptions<SubmitAttemptMutation, SubmitAttemptMutationVariables>;
export const SubmitDocument = gql`
    mutation Submit($workId: ID!, $saveId: ID!, $type: SubmissionType!, $submittedAt: DateTime!, $acceptedDeclaration: Boolean!, $sessionId: String, $editor: EditorType) {
  submit(
    editor: $editor
    workId: $workId
    saveId: $saveId
    type: $type
    submittedAt: $submittedAt
    acceptedDeclaration: $acceptedDeclaration
    sessionId: $sessionId
  ) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;
export type SubmitMutationFn = Apollo.MutationFunction<SubmitMutation, SubmitMutationVariables>;

/**
 * __useSubmitMutation__
 *
 * To run a mutation, you first call `useSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMutation, { data, loading, error }] = useSubmitMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      saveId: // value for 'saveId'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *      acceptedDeclaration: // value for 'acceptedDeclaration'
 *      sessionId: // value for 'sessionId'
 *      editor: // value for 'editor'
 *   },
 * });
 */
export function useSubmitMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMutation, SubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMutation, SubmitMutationVariables>(SubmitDocument, options);
      }
export type SubmitMutationHookResult = ReturnType<typeof useSubmitMutation>;
export type SubmitMutationResult = Apollo.MutationResult<SubmitMutation>;
export type SubmitMutationOptions = Apollo.BaseMutationOptions<SubmitMutation, SubmitMutationVariables>;
export const OnThreadConversationUpdatedDocument = gql`
    subscription onThreadConversationUpdated($threadId: ID!) {
  threadConversationUpdated(threadId: $threadId) {
    ...ConversationEvent
  }
}
    ${ConversationEventFragmentDoc}`;

/**
 * __useOnThreadConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnThreadConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnThreadConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnThreadConversationUpdatedSubscription({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useOnThreadConversationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnThreadConversationUpdatedSubscription, OnThreadConversationUpdatedSubscriptionVariables> & ({ variables: OnThreadConversationUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnThreadConversationUpdatedSubscription, OnThreadConversationUpdatedSubscriptionVariables>(OnThreadConversationUpdatedDocument, options);
      }
export type OnThreadConversationUpdatedSubscriptionHookResult = ReturnType<typeof useOnThreadConversationUpdatedSubscription>;
export type OnThreadConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnThreadConversationUpdatedSubscription>;
export const ThreadDocument = gql`
    query Thread($id: ID!) {
  thread(threadId: $id) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useThreadQuery__
 *
 * To run a query within a React component, call `useThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThreadQuery(baseOptions: Apollo.QueryHookOptions<ThreadQuery, ThreadQueryVariables> & ({ variables: ThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
      }
export function useThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadQuery, ThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
        }
export function useThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreadQuery, ThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreadQuery, ThreadQueryVariables>(ThreadDocument, options);
        }
export type ThreadQueryHookResult = ReturnType<typeof useThreadQuery>;
export type ThreadLazyQueryHookResult = ReturnType<typeof useThreadLazyQuery>;
export type ThreadSuspenseQueryHookResult = ReturnType<typeof useThreadSuspenseQuery>;
export type ThreadQueryResult = Apollo.QueryResult<ThreadQuery, ThreadQueryVariables>;
export const OnThreadUpdatedDocument = gql`
    subscription onThreadUpdated($id: ID!) {
  threadUpdated(threadId: $id) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useOnThreadUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnThreadUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnThreadUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnThreadUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnThreadUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnThreadUpdatedSubscription, OnThreadUpdatedSubscriptionVariables> & ({ variables: OnThreadUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnThreadUpdatedSubscription, OnThreadUpdatedSubscriptionVariables>(OnThreadUpdatedDocument, options);
      }
export type OnThreadUpdatedSubscriptionHookResult = ReturnType<typeof useOnThreadUpdatedSubscription>;
export type OnThreadUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnThreadUpdatedSubscription>;
export const UnresolveThreadDocument = gql`
    mutation UnresolveThread($threadId: ID!) {
  updateThreadResolution(threadId: $threadId, resolved: false) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type UnresolveThreadMutationFn = Apollo.MutationFunction<UnresolveThreadMutation, UnresolveThreadMutationVariables>;

/**
 * __useUnresolveThreadMutation__
 *
 * To run a mutation, you first call `useUnresolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnresolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unresolveThreadMutation, { data, loading, error }] = useUnresolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useUnresolveThreadMutation(baseOptions?: Apollo.MutationHookOptions<UnresolveThreadMutation, UnresolveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnresolveThreadMutation, UnresolveThreadMutationVariables>(UnresolveThreadDocument, options);
      }
export type UnresolveThreadMutationHookResult = ReturnType<typeof useUnresolveThreadMutation>;
export type UnresolveThreadMutationResult = Apollo.MutationResult<UnresolveThreadMutation>;
export type UnresolveThreadMutationOptions = Apollo.BaseMutationOptions<UnresolveThreadMutation, UnresolveThreadMutationVariables>;
export const UnsubmitDocument = gql`
    mutation Unsubmit($workId: ID!, $submissionId: ID!) {
  unsubmit(workId: $workId, submissionId: $submissionId) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;
export type UnsubmitMutationFn = Apollo.MutationFunction<UnsubmitMutation, UnsubmitMutationVariables>;

/**
 * __useUnsubmitMutation__
 *
 * To run a mutation, you first call `useUnsubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubmitMutation, { data, loading, error }] = useUnsubmitMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useUnsubmitMutation(baseOptions?: Apollo.MutationHookOptions<UnsubmitMutation, UnsubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubmitMutation, UnsubmitMutationVariables>(UnsubmitDocument, options);
      }
export type UnsubmitMutationHookResult = ReturnType<typeof useUnsubmitMutation>;
export type UnsubmitMutationResult = Apollo.MutationResult<UnsubmitMutation>;
export type UnsubmitMutationOptions = Apollo.BaseMutationOptions<UnsubmitMutation, UnsubmitMutationVariables>;
export const UpdateAnswerBlockDocument = gql`
    mutation UpdateAnswerBlock($answerBlockId: ID!, $input: UpdateAnswerBlockInput!) {
  updateAnswerBlock(answerBlockId: $answerBlockId, input: $input) {
    id
    skip
    bookmark
    confirm
  }
}
    `;
export type UpdateAnswerBlockMutationFn = Apollo.MutationFunction<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>;

/**
 * __useUpdateAnswerBlockMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerBlockMutation, { data, loading, error }] = useUpdateAnswerBlockMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnswerBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>(UpdateAnswerBlockDocument, options);
      }
export type UpdateAnswerBlockMutationHookResult = ReturnType<typeof useUpdateAnswerBlockMutation>;
export type UpdateAnswerBlockMutationResult = Apollo.MutationResult<UpdateAnswerBlockMutation>;
export type UpdateAnswerBlockMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerBlockMutation, UpdateAnswerBlockMutationVariables>;
export const VerifyAccessCodeDocument = gql`
    mutation VerifyAccessCode($code: String!, $assessmentId: ID!) {
  verifyAccessCode(code: $code, assessmentId: $assessmentId) {
    ...Session
  }
}
    ${SessionFragmentDoc}`;
export type VerifyAccessCodeMutationFn = Apollo.MutationFunction<VerifyAccessCodeMutation, VerifyAccessCodeMutationVariables>;

/**
 * __useVerifyAccessCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccessCodeMutation, { data, loading, error }] = useVerifyAccessCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useVerifyAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAccessCodeMutation, VerifyAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAccessCodeMutation, VerifyAccessCodeMutationVariables>(VerifyAccessCodeDocument, options);
      }
export type VerifyAccessCodeMutationHookResult = ReturnType<typeof useVerifyAccessCodeMutation>;
export type VerifyAccessCodeMutationResult = Apollo.MutationResult<VerifyAccessCodeMutation>;
export type VerifyAccessCodeMutationOptions = Apollo.BaseMutationOptions<VerifyAccessCodeMutation, VerifyAccessCodeMutationVariables>;
export const WorkDueDateDocument = gql`
    query WorkDueDate($workId: ID!) {
  work(workId: $workId) {
    id
    dueDate
  }
}
    `;

/**
 * __useWorkDueDateQuery__
 *
 * To run a query within a React component, call `useWorkDueDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkDueDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkDueDateQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useWorkDueDateQuery(baseOptions: Apollo.QueryHookOptions<WorkDueDateQuery, WorkDueDateQueryVariables> & ({ variables: WorkDueDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkDueDateQuery, WorkDueDateQueryVariables>(WorkDueDateDocument, options);
      }
export function useWorkDueDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkDueDateQuery, WorkDueDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkDueDateQuery, WorkDueDateQueryVariables>(WorkDueDateDocument, options);
        }
export function useWorkDueDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkDueDateQuery, WorkDueDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkDueDateQuery, WorkDueDateQueryVariables>(WorkDueDateDocument, options);
        }
export type WorkDueDateQueryHookResult = ReturnType<typeof useWorkDueDateQuery>;
export type WorkDueDateLazyQueryHookResult = ReturnType<typeof useWorkDueDateLazyQuery>;
export type WorkDueDateSuspenseQueryHookResult = ReturnType<typeof useWorkDueDateSuspenseQuery>;
export type WorkDueDateQueryResult = Apollo.QueryResult<WorkDueDateQuery, WorkDueDateQueryVariables>;
export const WorkDocument = gql`
    query Work($workId: ID!) {
  token
  work(workId: $workId) {
    id
    startDate
    sheet {
      ...Sheet
    }
    group {
      id
      name
    }
    features {
      id
      enableWorkAuthority
    }
    ...WorkSubmitAttempt
    settings {
      ...WorkSettings
    }
    answerBlocks {
      ...AnswerBlock
    }
    latestSave {
      ...Save
    }
    latestSentimentCheck {
      ...SentimentCheck
    }
  }
}
    ${SheetFragmentDoc}
${WorkSubmitAttemptFragmentDoc}
${WorkSettingsFragmentDoc}
${AnswerBlockFragmentDoc}
${SaveFragmentDoc}
${SentimentCheckFragmentDoc}`;

/**
 * __useWorkQuery__
 *
 * To run a query within a React component, call `useWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useWorkQuery(baseOptions: Apollo.QueryHookOptions<WorkQuery, WorkQueryVariables> & ({ variables: WorkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
      }
export function useWorkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkQuery, WorkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
        }
export function useWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkQuery, WorkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkQuery, WorkQueryVariables>(WorkDocument, options);
        }
export type WorkQueryHookResult = ReturnType<typeof useWorkQuery>;
export type WorkLazyQueryHookResult = ReturnType<typeof useWorkLazyQuery>;
export type WorkSuspenseQueryHookResult = ReturnType<typeof useWorkSuspenseQuery>;
export type WorkQueryResult = Apollo.QueryResult<WorkQuery, WorkQueryVariables>;
export const OnWorkSettingsUpdatedDocument = gql`
    subscription onWorkSettingsUpdated($workId: ID!) {
  workSettingsUpdated(workId: $workId) {
    ...WorkSettings
  }
}
    ${WorkSettingsFragmentDoc}`;

/**
 * __useOnWorkSettingsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnWorkSettingsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkSettingsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkSettingsUpdatedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkSettingsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkSettingsUpdatedSubscription, OnWorkSettingsUpdatedSubscriptionVariables> & ({ variables: OnWorkSettingsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkSettingsUpdatedSubscription, OnWorkSettingsUpdatedSubscriptionVariables>(OnWorkSettingsUpdatedDocument, options);
      }
export type OnWorkSettingsUpdatedSubscriptionHookResult = ReturnType<typeof useOnWorkSettingsUpdatedSubscription>;
export type OnWorkSettingsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnWorkSettingsUpdatedSubscription>;
export const OnWorkStartedDocument = gql`
    subscription onWorkStarted($workId: ID!) {
  workStarted(workId: $workId) {
    id
    startDate
    sheet {
      ...Sheet
    }
  }
}
    ${SheetFragmentDoc}`;

/**
 * __useOnWorkStartedSubscription__
 *
 * To run a query within a React component, call `useOnWorkStartedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkStartedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkStartedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkStartedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkStartedSubscription, OnWorkStartedSubscriptionVariables> & ({ variables: OnWorkStartedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkStartedSubscription, OnWorkStartedSubscriptionVariables>(OnWorkStartedDocument, options);
      }
export type OnWorkStartedSubscriptionHookResult = ReturnType<typeof useOnWorkStartedSubscription>;
export type OnWorkStartedSubscriptionResult = Apollo.SubscriptionResult<OnWorkStartedSubscription>;
export const OnWorkSubmittedDocument = gql`
    subscription onWorkSubmitted($workId: ID!) {
  workSubmitted(workId: $workId) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}`;

/**
 * __useOnWorkSubmittedSubscription__
 *
 * To run a query within a React component, call `useOnWorkSubmittedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkSubmittedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkSubmittedSubscription({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useOnWorkSubmittedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkSubmittedSubscription, OnWorkSubmittedSubscriptionVariables> & ({ variables: OnWorkSubmittedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkSubmittedSubscription, OnWorkSubmittedSubscriptionVariables>(OnWorkSubmittedDocument, options);
      }
export type OnWorkSubmittedSubscriptionHookResult = ReturnType<typeof useOnWorkSubmittedSubscription>;
export type OnWorkSubmittedSubscriptionResult = Apollo.SubscriptionResult<OnWorkSubmittedSubscription>;